//------------------------------------------------------------------------------------------

export const winorLose = [
    52,
    63,
    286,
    464,

    202,
    203,
    204,
    205,
    465,
    206,
    445,
    446,
    451,
    452,


    226,
    235,
    411,
    412,
]


//------------------------------------------------------------------------------------------

export const MainMarketData = [
    1,	    // 승무패	3	{"Id":{"low":-1671467999,"high":40824458,"unsigned":false},"Name":"1","Line":null,"BaseLine":null,"Status":1,"StartPrice":"2.8","Price":"2.99","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:43:31.317Z","ParticipantId":null}
    52,	    // 승패	2	{"Id":{"low":1005511201,"high":13798009,"unsigned":false},"Name":"1","Line":null,"BaseLine":null,"Status":1,"StartPrice":"1.909","Price":"2.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:08:32.857Z","ParticipantId":null}
    2,	    // 오버언더	26	{"Id":{"low":-419037663,"high":19580342,"unsigned":false},"Name":"Over","Line":"2.5","BaseLine":"2.5","Status":1,"StartPrice":"1.668","Price":"1.71","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:43:31.317Z","ParticipantId":null}
    3,	    // 핸디캡	34	{"Id":{"low":-2109679583,"high":14362612,"unsigned":false},"Name":"1","Line":"1.75 (0-0)","BaseLine":"1.75 (0-0)","Status":1,"StartPrice":"1.112","Price":"1.122","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:43:31.317Z","ParticipantId":null}
    // 4,	    // 전반전 및 풀타임	
    5,	    // 홀짝	2	{"Id":171056844310507040,"Name":"Even","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"3.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:09:32.328Z","ParticipantId":null}
    // 6,	    // 정확한스코어	4	{"Id":163598667610507040,"Name":"2-0","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:58:39.202Z","ParticipantId":null}
    7,	    // 더블찬스	3	{"Id":115605479010529120,"Name":"1X","Line":null,"BaseLine":null,"Status":1,"StartPrice":"1.0","Price":"1.184","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:38:06.650Z","ParticipantId":null}
    // 9,	    // 정확한스코어 [1 피리어드]	14	{"Id":52135507510507020,"Name":"0-6","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"21.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:28:23.753Z","ParticipantId":null}
    // 11,	    // 코너 합계	
    // 12,	    // 파울 합계	
    // 13,	    // 유럽 핸디캡	3	{"Id":158830754310529120,"Name":"2","Line":"1:0","BaseLine":"0:1","Status":2,"StartPrice":"1.0","Price":"2.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:52:07.711Z","ParticipantId":null}
    16,	    // 첫 득점팀	
    // 17,	    // 양팀 모두득점	2	{"Id":130851972410529120,"Name":"No","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"2.75","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:52:07.711Z","ParticipantId":null}
    19,	    // 첫 카드	
    21,	    // 오버언더 전반전	14	{"Id":{"low":-1150875615,"high":37465254,"unsigned":false},"Name":"Over","Line":"2.0","BaseLine":"2.0","Status":1,"StartPrice":"4.64","Price":"4.74","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:43:31.317Z","ParticipantId":null}
    // 22,	    // 원정팀 득점	
    // 23,	    // 홈팀 득점	
    // 25,	    // 더블찬스 [전반전]	
    28,	    // 오버언더_연장포함	18	{"Id":5814717310516551,"Name":"Under","Line":"9.5","BaseLine":"9.5","Status":1,"StartPrice":"1.15","Price":"1.15","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T05:54:42.295Z","ParticipantId":null}
    29,	    // 언더오버 - 라운드	
    30,	    // 언더오버 - 코너 [홈팀]	
    31,	    // 언더오버 - 코너 [원정팀]	
    34,	    // 홈팀 득점 [전반후반]	
    35,	    // 원정팀 득점 [전반후반]	
    // 41,	    // 승무패 전반전	3	{"Id":{"low":1419017249,"high":32703296,"unsigned":false},"Name":"2","Line":null,"BaseLine":null,"Status":1,"StartPrice":"2.8","Price":"2.94","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:43:31.317Z","ParticipantId":null}
    // 42,	    // 승무패 [2 피리어드]	3	{"Id":186168072710517760,"Name":"X","Line":null,"BaseLine":null,"Status":3,"StartPrice":"1.0","Price":"13.3","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:48.352Z","ParticipantId":null}
    // 43,	    // 승무패 [3 피리어드]	3	{"Id":175295516610512930,"Name":"1","Line":null,"BaseLine":null,"Status":3,"StartPrice":"1.0","Price":"1.4","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":2,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:02:13.263Z","ParticipantId":null}
    // 44,	    // 승무패 [4 피리어드]	3	{"Id":55417015610512936,"Name":"2","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"3.8","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:12:37.609Z","ParticipantId":null}
    // 45,	    // 언더오버 [2 피리어드]	12	{"Id":54648981010507020,"Name":"Over","Line":"8.5","BaseLine":"8.5","Status":2,"StartPrice":"1.0","Price":"1.01","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:12:11.729Z","ParticipantId":null}
    // 46,	    // 언더오버 [3 피리어드]	12	{"Id":23938273810507028,"Name":"Under","Line":"10.5","BaseLine":"10.5","Status":3,"StartPrice":"1.0","Price":"3.4","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:34.361Z","ParticipantId":null}
    // 47,	    // 언더오버 [4 피리어드]	24	{"Id":82031954010517780,"Name":"Over","Line":"33.5","BaseLine":"33.5","Status":1,"StartPrice":"1.0","Price":"2.464","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:16:17.188Z","ParticipantId":null}
    // 48,	    // 언더오버 [5 피리어드]	
    // 49,	    // 승무패 [5 피리어드]	
    50,	    // 승무패 [연장포함]	
    51,	    // 홀짝 [연장포함]	2	{"Id":7547284410517773,"Name":"Odd","Line":null,"BaseLine":null,"Status":1,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:26:05.116Z","ParticipantId":null}
    // 53,	    // 핸디캡 [전반전]	40	{"Id":12913579210517772,"Name":"1","Line":"9.5 (0-0)","BaseLine":"9.5 (0-0)","Status":3,"StartPrice":"1.0","Price":"3.58","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:48.352Z","ParticipantId":null}
    // 55,	    // 첫득점팀 [1 피리어드]	
    // 56,	    // 마지막득점팀	
    // 57,	    // 마지막득점팀 [전반전]	
    59,	    // 다음득점	3	{"Id":99850833010529120,"Name":"1","Line":"1.0","BaseLine":"1.0","Status":1,"StartPrice":"1.0","Price":"1.765","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:38:14.646Z","ParticipantId":null}
    // 61,	    // 유럽 핸디캡 [전반전]	3	{"Id":189818325010529120,"Name":"1","Line":"0:1","BaseLine":"0:1","Status":2,"StartPrice":"1.0","Price":"4.5","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:52:07.711Z","ParticipantId":null}
    // 62,	    // 홀짝 [전반전]	2	{"Id":111599954910517780,"Name":"Even","Line":null,"BaseLine":null,"Status":3,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:48.352Z","ParticipantId":null}
    // 63,	    // 승패 [전반전]	2	{"Id":51993559610512936,"Name":"1","Line":null,"BaseLine":null,"Status":3,"StartPrice":"1.0","Price":"1.007","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":2,"ProviderBetId":null,"LastUpdate":"2023-04-26T01:21:43.261Z","ParticipantId":null}
    // 64,	    // 핸디캡 전반전	18	{"Id":{"low":2002385697,"high":41637933,"unsigned":false},"Name":"2","Line":"1.5 (0-0)","BaseLine":"-1.5 (0-0)","Status":1,"StartPrice":"1.035","Price":"1.03","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:43:31.317Z","ParticipantId":null}
    // 65,	    // 핸디캡 [2 피리어드]	6	{"Id":167006010210507040,"Name":"2","Line":"1.5 (0-0)","BaseLine":"-1.5 (0-0)","Status":2,"StartPrice":"1.0","Price":"1.8","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:24:52.719Z","ParticipantId":null}
    // 66,	    // 핸디캡 [3 피리어드]	8	{"Id":1811514110507028,"Name":"2","Line":"1.5 (0-0)","BaseLine":"-1.5 (0-0)","Status":2,"StartPrice":"1.0","Price":"1.064","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:09:38.222Z","ParticipantId":null}
    // 67,	    // 핸디캡 [4 피리어드]	16	{"Id":13422452810517772,"Name":"2","Line":"-2.5 (0-0)","BaseLine":"2.5 (0-0)","Status":1,"StartPrice":"1.0","Price":"2.005","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:16:17.188Z","ParticipantId":null}
    // 68,	    // 핸디캡 [5 피리어드]	
    69,	    // 연장전 발생	2	{"Id":202657557110512930,"Name":"No","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.004","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T01:46:15.068Z","ParticipantId":null}
    // 70,	    // 최고득점 피리어드	
    71,	    // 최고득점 하프	3	{"Id":59075605510512936,"Name":"1st Half","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"2.7","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:11:05.267Z","ParticipantId":null}
    // 72,	    // 홀짝 [1 피리어드]	2	{"Id":12863882110517772,"Name":"Odd","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:42:39.161Z","ParticipantId":null}
    // 73,	    // 홀짝 [2 피리어드]	2	{"Id":141408646210517780,"Name":"Even","Line":null,"BaseLine":null,"Status":3,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:48.352Z","ParticipantId":null}
    // 74,	    // 홀짝 [3 피리어드]	2	{"Id":12553919810517772,"Name":"Odd","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:16:21.212Z","ParticipantId":null}
    // 75,	    // 홀짝 [4 피리어드]	2	{"Id":163916956110517760,"Name":"Odd","Line":null,"BaseLine":null,"Status":1,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:26:05.116Z","ParticipantId":null}
    // 76,	    // 홀짝 [5 피리어드]	
    // 77,	    // 언더오버 [전반전]	26	{"Id":113663409810517780,"Name":"Over","Line":"72.5","BaseLine":"72.5","Status":3,"StartPrice":"1.0","Price":"3.11","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":2,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:48.352Z","ParticipantId":null}
    78,	    // 식스 최다 득점	
    79,	    // 패널티 발생	
    80,	    // 첫 코너	
    81,	    // 마지막 코너	
    82,	    // 레드카드 발생	
    83,	    // 득점 미발생	
    84,	    // 전후반모두 승리	
    85,	    // 후반 역전승	
    86,	    // 무실점 승리	
    88,	    // 최종 승팀	
    89,	    // 	
    // 90,	    // 5세트 발생	
    91,	    // 첫득점 발생 하프	
    // 92,	    // 첫 득점팀 [후반전]	
    95,	    // 코너 - 핸디캡  	
    96,	    // 원정팀 무실점승리	
    97,	    // 홈팀 무실점승리	
    98,	    // 홈팀 무득점	
    99,	    // 원정팀 무득점	
    // 100,	    // 정확한스코어 [2 피리어드]	14	{"Id":109394050210507020,"Name":"3-6","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:20:10.125Z","ParticipantId":null}
    101,	    // 언더오버 <홈팀>	16	{"Id":72726783710507020,"Name":"Under","Line":"12.5","BaseLine":"12.5","Status":2,"StartPrice":"1.0","Price":"2.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:40:36.884Z","ParticipantId":null}
    102,	    // 언더오버 <원정팀>	8	{"Id":138006790010507020,"Name":"Over","Line":"14.5","BaseLine":"14.5","Status":3,"StartPrice":"1.0","Price":"1.727","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":2,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:34.361Z","ParticipantId":null}
    104,	    // 전후반모두 승리 <원정팀>	
    105,	    // 전후반모두 승리 <홈팀>	
    106,	    // 후반 역전승 <홈팀>	
    107,	    // 후반 역전승 <원정팀>	
    108,	    // 홈팀 패널티 득점	
    109,	    // 원정팀 패널티 득점	
    110,	    // 전반 또는 후반승 <원정팀>	
    111,	    // 전반 또는 후반승 <홈팀>	
    // 113,	    // 양팀 모두득점 [전반전]	2	{"Id":170335094510529120,"Name":"Yes","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"2.75","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:52:07.711Z","ParticipantId":null}
    114,	    // 어떤 선수든 최소 2골 득점	
    117,	    // 어떤 선수든 최소 3골 득점	
    122,	    // 첫득점팀이 승리	
    123,	    // 원정팀 첫득점 후 승리	
    124,	    // 홈팀 첫득점 후 승리	
    125,	    // 첫 서브	
    128,	    // 득점수	
    // 129,	    // 언더오버 - 코너 [전반전]	
    132,	    // 유효슈팅 언더/오버	
    133,	    // 슈팅 합계 언더/오버	
    // 134,	    // 득점수 [전반전]	
    135,	    // 언더오버 - 프리킥	
    136,	    // 언더오버 - 오프사이드	
    137,	    // [승X] 무패	
    138,	    // 승무 [패X]	
    139,	    // 첫득점 발생하프 <홈팀>	
    140,	    // 첫득점 발생하프 <원정팀>	
    143,	    // 더많은득점 발생하프 <홈팀>	
    144,	    // 더많은득점 발생하프 <원정팀>	
    // 145,	    // 홈팀 득점수 [전반전]	
    // 146,	    // 원정팀 득점수 [전반전]	
    147,	    // 원정팀 득점수 [후반전]	
    148,	    // 홈팀 득점수 [후반전]	
    // 149,	    // 홈팀 득점수	
    // 150,	    // 원정팀 득점수	
    151,	    // 더블찬스 [후반전]	
    // 153,	    // 언더오버 [1 피리어드] <홈팀>	8	{"Id":192019580710507040,"Name":"Under","Line":"4.5","BaseLine":"4.5","Status":2,"StartPrice":"1.0","Price":"1.755","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:48:25.582Z","ParticipantId":null}
    // 154,	    // 언더오버 [2 피리어드] <홈팀>	6	{"Id":138954876810507020,"Name":"Over","Line":"5.5","BaseLine":"5.5","Status":2,"StartPrice":"1.0","Price":"1.185","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:25:04.387Z","ParticipantId":null}
    // 155,	    // 언더오버 [1 피리어드] <원정팀>	4	{"Id":9978145210507028,"Name":"Over","Line":"6.5","BaseLine":"6.5","Status":2,"StartPrice":"1.0","Price":"9.99","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:58:58.359Z","ParticipantId":null}
    // 156,	    // 언더오버 [2 피리어드] <원정팀>	6	{"Id":52893392410507020,"Name":"Under","Line":"6.5","BaseLine":"6.5","Status":2,"StartPrice":"1.0","Price":"1.47","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:23:49.348Z","ParticipantId":null}
    157,	    // 언더오버 - 옐로우카드 [전반전]	
    158,	    // 언더오버 - 옐로우카드	
    159,	    // 타이 브레이크 발생	
    160,	    // 레이스 승자	
    161,	    // 승무패 [10분]	
    162,	    // 언더오버 [10분]	
    163,	    // 득점수 [후반전]	
    // 164,	    // 타이 브레이크 발생 [1세트]	
    // 165,	    // 오버언더 세트	
    166,	    // 언더오버 - 게임	28	{"Id":190139174610507040,"Name":"Over","Line":"17.5","BaseLine":"17.5","Status":2,"StartPrice":"1.0","Price":"1.585","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:43:55.418Z","ParticipantId":null}
    168,	    // 자살골 발생	
    169,	    // 전후반 모두득점	
    170,	    // 홀짝 - 코너	
    171,	    // 어느 하프든 승리	
    // 175,	    // 타이 브레이크 발생 [2세트]	
    // 176,	    // 타이 브레이크 발생 [3세트]	
    // 177,	    // 타이 브레이크 발생 [4세트]	
    // 178,	    // 타이 브레이크 발생 [5세트]	
    180,	    // 언더오버 - 드로잉	
    181,	    // 언더오버 - 옐로우카드 <홈팀>	
    182,	    // 언더오버 - 옐로우카드 [전반전] <홈팀>	
    183,	    // 언더오버 - 옐로우카드 [후반전] <홈팀>	
    184,	    // 언더오버 - 옐로우카드 <원정팀>	
    185,	    // 언더오버 - 옐로우카드 [전반전] <원정팀>	
    186,	    // 언더오버 - 옐로우카드 [후반전] <원정팀>	
    187,	    // 언더오버 - 옐로우카드 [후반전]	
    188,	    // 첫 옐로우카드	
    189,	    // 첫 레드카드	
    190,	    // 첫 옐로우카드 [후반전]	
    191,	    // Will Any Player Score a Hat-Trick?	
    192,	    // 전후반 모두 득점발생	
    // 194,	    // 홈팀 무득점 [1 피리어드]	
    // 195,	    // 홈팀 무득점 [2 피리어드]	
    // 196,	    // 원정팀 무득점 [1 피리어드]	
    // 197,	    // 원정팀 무득점 [2피리어드]	
    198,	    // 홀짝 <홈팀>	
    199,	    // 홀짝 <원정팀>	
    200,	    // 첫득점팀이 승리	
    201,	    // 핸디캡 - 게임	22	{"Id":181953278310507040,"Name":"1","Line":"3.5","BaseLine":"3.5","Status":2,"StartPrice":"1.0","Price":"1.395","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:25:08.799Z","ParticipantId":null}
    // 202,	    // 승패 1세트	2	{"Id":{"low":874367728,"high":6172758,"unsigned":false},"Name":"1","Line":null,"BaseLine":null,"Status":1,"StartPrice":"1.4","Price":"1.4","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T04:22:21.296Z","ParticipantId":null}
    // 203,	    // 승패 [2 Peroid]	2	{"Id":207898845910507040,"Name":"2","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"34.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:26:22.446Z","ParticipantId":null}
    // 204,	    // 승패 [3 피리어드]	2	{"Id":141031230810507020,"Name":"2","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.565","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:26:00.253Z","ParticipantId":null}
    // 205,	    // 승패 [4 피리어드]	2	{"Id":27344948210512936,"Name":"2","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"3.75","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:12:37.609Z","ParticipantId":null}
    // 206,	    // 승패 [5 피리어드]	
    207,	    // 승무패  [15분]	
    208,	    // 승무패  [30분]	
    210,	    // 코너합계  [후반전]	
    // 211,	    // 양팀 모두득점 [후반전]	
    // 212,	    // 양팀 모두득점 [전반후반]	
    // 213,	    // 양팀모두동점 [전반후반 모두]	
    214,	    // 언더오버 - 카드	
    // 215,	    // 원정팀 득점 [전반전]	
    // 216,	    // 원정팀 득점 [후반전]	
    // 217,	    // 정확한스코어 [3 피리어드]	14	{"Id":142132694810507020,"Name":"6-2","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"9.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:57:59.144Z","ParticipantId":null}
    218,	    // 홈팀 득점 [전반전]	
    // 219,	    // 홈팀 득점 [후반전]	
    220,	    // 언더오버 [연장포함] <원정팀>	30	{"Id":42834577010517780,"Name":"Over","Line":"78.5","BaseLine":"78.5","Status":1,"StartPrice":"1.0","Price":"2.52","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:16:15.434Z","ParticipantId":null}
    221,	    // 언더오버 [연장포함[ <홈팀>	44	{"Id":171637180410517760,"Name":"Over","Line":"71.5","BaseLine":"71.5","Status":2,"StartPrice":"1.0","Price":"3.264","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:37:55.056Z","ParticipantId":null}
    // 222,	    // 언더오버 [3 피리어드] <원정팀>	8	{"Id":168712774410507040,"Name":"Under","Line":"5.5","BaseLine":"5.5","Status":3,"StartPrice":"1.0","Price":"2.03","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:34.361Z","ParticipantId":null}
    // 223,	    // 언더오버 [3 피리어드] <홈팀>	8	{"Id":200849253310507040,"Name":"Under","Line":"3.5","BaseLine":"3.5","Status":2,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:34:54.867Z","ParticipantId":null}
    // 224,	    // 더블찬스 [3 피리어드]	
    // 225,	    // 더블찬스 [4 피리어드]	
    226,	    // 승패	2	{"Id":{"low":1316040263,"high":9411403,"unsigned":false},"Name":"1","Line":null,"BaseLine":null,"Status":1,"StartPrice":"1.9","Price":"1.6","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:57:32.000Z","ParticipantId":null}
    227,	    // 레이스 승자 2 자리	
    228,	    // 레이스 승자 3 자리	
    229,	    // 레이스 승자 4 자리	
    233,	    // 우승 대 영점 아님	
    // 235,	    // 승패 5이닝	3	{"Id":{"low":204088972,"high":48021758,"unsigned":false},"Name":"X","Line":null,"BaseLine":null,"Status":1,"StartPrice":"6.1","Price":"6.4","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:40:52.937Z","ParticipantId":null}
    // 236,	    // 오버언더 5이닝	20	{"Id":{"low":2092297771,"high":37937157,"unsigned":false},"Name":"Under","Line":"1.5","BaseLine":"1.5","Status":1,"StartPrice":"6.75","Price":"7.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T00:36:37.928Z","ParticipantId":null}
    // 237,	    // 득점발생 [1이닝]	
    238,	    // 남은 매치	
    239,	    // 골 범위	
    240,	    // 홀짝 1차 오버 <홈팀>	
    241,	    // 홀짝 1차 오버 <원정팀>	
    // 242,	    // 홀짝 [1 피리어드] <홈팀>	
    // 243,	    // 홀짝 [1 피리어드] <원정팀>	
    244,	    // 최고 오프닝 파트너십	
    245,	    // 득점무득점	
    247,	    // 남은 1차 하프	
    250,	    // 핸디캡 - 코너 [전반전]	
    254,	    // 카드 범위	
    255,	    // 1차 카드 시간	
    256,	    // 홈팀 - 카드 범위	
    257,	    // 원정팀 - 카드 범위	
    258,	    // 코너 범위	
    259,	    // 코너가 많은 팀	
    260,	    // 코너가 많은 팀 [전반전]	
    261,	    // 코너가 많은 팀 [후반전]	
    262,	    // 홈팀 - 코너 범위	
    263,	    // 원정팀 - 코너 범위	
    264,	    // 홈팀 - 코너 범위 1차 하프	
    265,	    // 원정팀 - 코너 범위 1차 하프	
    266,	    // 홈팀 - 코너 범위 2차 하프	
    267,	    // 원정팀 - 코너 범위 2차 하프	
    269,	    // 멀티 골	
    271,	    // 찬스 믹스	
    274,	    // 완전한 승자	
    275,	    // 골 범위 2차 피리어드	
    278,	    // 골 범위 홈팀	
    279,	    // 골 범위 원정팀	
    281,	    // 핸디캡 5이닝	2	{"Id":{"low":-740717940,"high":21204554,"unsigned":false},"Name":"1","Line":"0.0 (0-0)","BaseLine":"0.0 (0-0)","Status":1,"StartPrice":"1.91","Price":"1.91","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:40:52.937Z","ParticipantId":null}
    282,	    // 승무패 [전반전]	3	{"Id":143448908810517780,"Name":"X","Line":null,"BaseLine":null,"Status":3,"StartPrice":"1.0","Price":"15.4","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:48.352Z","ParticipantId":null}
    // 283,	    // 핸디캡 [후반전]	
    // 284,	    // 승무패 [후반전]	3	{"Id":134676060910517780,"Name":"2","Line":null,"BaseLine":null,"Status":1,"StartPrice":"1.0","Price":"1.33","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:16:15.434Z","ParticipantId":null}
    // 285,	    // 홀짝 [후반전]	2	{"Id":190790932910517760,"Name":"Odd","Line":null,"BaseLine":null,"Status":1,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:26:05.116Z","ParticipantId":null}
    // 286,	    // 승패 [후반전]	
    // 287,	    // 언더오버 [4 피리어드] <홈팀>	18	{"Id":40551964510517780,"Name":"Over","Line":"17.5","BaseLine":"17.5","Status":1,"StartPrice":"1.0","Price":"3.264","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:16:17.188Z","ParticipantId":null}
    // 288,	    // 언더오버 [4 피리어드] <원정팀>	14	{"Id":187735405610517760,"Name":"Under","Line":"20.5","BaseLine":"20.5","Status":2,"StartPrice":"1.0","Price":"1.264","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:13:03.969Z","ParticipantId":null}
    // 289,	    // 홀짝 [2 피리어드] <홈팀>	
    // 290,	    // 홀짝 [3 피리어드] <홈팀>	
    // 291,	    // 홀짝 [4 피리어드] <홈팀>	
    // 292,	    // 홀짝 [2 피리어드] <원정팀>	
    // 293,	    // 홀짝 [3 피리어드] <원정팀>	
    // 294,	    // 홀짝 [4 피리어드] <원정팀>	
    297,	    // SP	
    299,	    // 포인트 승자	492	{"Id":11091886910507028,"Name":"1","Line":"3/1/4","BaseLine":"3/1/4","Status":2,"StartPrice":"1.0","Price":"2.625","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:29:05.094Z","ParticipantId":null}
    300,	    // 게임 승자	64	{"Id":130031015210507020,"Name":"1","Line":"3/9","BaseLine":"3/9","Status":2,"StartPrice":"1.0","Price":"21.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:02:26.872Z","ParticipantId":null}
    301,	    // Goal Before	
    302,	    // Goal After	
    304,	    // Team With Highest Scoring Period	
    305,	    // 코너 - 정확한 언더오버	
    306,	    // 첫득점 및 마지막득점	
    307,	    // 유럽핸디캡 - 게임	
    308,	    // 언더오버 - 높은득점 피리어드	
    309,	    // 언더오버 - 낮은득점 피리어드 	
    310,	    // 시리즈 승자	
    315,	    // 그룹 승자	
    // 317,	    // 정확한 언더오버 [1 피리어드]	21	{"Id":13810279610512936,"Name":"Over","Line":"44.0","BaseLine":"44.0","Status":3,"StartPrice":"1.0","Price":"2.5","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-26T00:48:41.252Z","ParticipantId":null}
    // 318,	    // 정확한 언더오버 [2 피리어드]	3	{"Id":204373654810512930,"Name":"Exactly","Line":"40.0","BaseLine":"40.0","Status":3,"StartPrice":"1.0","Price":"13.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-26T01:21:43.261Z","ParticipantId":null}
    // 319,	    // 정확한 언더오버 [3 피리어드]	30	{"Id":73867311410512940,"Name":"Over","Line":"45.0","BaseLine":"45.0","Status":3,"StartPrice":"1.0","Price":"2.25","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:02:13.263Z","ParticipantId":null}
    // 320,	    // 정확한 언더오버 [4 피리어드]	3	{"Id":141854680410512940,"Name":"Over","Line":"40.0","BaseLine":"40.0","Status":2,"StartPrice":"1.0","Price":"1.87","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:03:12.799Z","ParticipantId":null}
    // 321,	    // 정확한 언더오버 [5 피리어드]	
    322,	    // 정확한 언더오버	12	{"Id":168032600810529120,"Name":"Exactly","Line":"2.0","BaseLine":"2.0","Status":1,"StartPrice":"1.0","Price":"3.45","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:38:06.650Z","ParticipantId":null}
    329,	    // 1st Period Race To	8	{"Id":44166278510507020,"Name":"2","Line":"3.0","BaseLine":"3.0","Status":2,"StartPrice":"1.0","Price":"1.03","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:39:23.554Z","ParticipantId":null}
    330,	    // 2nd Period Race To	8	{"Id":24788335810507028,"Name":"1","Line":"3.0","BaseLine":"3.0","Status":2,"StartPrice":"1.0","Price":"1.005","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:11:52.529Z","ParticipantId":null}
    331,	    // 3rd Period Race To	8	{"Id":44832626110507020,"Name":"2","Line":"4.0","BaseLine":"4.0","Status":2,"StartPrice":"1.0","Price":"6.5","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:53:27.979Z","ParticipantId":null}
    332,	    // 4th Period Race To	9	{"Id":113213317310512940,"Name":"2","Line":"20.0","BaseLine":"20.0","Status":2,"StartPrice":"1.0","Price":"5.25","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:12:37.609Z","ParticipantId":null}
    333,	    // 5th Period Race To	
    337,	    // 언더오버 [후반전]	
    338,	    // 다음득점 [1 피리어드]	
    339,	    // 다음득점 [2 피리어드]	
    340,	    // 다음득점 [3 피리어드]	
    341,	    // Race To	
    342,	    // 핸디캡_연장포함	4	{"Id":{"low":1731653191,"high":11660535,"unsigned":false},"Name":"1","Line":"-1.5 (0-0)","BaseLine":"-1.5 (0-0)","Status":1,"StartPrice":"2.95","Price":"2.5","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:57:32.000Z","ParticipantId":null}
    343,	    // Game Range 1st Period	
    344,	    // Game Range 2nd Period	
    345,	    // Game Range 3rd Period	
    346,	    // Game Range 4th Period	
    347,	    // Game Range 5th Period	
    348,	    // 6th Period Winner	
    349,	    // 7th Period Winner	
    // 350,	    // 홀짝 [6 피리어드]	
    // 351,	    // 홀짝 [7 피리어드]	
    // 352,	    // 언더오버 [6 피리어드]	
    // 353,	    // 언더오버 [7 피리어드]	
    354,	    // 언더오버 [전반전] <홈팀>	28	{"Id":52029666110517780,"Name":"Over","Line":"34.5","BaseLine":"34.5","Status":3,"StartPrice":"1.0","Price":"3.015","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:48.352Z","ParticipantId":null}
    355,	    // 언더오버 [전반전] <원정팀>	28	{"Id":126561374410517780,"Name":"Under","Line":"32.5","BaseLine":"32.5","Status":3,"StartPrice":"1.0","Price":"2.496","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:48.352Z","ParticipantId":null}
    356,	    // Method Of Dismissal 6-Way	
    357,	    // Dismissal Method	
    358,	    // Runs at fall of Wicket Home Team 2-way	
    359,	    // Runs at fall of Wicket Away Team 2-way	
    360,	    // Runs at fall of Wicket Home Team 3-way	
    361,	    // Runs at fall of Wicket Away Team 3-way	
    362,	    // Over at fall of Wicket Home Team 2-way	
    363,	    // Over at fall of Wicket Away Team 2-way	
    364,	    // Over at fall of Wicket Home Team 3-way	
    365,	    // Over at fall of Wicket Away Team 3-way	
    366,	    // Total Runs Odd/Even in Over - Home Team	
    367,	    // Total Runs Odd/Even in Over - Away Team	
    368,	    // Runs Odd/Even in Over - Home Team	
    369,	    // Runs Odd/Even in Over - Away Team	
    370,	    // Total Runs in Over - Home Team	
    371,	    // Total Runs in Over - Away Team	
    372,	    // Wicket in Over - Home Team	
    373,	    // Wicket in Over - Away Team	
    374,	    // Runs Off 1st Delivery - Home Team	
    375,	    // Runs Off 2nd Delivery - Home Team	
    376,	    // Runs Off 3rd Delivery - Home Team	
    377,	    // Runs Off 4th Delivery - Home Team	
    378,	    // Runs Off 5th Delivery - Home Team	
    379,	    // Runs Off 6th Delivery - Home Team	
    380,	    // Runs Off 1st Delivery - Away Team	
    381,	    // Runs Off 2nd Delivery - Away Team	
    382,	    // Runs Off 3rd Delivery - Away Team	
    383,	    // Runs Off 4th Delivery - Away Team	
    384,	    // Runs Off 5th Delivery - Away Team	
    385,	    // Runs Off 6th Delivery - Away Team	
    386,	    // 유럽핸디캡 [연장포함]	
    387,	    // 홀짝 [연장포함] <홈팀>	2	{"Id":71082138610509440,"Name":"Even","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:00:28.028Z","ParticipantId":null}
    388,	    // 홀짝 [연장포함] <원정팀>	2	{"Id":49990999610509440,"Name":"Odd","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:00:28.028Z","ParticipantId":null}
    390,	    // 전반전 및 풀타임 [연장포함]	6	{"Id":162524683410512930,"Name":"1/1","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.025","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T01:16:29.704Z","ParticipantId":null}
    391,	    // 다음득점 [연장전]	
    392,	    // Home Team Penalty Shootout	
    393,	    // Away Team Penalty Shootout	
    394,	    // 정확한스코어 [4 피리어드]	16	{"Id":{"low":409294872,"high":10499902,"unsigned":false},"Name":"25-22","Line":null,"BaseLine":null,"Status":3,"StartPrice":"1.0","Price":"18.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-22T06:49:50.765Z","ParticipantId":null}
    395,	    // 정확한스코어 [5 피리어드]	
    396,	    // Total Runs in first Overs - Home Team	
    397,	    // Total Runs in first Overs - Away Team	
    398,	    // Odd/Even Cards	
    399,	    // Half With Most Corners	
    400,	    // Odd/Even Cards 1st Half	
    401,	    // 언더오버 - 코너 [전반전] <홈팀>	
    402,	    // 언더오버 - 코너 [전반전] <원정팀>	
    403,	    // 언더오버 - 코너 [후반전]	
    404,	    // 언더오버 - 코너 [후반전] <홈팀>	
    405,	    // 언더오버 - 코너 [후반전] <원정팀>	
    406,	    // 홀짝 - 코너 [전반전]	
    407,	    // Asian Handicap Cards	
    408,	    // Asian Handicap Cards 1st Half	
    409,	    // 승무패 및 코너	
    410,	    // 승무패 및 코너 [전반전]	
    411,	    // 승패 및 코너	
    412,	    // 승패 및 코너 [전반전]	
    414,	    // Under/Over Cards 1st Half	
    415,	    // 승무패 및 양팀모두득점	6	{"Id":115806137210529120,"Name":"Both Teams Not To Score","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"21.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:52:07.711Z","ParticipantId":null}
    416,	    // 언더오버 [연장전]	
    417,	    // 언더오버 [연장전반전]	
    418,	    // 언더오버 [연장후반전]	
    419,	    // 승무패 [연장전]	
    420,	    // Remaining Match - Extra Time	
    421,	    // 다음득점 [연장전반전]	
    423,	    // Fast Market - Shots off Target	
    427,	    // 승무패 및 언더오버	
    428,	    // Multiple Correct Score	
    430,	    // 정확한 언더오버 [전반전]	
    // 431,	    // 정확한 언더오버 [후반전]	3	{"Id":94013643310512940,"Name":"Under","Line":"85.0","BaseLine":"85.0","Status":2,"StartPrice":"1.0","Price":"1.87","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T01:38:21.339Z","ParticipantId":null}
    433,	    // 유럽핸디캡 - 코너	
    434,	    // 8th Period Winner	
    435,	    // 9th Period Winner	
    // 436,	    // 언더오버 [8 피리어드]	
    // 437,	    // 언더오버 [9 피리어드]	
    438,	    // Total Runs Odd/Even in Over	
    439,	    // Total Runs in Over	
    440,	    // Points Scored	
    441,	    // Points Scored - 1st Period	
    442,	    // Morning Line	
    443,	    // 6th Period Race To	
    444,	    // 7th Period Race To	
    // 445,	    // 승패 [6 피리어드]	
    // 446,	    // 승패 [7 피리어드]	
    // 447,	    // 핸디캡 [6 피리어드]	
    // 448,	    // 핸디캡 [7 피리어드]	
    // 449,	    // 핸디캡 [8 피리어드]	
    // 450,	    // 핸디캡 [9 피리어드]	
    // 451,	    // 승패 [8 피리어드]	
    // 452,	    // 승패 [9 피리어드]	
    453,	    // First Score Method	
    454,	    // First Score Method - Home Team	
    455,	    // First Score Method - Away Team	
    // 456,	    // 더블찬스 [1 피리어드]	3	{"Id":2395254710529119,"Name":"1X","Line":null,"BaseLine":null,"Status":3,"StartPrice":"1.0","Price":"1.03","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":2,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:37:42.267Z","ParticipantId":null}
    // 457,	    // 더블찬스 [2 피리어드]	
    // 459,	    // 홈팀 전체쿼터 득점	
    // 460,	    // 원정팀 전체쿼터 득점	
    461,	    // Winning Margin	
    462,	    // Top 5 Finish	
    463,	    // Top 10 Winner	
    464,	    // 승패 [후반 및 연장포함] 	2	{"Id":114601831010512940,"Name":"2","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"4.5","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:12:37.609Z","ParticipantId":null}
    465,	    // 승패 [4 피리어드 및 연장포함]	
    466,	    // 언더오버 [4 피리어드 및 연장포함]	
    467,	    // 핸디캡 [4 피리어드 및 연장포함]	
    468,	    // 핸디캡 [후반전 및 연장포함]	28	{"Id":98795464310517780,"Name":"1","Line":"10.5 (0-0)","BaseLine":"10.5 (0-0)","Status":2,"StartPrice":"1.0","Price":"1.375","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:50.710Z","ParticipantId":null}
    469,	    // 언더오버 [후반전 및 연장포함]	10	{"Id":111183019810512940,"Name":"Over","Line":"87.5","BaseLine":"87.5","Status":2,"StartPrice":"1.0","Price":"2.25","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T01:38:21.339Z","ParticipantId":null}
    472,	    // Will Game Go to Shootout?	
    // 475,	    // Under/Over Runs In Over - Home Team 1st Inning	
    // 476,	    // Under/Over Runs In Over - Away Team 1st Inning	
    // 477,	    // Under/Over Runs In Over - Home Team 2nd Inning	
    // 478,	    // Under/Over Runs In Over - Away Team 2nd Inning	
    // 479,	    // Odd/Even Runs In Over - Home Team 1st Inning	
    // 480,	    // Odd/Even Runs In Over - Away Team 1st Inning	
    // 481,	    // Odd/Even Runs In Over - Home Team 2nd Inning	
    // 482,	    // Odd/Even Runs In Over - Away Team 2nd Inning	
    // 483,	    // Will Home Team Get A Wicket in Over - 1st Inning?	
    // 484,	    // Will Away Team Get A Wicket in Over - 1st Inning?	
    // 485,	    // Will Home Team Get A Wicket in Over - 2nd Inning?	
    // 486,	    // Will Away Team Get A Wicket in Over - 2nd Inning?	
    // 491,	    // Will there be a home team hit in 5th inning?	
    // 500,	    // Will there be a away team hit in 5th inning?	
    // 505,	    // A Run Scored - home team 1st inning	
    523,	    // 언더오버 및 양팀모두득점	
    // 524,	    // 1st 7 Innings Winner	
    // 525,	    // 1st 7 Innings Under/Over	
    // 526,	    // 1st 7 Innings Asian Handicap	
    527,	    // Next Score Type	
    528,	    // 승무패 [후반전 및 연장포함]	
    529,	    // 홀짝 [후반전 및 연장포함]	
    531,	    // 3-Way Winning Margin Range	
    532,	    // Winning Margin Range	
    533,	    // Exact Winning Margin	
    535,	    // 3-Way Winning Margin Range - 1st Half	
    536,	    // 3-Way Winning Margin Range - 1st Period	
    537,	    // 3-Way Winning Margin Range - 2nd Period	
    538,	    // 3-Way Winning Margin Range - 3rd Period	
    539,	    // 3-Way Winning Margin Range - 4th Period	
    540,	    // 3-Way Winning Margin Range - 5th Period	
    // 541,	    // Winning Margin - 1st Period	
    542,	    // Winning Margin - 2nd Period	
    543,	    // Winning Margin - 3rd Period	
    544,	    // Winning Margin - 4th Period	
    545,	    // Winning Margin - 5th Period	
    546,	    // 3-Way Winning Margin Range Including Overtime	
    547,	    // Exact Winning Margin Including Overtime	
    548,	    // Winning Margin Range Including Overtime	
    549,	    // Exact Winning Margin - 1st Period	
    550,	    // Exact Winning Margin - 2nd Period	
    551,	    // Exact Winning Margin - 3rd Period	
    552,	    // Exact Winning Margin - 4th Period	
    553,	    // Under/Over Shootout Penalties Taken	
    554,	    // 12 Shootout	
    555,	    // Asian Handicap Shootout	
    556,	    // Correct Score Shootout	
    557,	    // Under/Over Shootout	
    558,	    // Under/Over Shootout - Home Team	
    559,	    // Under/Over Shootout - Away Team	
    560,	    // Team To Take Last Shootout Penalty	
    563,	    // Race To Including Overtime	
    564,	    // 1X2 And Under/Over 5 way	
    566,	    // 10th Period Winner Home/Away	
    567,	    // 11th Period Winner Home/Away	
    568,	    // 12th Period Winner Home/Away	
    569,	    // 13th Period Winner Home/Away	
    570,	    // 14th Period Winner Home/Away	
    571,	    // 15th Period Winner Home/Away	
    573,	    // 16th Period Winner Home/Away	
    574,	    // 17th Period Winner Home/Away	
    575,	    // 18th Period Winner Home/Away	
    576,	    // 19th Period Winner Home/Away	
    577,	    // 10 Minute Under/Over - Corners	
    578,	    // 10 Minute Under/Over - Cards	
    579,	    // Next Corner	
    581,	    // Top 3 Finish	
    582,	    // Top 6 Winner	
    584,	    // Top 8 Winner	
    586,	    // To Finish In Top Half	
    587,	    // To Finish In Bottom Half	
    588,	    // To Finish Bottom	
    589,	    // Not To Finish In Top 4	
    590,	    // To Be Relegated	
    591,	    // Not To Be Relegated	
    592,	    // To Reach Final	
    593,	    // To Finish In Bottom 6	
    594,	    // To Be Promoted	
    595,	    // First Goal Time	
    596,	    // Goals Range Home Team 1st Period	
    597,	    // Goals Range Home Team 2nd Period	
    598,	    // Goals Range Away Team 1st Period	
    599,	    // Goals Range Away Team 2nd Period	
    600,	    // 1st Period Winner And Both Teams To Score	
    601,	    // HT/FT Double Chance	
    602,	    // Correct Score Including Overtime	
    603,	    // Negative HT/FT	
    604,	    // Goals Range Home Team Both Periods	
    605,	    // Goals Range Away Team Both Periods	
    606,	    // Winner And Goals Type One	
    607,	    // Double Chance And Goals	
    608,	    // Winner And Goals Type Two	
    609,	    // Both Teams To Score And Goals	
    610,	    // Double Chance Mix	
    628,	    // To Finish In Top 7	
    629,	    // To Finish In Top 6	
    630,	    // To Finish In Top 3	
    631,	    // To Finish In Top 2	
    632,	    // To Finish In Top 4	
    633,	    // To Finish In Top 5	
    // 634,	    // Odd/Even Rounds 1st Period	
    635,	    // Odd/Even Rounds 2nd Period	
    636,	    // Odd/Even Rounds 3rd Period	
    637,	    // Will There Be An Ace?	
    638,	    // Will There Be A Knife Kill?	
    639,	    // 1st Round Winner	
    640,	    // 16th Round Winner	
    641,	    // Will there be a knife kill? - 1st Period	
    642,	    // Will there be a knife kill? - 2nd Period	
    643,	    // Will there be a knife kill? - 3rd Period	
    644,	    // Will There Be An Ace? - 1st Period	
    645,	    // Will There Be An Ace? - 2nd Period	
    646,	    // Will There Be An Ace? - 3rd Period	
    // 647,	    // Will There Be Overtime? - 1st Period	
    648,	    // Will There Be Overtime? - 2nd Period	
    649,	    // Will There Be Overtime? - 3rd Period	
    // 650,	    // 16th Round Winner - 1st Period	
    // 651,	    // 16th Round Winner - 2nd Period	
    // 652,	    // 16th Round Winner - 3rd Period	
    // 653,	    // 1st Round Winner - 1st Period	
    // 654,	    // 1st Round Winner - 2nd Period	
    655,	    // 1st Round Winner - 3rd Period	
    660,	    // Game Duration	
    662,	    // Odd/Even Rounds	
    663,	    // 1st Period Duration	
    664,	    // 2nd Period Duration	
    665,	    // 3rd Period Duration	
    // 666,	    // 1st Period - 1st Roshan	
    // 667,	    // 2nd Period - 1st Roshan	
    // 668,	    // 3rd Period - 1st Roshan	
    // 669,	    // 1st Period - 1st Blood	
    // 670,	    // 2nd Period - 1st Blood	
    671,	    // 3rd Period - 1st Blood	
    // 672,	    // 1st Period - 1st Tower	
    // 673,	    // 2nd Period - 1st Tower	
    // 674,	    // 3rd Period - 1st Tower	
    675,	    // 1st Period - 1st Barracks	
    677,	    // 2nd Period - 1st Barracks	
    678,	    // 3rd Period - 1st Barracks	
    679,	    // 1st Period - 1st Turret	
    680,	    // 2nd Period - 1st Turret	
    681,	    // 3rd Period - 1st Turret	
    682,	    // Race To Kills - 1st Period	
    683,	    // Race To Kills - 2nd Period	
    684,	    // Race To Kills - 3rd Period	
    685,	    // Both Teams to kill a Dragon - 1st Period	
    686,	    // Both Teams to kill a Dragon - 2nd Period	
    687,	    // Both Teams to kill a Dragon - 3rd Period	
    688,	    // Both Teams to kill a Inhibitor - 1st Period	
    689,	    // Both Teams to kill a Inhibitor - 2nd Period	
    690,	    // Both Teams to kill a Inhibitor - 3rd Period	
    691,	    // Odd/Even Kills	
    // 692,	    // Odd/Even Kills - 1st Period	
    // 693,	    // Odd/Even Kills - 2nd Period	
    694,	    // Odd/Even Kills - 3rd Period	
    695,	    // HT/FT And Goals	
    697,	    // To Finish In Top 8	
    698,	    // To Finish In Top 9	
    711,	    // Player To Score In Anytime	
    712,	    // First Player To Score	
    713,	    // Last Player To Score	
    714,	    // Player To Score 2 Or More Goals	
    715,	    // Player To Score 3 Or More Goals	
    720,	    // To win 1st set & win the match	
    721,	    // To Lose 1st Set & win the Match	
    726,	    // To Win 1st Set & Lose The Match	
    727,	    // 1st Period Both Teams To Score	
    728,	    // 2nd Period Both Teams To Score	
    729,	    // 3rd Period Both Teams To Score	
    730,	    // 4th Period Both Teams To Score	
    731,	    // 1st Period Home Team To Score	
    732,	    // 2nd Period Home Team To Score	
    733,	    // 3rd Period Home Team To Score	
    734,	    // 4th Period Home Team To Score	
    735,	    // 1st Period Away Team To Score	
    736,	    // 2nd Period Away Team To Score	
    737,	    // 3rd Period Away Team To Score	
    738,	    // 4th Period Away Team To Score	
    751,	    // 1st Half Race To	
    752,	    // 2nd Half Race To - Including Overtime	27	{"Id":173864394710512930,"Name":"2","Line":"50.0","BaseLine":"50.0","Status":2,"StartPrice":"1.0","Price":"26.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:12:06.041Z","ParticipantId":null}
    754,	    // Game To Deuce	64	{"Id":177565877010507040,"Name":"No","Line":"3/10","BaseLine":"3/10","Status":2,"StartPrice":"1.0","Price":"1.533","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:05:21.268Z","ParticipantId":null}
    755,	    // Extra Time Corners - Under/Exactly/Over	
    756,	    // Under/Over- Extra Time Corners	
    757,	    // Asian Handicap - Extra Time	
    758,	    // 10 Minute Under/Over - Free Kicks	
    759,	    // 10 Minute Under/Over - Throw-ins	
    760,	    // 10 Minute Under/Over - Goal Kicks	
    762,	    // To Win The Toss	
    763,	    // Under/Over Runs In Match	
    765,	    // To Score Most Fours	
    766,	    // Under/Over - Match Fours	
    767,	    // Under/Over - Match Sixes	
    768,	    // A Fifty To Be Scored In The Match	
    769,	    // A Hundred To Be Scored In The Match	
    770,	    // Most Run Outs	
    791,	    // Top Batsman - Home Team	
    792,	    // Top Batsman - Away Team	
    793,	    // Top Bowler - Home Team	
    794,	    // Top Bowler - Away Team	
    795,	    // Man Of The Match	
    806,	    // Batsman To Score a Fifty in The match	
    807,	    // Most Runs - Batsman Matches	
    808,	    // Race To 10 Runs	
    809,	    // Highest 1st 6 Overs Score	
    813,	    // Player To Score Most Sixes	
    814,	    // Highest Individual Score	
    819,	    // To Have A Break Point In The Game	64	{"Id":88731541210507020,"Name":"Yes","Line":"1/7","BaseLine":"1/7","Status":2,"StartPrice":"1.0","Price":"3.75","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:45:33.999Z","ParticipantId":null}
    820,	    // Race To Corners	
    821,	    // League Top Goalscorer	
    822,	    // Top New Team 	
    823,	    // 2nd Player To Score	
    824,	    // Player To Be Booked	
    825,	    // Player To Be Sent Off	
    834,	    // Extra Points Set	
    835,	    // Asian Under/Over	22	{"Id":103624053210529120,"Name":"Under","Line":"6.25","BaseLine":"6.25","Status":2,"StartPrice":"1.0","Price":"1.125","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:41:06.976Z","ParticipantId":null}
    836,	    // Asian Under/Over 1st Period	8	{"Id":144132449810529120,"Name":"Under","Line":"1.25","BaseLine":"1.25","Status":3,"StartPrice":"1.0","Price":"1.12","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":2,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:37:42.267Z","ParticipantId":null}
    837,	    // 1st Half Home Team Win To Nil	
    838,	    // 1st Half Away Team Win To Nil	
    839,	    // 1st Half 1X2 And Under/Over	
    840,	    // 1st Period Home Team Win To Nil	
    841,	    // 1st Period Away Team Win To Nil	
    842,	    // Under/Exactly/Over - Home Team	
    843,	    // Under/Exactly/Over - Away Team	
    844,	    // First Team To Score - Home/Away	
    845,	    // Team To Call First Time Out	
    846,	    // Under/Over Hits - Including Overtime	
    // 848,	    // Under/Over 3rd Inning	
    // 849,	    // Under/Over 5th Inning	
    // 850,	    // Under/Over 7th Inning	
    851,	    // Team With Highest Scoring Half	
    852,	    //  Either Team to Score 3 Unanswered Times	
    853,	    // 12 And Under/Over	
    854,	    // Special Team or Defensive Touchdown Scored	
    855,	    // Points Range	
    859,	    // 147 Break In Match	
    861,	    // First Score Method 3 Way - Home Team	
    862,	    // First Score Method 3 Way - Away Team	
    863,	    // Team with Highest Scoring Period -1X2	
    864,	    // Team First Goalscorer	
    865,	    // Team Last Goalscorer	
    // 866,	    // 핸디캡 세트	2	{"Id":{"low":-1089902433,"high":47331811,"unsigned":false},"Name":"2","Line":"-1.5 (0-0)","BaseLine":"1.5 (0-0)","Status":1,"StartPrice":"2.0","Price":"2.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:57:20.336Z","ParticipantId":null}
    870,	    // First Score Method 6 Way Home/Away	
    878,	    // Goals Range 3rd Period	
    879,	    // Under/Over Tries	
    880,	    // First Half Corners - Under/Exactly/Over	
    881,	    // First Goal Method	
    882,	    // Number of points	120	{"Id":182248968310507040,"Name":"6","Line":"10.0","BaseLine":"10.0","Status":2,"StartPrice":"1.0","Price":"3.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:00:34.488Z","ParticipantId":null}
    891,	    // Team To Score Longest Touchdown	
    892,	    // Team To Score Longest Field Goal	
    893,	    // Longest Touchdown Scored	
    894,	    // Shortest Touchdown Scored	
    895,	    // Longest Field Goal Scored	
    896,	    // Time Of First Team Goal	
    897,	    // Game Score After 2 Points	
    898,	    // Game Score After 3 Points	
    899,	    // Game Score After 4 Points	
    900,	    // Game To Score	256	{"Id":107125991510507020,"Name":"2","Line":"1/9/30","BaseLine":"1/9/30","Status":2,"StartPrice":"1.0","Price":"1.8","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:56:21.849Z","ParticipantId":null}
    901,	    // 1st Period Lead After	
    902,	    // 2nd Period Lead After	
    903,	    // 3rd Period Lead After	
    904,	    // 4th Period Lead After	
    905,	    // 5th Period Lead After	
    906,	    // Score After 4 Games	18	{"Id":151793716310507040,"Name":"2","Line":"1/4-0","BaseLine":"1/4-0","Status":2,"StartPrice":"1.0","Price":"23.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:28:23.753Z","ParticipantId":null}
    907,	    // Score After 6 Games	23	{"Id":96315614410507020,"Name":"1","Line":"3/6-0","BaseLine":"3/6-0","Status":2,"StartPrice":"1.0","Price":"1.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:30:48.834Z","ParticipantId":null}
    908,	    // To Break Serve In Set	12	{"Id":143352132210507020,"Name":"Away - No","Line":"1.0","BaseLine":"1.0","Status":2,"StartPrice":"1.0","Price":"5.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:39:23.554Z","ParticipantId":null}
    909,	    // Home To Win In Straight Sets	2	{"Id":122321073610507020,"Name":"No","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.007","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:58:32.955Z","ParticipantId":null}
    910,	    // Away To Win In Straight Sets	2	{"Id":90288377110507020,"Name":"No","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"2.375","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:58:39.202Z","ParticipantId":null}
    911,	    // Score After 2 Sets	
    912,	    // Score After 3 Sets	
    913,	    // Score After 4 Sets	
    914,	    // Under/Over Field Goals Scored - 1st Half	
    915,	    // Under/Over Touchdowns Scored - 1st Half	
    916,	    // Under/Over Home Team Touchdowns - 1st Half	
    917,	    // Under/Over Away Team Touchdowns - 1st Half	
    918,	    // Under/Over Home Team Field Goals - 1st Half	
    919,	    // Under/Over Away Team Field Goals - 1st Half	
    920,	    // Under/Over Touchdowns	
    921,	    // Under/Exactly/Over - Touchdowns	
    922,	    // Under/Over Field Goals	
    923,	    // Under/Exactly/Over - Field Goals	
    924,	    // Time Of First Field Goal Scored	
    925,	    // Time Of First Touchdown Scored	
    926,	    // Time Of First Score	
    927,	    // Home Team Under/Over Touchdowns	
    928,	    // Away Team Under/Over Touchdowns	
    929,	    // Home Team Under/Over Field Goals	
    930,	    // Away Team Under/Over Field Goals	
    931,	    // Both Teams To Score Points	
    932,	    // Team to Have First Coaches Challenge	
    933,	    // Team to Commit First Accepted Penalty	
    934,	    // Safety Scored	
    935,	    // European Cards Handicap	
    936,	    // Asian Under/Over Cards	
    938,	    // Under/Over Cards - Home Team	
    939,	    // Under/Over Cards - Away Team	
    940,	    // Time Of First Card	
    941,	    // Next Player To Score	
    942,	    // Top Nationality - Asian 	
    943,	    // Top Nationality - Australian 	
    944,	    // Top Nationality - European	
    945,	    // Top Nationality - Great Britain & Ireland	
    946,	    // Top Nationality - Rest Of The World	
    947,	    // Under/Over Aces	2	{"Id":18537447510507028,"Name":"Under","Line":"13.5","BaseLine":"13.5","Status":2,"StartPrice":"1.0","Price":"2.22","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:22:01.645Z","ParticipantId":null}
    948,	    // Under/Over Aces - Home Team	
    949,	    // Exact Number Of Aces	
    950,	    // Under/Over Aces - Away Team	
    951,	    // Correct Number Of Aces	
    952,	    // Odd/Even Number Of Aces	
    953,	    // Odd/Even Number Of Aces - Home Team	
    954,	    // Odd/Even Number Of Aces - Away Team	
    955,	    // 1X2 Aces	
    956,	    // Exact Number Of Aces - Home Team	
    957,	    // Exact Number Of Aces - Away Team	
    958,	    // Aces Asian Handicap	2	{"Id":60668206710507020,"Name":"1","Line":"6.5","BaseLine":"6.5","Status":2,"StartPrice":"1.0","Price":"1.975","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:22:01.645Z","ParticipantId":null}
    959,	    // Race To Aces 	
    960,	    // Under/Over Aces - 1st Period	
    961,	    // Under/Over Aces - 2nd Period	
    962,	    // Under/Over Aces Home Team - 1st Period	
    963,	    // Under/Over Aces Home Team - 2nd Period	
    964,	    // Under/Over Aces Away Team - 1st Period	
    965,	    // Under/Over Aces Away Team - 2nd Period	
    966,	    // Exact Number Of Aces - 1st Period	
    967,	    // Exact Number Of Aces - 2nd Period	
    968,	    // Correct Number Of Aces - 1st Period	
    969,	    // Correct Number Of Aces - 2nd Period	
    970,	    // Odd/Even Number Of Aces - 1st Period	
    971,	    // Odd/Even Number Of Aces - 2nd Period	
    972,	    // Odd/Even Number Of Aces Home Team - 1st Period	
    973,	    // Odd/Even Number Of Aces Home Team - 2nd Period	
    974,	    // Odd/Even Number Of Aces Away Team - 1st Period	
    975,	    // Odd/Even Number Of Aces Away Team - 2nd Period	
    976,	    // 1X2 Aces - 1st Period	
    977,	    // 1X2 Aces - 2nd Period	
    978,	    // Exact Number Of Aces Home Team - 1st Period	
    979,	    // Exact Number Of Aces Home Team - 2nd Period	
    980,	    // Exact Number Of Aces Away Team - 1st Period	
    981,	    // Exact Number Of Aces Away Team - 2nd Period	
    982,	    // Aces Asian Handicap - 1st Period	
    983,	    // Aces Asian Handicap - 2nd Period	
    984,	    // Race To Aces - 1st Period	
    985,	    // Race To Aces - 2nd Period	
    986,	    // 12 Aces	
    987,	    // 12 Aces - 1st Period	
    988,	    // 12 Aces - 2nd Period	
    // 989,	    // Under/Over Kills - 1st Period	
    // 990,	    // Under/Over Kills - 2nd Period	
    // 991,	    // Under/Over Kills - 3rd Period	
    992,	    // Next Touchdown Scorer - Home Team	
    993,	    // Next Touchdown Scorer - Away Team	
    994,	    // Next Touchdown Scorer	
    995,	    // Player To Score Touchdown In Anytime	
    996,	    // Player To Score 2 Or More Touchdowns	
    997,	    // Player To Score 3 Or More Touchdowns	
    998,	    //  First Match Corner - 12	
    999,	    // Last Match Corner - 12	
    1000,	// Number Of Sets	2	{"Id":197829011910507040,"Name":"2 Sets","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.5","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:58:39.202Z","ParticipantId":null}
    1001,	// Under/Over Double Faults	2	{"Id":127048308710507020,"Name":"Over","Line":"4.5","BaseLine":"4.5","Status":2,"StartPrice":"1.0","Price":"1.775","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:21:55.393Z","ParticipantId":null}
    1002,	// Under/Over Double Faults - Away Team	
    1003,	// Under/Over Double Faults - Home Team	
    1004,	// Under/Over Double Faults  - 1st Period	
    1005,	// Under/Over Double Faults - 2nd Period	
    1006,	// Under/Over Double Faults Away Team - 1st Period	
    1007,	// Under/Over Double Faults Away Team - 2nd Period	
    1008,	// Under/Over Double Faults Home Team - 1st Period	
    1009,	// Under/Over Double Faults Home Team - 2nd Period	
    1010,	// 12 Double Faults	
    1011,	// 12 Double Faults - 1st Period	
    1012,	// 12 Double Faults - 2nd Period	
    1013,	// 1X2 Double Faults	
    1014,	// 1X2 Double Faults - 1st Period	
    1015,	// 1X2 Double Faults - 2nd Period	
    1016,	// Exact Number Of Double Faults	
    1017,	// Exact Number Of Double Faults - 1st Period	
    1018,	// Exact Number Of Double Faults - 2nd Period	
    1019,	// Exact Number Of Double Faults - Home Team	
    1020,	// Exact Number Of Double Faults - Away Team	
    1021,	// Exact Number Of Double Faults Home Team - 1st Period	
    1024,	// Exact Number Of Double Faults Home Team - 2nd Period	
    1025,	// Exact Number Of Double Faults Away Team - 1st Period	
    1026,	// Exact Number Of Double Faults Away Team - 2nd Period	
    1027,	// Correct Number Of Double Faults	
    1028,	// Correct Number Of Double Faults - 1st Period	
    1029,	// Correct Number Of Double Faults - 2nd Period	
    1030,	// Time Of First Corner	
    1031,	// Multiple Corners 	
    1034,	// 20th Period Winner Home/Away	
    1035,	// 21th Period Winner Home/Away	
    1036,	// 22th Period Winner Home/Away	
    1037,	// 23th Period Winner Home/Away	
    1038,	// 24th Period Winner Home/Away	
    1039,	// 25th Period Winner Home/Away	
    1040,	// 26th Period Winner Home/Away	
    1041,	// 27th Period Winner Home/Away	
    1042,	// 28th Period Winner Home/Away	
    1043,	// 29th Period Winner Home/Away	
    1044,	// 30th Period Winner Home/Away	
    1045,	// 31th Period Winner Home/Away	
    1046,	// 32th Period Winner Home/Away	
    1047,	// 33th Period Winner Home/Away	
    1048,	// 34th Period Winner Home/Away	
    1049,	// 35th Period Winner Home/Away	
    1050,	// Race To 20 Points	
    1051,	// Under/Over 2nd Half - Home Team	2	{"Id":153174349710512930,"Name":"Under","Line":"43.5","BaseLine":"43.5","Status":2,"StartPrice":"1.0","Price":"1.769","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T01:38:21.339Z","ParticipantId":null}
    1052,	// Under/Over 2nd Half - Away Team	2	{"Id":153011310512937,"Name":"Over","Line":"42.5","BaseLine":"42.5","Status":2,"StartPrice":"1.0","Price":"1.909","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T01:38:21.339Z","ParticipantId":null}
    1053,	// Asian Under/Over 2nd Period	
    1054,	// Asian Under/Over 3rd Period	
    1055,	// Asian Under/Over 4th Period	
    1061,	// Asian Under/Over Including Overtime 	64	{"Id":182445178010512930,"Name":"Over","Line":"161.25","BaseLine":"161.25","Status":2,"StartPrice":"1.0","Price":"1.84","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:04:42.219Z","ParticipantId":null}
    1062,	// Highest Scoring Half - Home Team	
    1063,	// Highest Scoring Half - Away Team	
    1064,	// tmp1	
    1065,	// Home Team - First Goalscorer	
    1066,	// Home Team - Last Goalscorer	
    1067,	// Away Team - First Goalscorer	
    1068,	// Away Team - Last Goalscorer	
    1069,	// Under/Over Player Points	218	{"Id":43721363710509440,"Name":"Over","Line":"36.5","BaseLine":"Devin Booker#36.5","Status":3,"StartPrice":"1.0","Price":"1.952","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":2,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:55:53.977Z","ParticipantId":null}
    1070,	// Under/Over Player Blocks	42	{"Id":19605995410509436,"Name":"Under","Line":"0.5","BaseLine":"Bismack Biyombo#0.5","Status":3,"StartPrice":"1.0","Price":"2.05","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:31:55.258Z","ParticipantId":null}
    1071,	// Under/Over Player Assists	80	{"Id":169630335710509440,"Name":"Over","Line":"0.5","BaseLine":"Deandre Ayton#0.5","Status":3,"StartPrice":"1.0","Price":"2.55","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":2,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:05:39.260Z","ParticipantId":null}
    1072,	// Under/Over Player Rebounds	106	{"Id":201797937410509440,"Name":"Over","Line":"6.5","BaseLine":"Morris Marcus#6.5","Status":2,"StartPrice":"1.0","Price":"2.8","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:38:22.345Z","ParticipantId":null}
    1073,	// Under/Over Player Steals	44	{"Id":107514887210509440,"Name":"Over","Line":"0.5","BaseLine":"Torrey Craig#0.5","Status":2,"StartPrice":"1.0","Price":"6.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T04:01:24.264Z","ParticipantId":null}
    1074,	// Under/Over Player Turnovers	58	{"Id":162946801510509440,"Name":"Over","Line":"4.5","BaseLine":"Westbrook Russell#4.5","Status":2,"StartPrice":"1.0","Price":"1.476","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:57:18.857Z","ParticipantId":null}
    1075,	// Under/Over Player 3 Points Made	54	{"Id":148004922210509440,"Name":"Over","Line":"2.5","BaseLine":"Westbrook Russell#2.5","Status":2,"StartPrice":"1.0","Price":"2.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:59:02.311Z","ParticipantId":null}
    1076,	// Under/Over Player 3 Points Attempted	
    1077,	// Under/Over Player 2 Points Made	
    1078,	// Under/Over Player 2 Points Attempted	
    1079,	// Under/Over Player Free Throws Made	
    1080,	// Under/Over Player Free Throws Attempted	
    1081,	// 1X2 Yellow Cards	
    1082,	// Double Chance Yellow Cards	
    1083,	// Asian Handicap Yellow Cards	
    1084,	// Correct Score Yellow Cards	
    1085,	// Under/Over Red Cards	
    1086,	// Under/Exactly/Over Booking Points	
    1087,	// Under/Exactly/Over Booking Points - Home Team	
    1088,	// Under/Exactly/Over Booking Points - Away Team	
    1089,	// Under/Over Player Steals And Blocks	58	{"Id":184469861110509440,"Name":"Over","Line":"0.5","BaseLine":"Torrey Craig#0.5","Status":2,"StartPrice":"1.0","Price":"3.65","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T04:01:24.264Z","ParticipantId":null}
    1090,	// Under/Over Player Points, Assists And Rebounds	260	{"Id":201455310910509440,"Name":"Under","Line":"17.5","BaseLine":"Eric Gordon#17.5","Status":2,"StartPrice":"1.0","Price":"1.833","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:09:42.715Z","ParticipantId":null}
    1091,	// Under/Over Player Assists And Rebounds	132	{"Id":190123238010509440,"Name":"Over","Line":"3.5","BaseLine":"Torrey Craig#3.5","Status":2,"StartPrice":"1.0","Price":"2.65","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T04:01:42.497Z","ParticipantId":null}
    1092,	// Under/Over Player Points And Rebounds	228	{"Id":86000095710509440,"Name":"Under","Line":"9.5","BaseLine":"Bismack Biyombo#9.5","Status":2,"StartPrice":"1.0","Price":"2.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:06:02.192Z","ParticipantId":null}
    1093,	// Under/Over Player Points And Assists	226	{"Id":24077212710509436,"Name":"Under","Line":"5.5","BaseLine":"Torrey Craig#5.5","Status":2,"StartPrice":"1.0","Price":"1.645","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:03:53.801Z","ParticipantId":null}
    1094,	// Player Double Double	
    1095,	// Player Triple Double	
    1096,	// Under/Exactly/Over Booking Points - 1st Period	
    1098,	// Under/Over 180's In a Leg	
    1099,	// Under/Over Total Checkouts In a Leg	
    1100,	// Set Winner 	
    1101,	// Under/Over 180's In a Set	
    1102,	// Set/Leg Winner 	
    1103,	// Set/Leg Total Checkouts Under/Over 	
    1104,	// Set/Leg 180's Under/Over	
    1105,	// Under/Over Total 180's - Home Team	
    1106,	// Under/Over Total 180's - Away Team	
    1112,	// Under/Over Player Goals	
    1115,	// Under/Over Player Goals Allowed	
    // 1120,	// Under/Over Rounds - 1st Period	
    // 1121,	// Under/Over Rounds - 2nd Period	
    // 1122,	// Under/Over Rounds - 3rd Period	
    1123,	// 4th Period - 1st Blood	
    1124,	// 5th Period - 1st Blood	
    1125,	// Both Teams To Kill a Dragon	
    1126,	// Both Teams To Kill a Baron	
    1127,	// Both Teams To Kill a Inhibitor	
    1128,	// Under/Over Barons Slain	
    1129,	// Under/Over Barons Slain - 1st Period	
    1130,	// Under/Over Barons Slain - 2nd Period	
    1131,	// Under/Over Barons Slain - 3rd Period	
    1132,	// Under/Over Dragons Slain	
    1133,	// Under/Over Dragons Slain - 1st Period	
    1134,	// Under/Over Dragons Slain - 2nd Period	
    1135,	// Under/Over Dragons Slain - 3rd Period	
    1136,	// Under/Over 180's	
    1137,	// First 180	
    1138,	// Last 180	
    1139,	// Under/Over Highest Checkout Score	
    1140,	// Most 180's	
    1141,	// Under/Over Highest Checkout Score - Home Team	
    1142,	// Under/Over Highest Checkout Score - Away Team	
    1143,	// First Player To Score Touchdown	
    1144,	// Last Player To Score Touchdown	
    1145,	// First Player To Score Touchdown - Home Team	
    1146,	// First Player To Score Touchdown - Away Team	
    1147,	// Under/Over Kills - 4th Period	
    1148,	// Under/Over Kills - 5th Period	
    // 1149,	// Asian Handicap Kills - 1st Period	
    // 1150,	// Asian Handicap Kills - 2nd Period	
    // 1151,	// Asian Handicap Kills - 3rd Period	
    1152,	// Asian Handicap Kills - 4th Period	
    1153,	// Asian Handicap Kills - 5th Period	
    1154,	// Under/Exactly/Over 180's	
    1155,	// Under/Exactly/Over Total 180's - Home Team	
    1156,	// Under/Exactly/Over Total 180's - Away Team	
    1157,	// Most Checkouts	
    1158,	// First Try Scorer	
    1159,	// Last Try Scorer	
    1160,	// Anytime Try Scorer	
    1161,	// Under/Over Towers Destroyed	
    1162,	// Under/Over Towers Destroyed - 1st Period	
    1163,	// Under/Over Towers Destroyed - 2nd Period	
    1164,	// Under/Over Towers Destroyed - 3rd Period	
    1165,	// 1st Period - 1st Baron	
    1166,	// 2nd Period - 1st Baron	
    1167,	// 3rd Period - 1st Baron	
    1168,	// 4th Period - 1st Baron	
    1169,	// 5th Period - 1st Baron	
    1170,	// 1st Period - 1st Dragon	
    1171,	// 2nd Period - 1st Dragon	
    1172,	// 3rd Period - 1st Dragon	
    1173,	// 4th Period - 1st Dragon	
    1174,	// 5th Period - 1st Dragon	
    1175,	// Most Kills - 1st Period	
    1176,	// Most Kills - 2nd Period	
    1177,	// Most Kills - 3rd Period	
    1178,	// Most Kills - 4th Period	
    1179,	// Most Kills - 5th Period	
    1180,	// Most Kills - 6th Period	
    1181,	// Most Kills - 7th Period	
    1182,	// Player To Score 2 Or More Trys	
    1183,	// Player To Score 3 Or More Trys	
    1184,	// Not To Win The Leauge	
    1185,	// Under/Exactly/Over Including Overtime - Home Team	
    1186,	// Under/Exactly/Over Including Overtime - Away Team	
    1187,	// Under/Exactly/Over Including Overtime 	
    1188,	// Under/Over Substitutions	
    1189,	// Under/Over Substitutions - 1st Period	
    1190,	// Last Player To Score Touchdown - Home Team	
    1191,	// Last Player To Score Touchdown - Away Team	
    1192,	// First Player To Hit an Ace	
    1193,	// Under/Over Player Quarterback Passing Yards	
    1194,	// Under/Over Player Passing Touchdowns	
    1195,	// Under/Over Longest Player Pass Completion	
    1196,	// Under/Over Player Receiving Yards	
    1197,	// Under/Over Player Interceptions	
    1198,	// Under/Over Player Kicking Points	
    1199,	// Under/Over Player Rushing & Receiving Yards	
    1200,	// Under/Over Player Rushing Yards	
    1201,	// Under/Over Player Longest Reception	
    1202,	// Under/Over Player Receptions	
    1203,	// Under/Over Player Field Goals Made	
    1204,	// Under/Over Player Field Goals Attempted	
    1205,	// Under/Over Player Quarterback Passing Touchdowns	
    1206,	// Under/Over Player Receiver Reception Completions	
    1207,	// Under/Over Player Quarterback Passes Completed	
    1208,	// Under/Over Player Rushing Touchdowns	
    1209,	// Under/Over Player Receiver Reception Attempts	
    1210,	// Under/Over Player Quarterback Passes Attempted	
    1211,	// 1X2 Fouls	
    1212,	// Double Chance Fouls	
    1213,	// Under/Over Fouls - 1st Period	
    1214,	// Under/Over Fouls - 2nd Period	
    1215,	// Asian Handicap Fouls	
    1216,	// Under/Over Fouls - Home Team	
    1217,	// Under/Over Fouls - Away Team	
    1218,	// Under/Over Player Rush Attempts	
    1219,	// Under/Over Player Receiving Touchdowns	
    1222,	// Under/Over Throw-Ins - Home Team	
    1223,	// Under/Over Throw-Ins - Away Team	
    1224,	// 1X2 Throw-Ins	
    1225,	// Double Chance Throw-Ins	
    1226,	// Under/Over Throw-Ins - 1st Period	
    1227,	// Throw-ins Handicap	
    1228,	// Throw-ins Handicap - 1st Period	
    1229,	// Under/Over Shots on Target - Home Team	
    1230,	// Under/Over Shots on Target - Away Team	
    1231,	// Asian Handicap Shots on Target	
    1232,	// Asian Handicap Shots On Target - 1st Period	
    1233,	// Under/Over Shots On Target - 1st Period	
    1234,	// 1X2 Shots on Target	
    1235,	// Double Chance Shots on Target	
    1236,	// Under/Over Total Shots - Home Team	
    1237,	// Under/Over Total Shots - Away Team	
    1238,	// Double Chance Total Shots	
    1239,	// 1X2 Total Shots	
    1240,	// Asian Handicap Total Shots	
    1241,	// Asian Handicap Total Shots - 1st Period	
    1242,	// Under/Over Total Shots - 1st Period	
    1243,	// Double Chance Corners	
    1244,	// Double Chance Corners - 1st Period	
    1245,	// Corners From All 4 Corners Of The Pitch	
    1246,	// Double Chance Yellow Cards - 1st Period	
    1247,	// 1X2 Yellow Cards - 1st Period	
    1248,	// Asian Handicap Yellow Cards - 1st Period	
    1249,	// Double Chance & Under/Over	
    1250,	// Double Chance & Both Teams To Score	
    1251,	// 1st Period - 1st Inhibitor	
    1252,	// 2nd Period - 1st Inhibitor	
    1253,	// 3rd Period - 1st Inhibitor	
    1254,	// 4th Period - 1st Inhibitor	
    1255,	// 5th Period - 1st Inhibitor	
    1256,	// Both Teams To Kill a Baron - 1st Period	
    1257,	// Both Teams To Kill a Baron - 2nd Period	
    1258,	// Both Teams To Kill a Baron - 3rd Period	
    1259,	// Both Teams To Kill a Baron - 4th Period	
    1260,	// Both Teams To Kill a Baron - 5th Period	
    1261,	// Both Teams to kill a Dragon - 4th Period	
    1262,	// Both Teams to kill a Dragon - 5th Period	
    1263,	// Both Teams to kill a Inhibitor - 4th Period	
    1264,	// Both Teams to kill a Inhibitor - 5th Period	
    1265,	// Will There Be An Ace Next Game?	
    1266,	// Will There Be Double Fault Next Game?	
    1267,	// Odd/Even Fouls	
    1268,	// Asian Handicap Ball Possession 	
    1269,	// Double Chance Offsides	
    1270,	// Asian Handicap Offsides	
    1271,	// Under/Over Offsides - Home Team	
    1272,	// Under/Over Offsides - Away Team	
    1273,	// 1X2 Offsides	
    1274,	// Under/Over Kills 1st Period - Home Team	
    1275,	// Under/Over Kills 2nd Period - Home Team	
    1276,	// Under/Over Kills 3rd Period - Home Team	
    1277,	// Under/Over Kills 1st Period - Away Team	
    1278,	// Under/Over Kills 2nd Period - Away Team	
    1279,	// Under/Over Kills 3rd Period - Away Team	
    1280,	// Under/Over Wides	
    1281,	// Under/Over Ducks	
    1282,	// Under/Over Wickets	
    1283,	// Under/Over Match Fours - Home Team	
    1284,	// Under/Over Match Sixes - Home Team	
    1285,	// Under/Over Match Fours - Away Team	
    1286,	// Under/Over Match Sixes - Away Team	
    1287,	// Under/Over Extras	
    1288,	// Fall Of 1st Wicket - Home Team	
    1289,	// Fall Of 1st Wicket - Away Team	
    1290,	// Team Of Top Batsman	
    1291,	// Under/Over Match Sixes Home Team - 1st Inning	
    1292,	// Under/Over Match Sixes Away Team - 1st Inning	
    1293,	// Under/Over Match Fours Home Team - 1st Inning	
    1294,	// Under/Over Match Fours Away Team - 1st Inning	
    1295,	// Under/Over Top Batsman	
    1296,	// 1st inning 1st Over Dismissal - Home Team	
    1297,	// 1st Inning 2nd Over Dismissal - Home Team	
    1298,	// 1st Inning 3rd Over Dismissal - Home Team	
    1299,	// 1st Inning 2nd Over Dismissal - Away Team	
    1300,	// 1st Inning 3rd Over Dismissal - Away Team	
    1301,	// 1st Inning 1st Over Dismissal - Away Team	
    1302,	// Highest Scoring Over - Under/Over	
    1303,	// 1st Inning 2nd Over Under/Over - Home Team	
    1304,	// 1st Inning 3rd Over Under/Over - Home Team	
    1306,	// 1st Inning 3rd Over Under/Over - Away Team	
    1307,	// 1st Inning 2nd Over Under/Over - Away Team	
    1309,	// Winning Margin - Teams	
    1310,	// Winning Margin - Teams Including Overtime	14	{"Id":140288572010512940,"Name":"Away 14-16","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"351.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:12:37.609Z","ParticipantId":null}
    1311,	// Winning Margin - Teams With Draw	
    1312,	// Winning Margin Exact	
    1314,	// Winning Margin Ranges	
    1315,	// Winning Margin Exact - Teams	
    1316,	// Winning Margin - Teams With Any Other Score	3	{"Id":110722903210512940,"Name":"Any Other Result","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"17.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:06:22.469Z","ParticipantId":null}
    1318,	// Asian Handicap Fouls - 1st Period	
    1319,	// Asian Handicap Offsides - 1st Period	
    1320,	// Asian Handicap Offsides - 2nd Period	
    1321,	// Asian Handicap Fouls - 2nd Period	
    1322,	// Asian Handicap Shots On Target - 2nd Period	
    1323,	// Asian Handicap Total Shots - 2nd Period	
    1324,	// Under/Over Offsides - 1st Period	
    1325,	// Under/Over Offsides - 2nd Period	
    1326,	// First Foul	
    1327,	// First Two Pointer	
    1328,	// First Three Pointer	
    1329,	// Last Two Pointer	
    1330,	// Last Three Pointer	
    1331,	// Last Free Throw Scored	
    1332,	// First Free Throw Scored	
    1333,	// First Rebound	
    1334,	// Last Timeout	
    1335,	// Winning Margin Teams - 1st Period	13	{"Id":198417701410512930,"Name":"Away 7-8","Line":null,"BaseLine":null,"Status":3,"StartPrice":"1.0","Price":"101.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-26T00:48:41.252Z","ParticipantId":null}
    1336,	// Winning Margin Teams - 2nd Period	
    1337,	// Winning Margin Teams - 3rd Period	
    1338,	// Winning Margin Teams - 4th Period	
    1339,	// Winning Margin Teams - 5th Period	
    1340,	// Last Foul	
    1341,	// Under/Over 10th Period	
    1342,	// Under/Over 11th Period	
    1343,	// Under/Over 12th Period	
    1344,	// Under/Over 13th Period	
    1345,	// Under/Over 14th Period	
    1346,	// Under/Over 15th Period	
    1347,	// Under/Over 16th Period	
    1348,	// Under/Over 17th Period	
    1349,	// Under/Over 18th Period	
    1350,	// Under/Over 19th Period	
    1351,	// Under/Over 20th Period	
    1352,	// Under/Over 21st Period	
    1353,	// Under/Over 22nd Period	
    1354,	// Under/Over 23rd Period	
    1355,	// Under/Over 24th Period	
    1356,	// Under/Over 25th Period	
    1357,	// Under/Over 26th Period	
    1358,	// Under/Over 27th Period	
    1359,	// Under/Over 28th Period	
    1360,	// Under/Over 29th Period	
    1361,	// Under/Over 30th Period	
    1362,	// Under/Over 31st Period	
    1363,	// Under/Over 32nd Period	
    1364,	// Under/Over 33rd Period	
    1365,	// Under/Over 34th Period	
    1366,	// Under/Over 35th Period	
    1367,	// Asian Handicap 11th Period	
    1368,	// Asian Handicap 12th Period	
    1369,	// Asian Handicap 13th Period	
    1370,	// Asian Handicap 14th Period	
    1371,	// Asian Handicap 15th Period	
    1372,	// Asian Handicap 16th Period	
    1373,	// Asian Handicap 17th Period	
    1374,	// Asian Handicap 18th Period	
    1375,	// Asian Handicap 19th Period	
    1376,	// Asian Handicap 20th Period	
    1377,	// Asian Handicap 21st Period	
    1378,	// Asian Handicap 22nd Period	
    1379,	// Asian Handicap 23rd Period	
    1380,	// Asian Handicap 24th Period	
    1381,	// Asian Handicap 25th Period	
    1382,	// Asian Handicap 26th Period	
    1383,	// Asian Handicap 27th Period	
    1384,	// Asian Handicap 28th Period	
    1385,	// Asian Handicap 29th Period	
    1386,	// Asian Handicap 30th Period	
    1387,	// Asian Handicap 31st Period	
    1388,	// Asian Handicap 32nd Period	
    1389,	// Asian Handicap 33rd Period	
    1390,	// Asian Handicap 34th Period	
    1391,	// Asian Handicap 35th Period	
    1392,	// To Finish In Top 10	
    1393,	// To Stay Up	
    1394,	// Asian Handicap 10th Period	
    1395,	// Under/Over Player Powerplay Points	
    1396,	// Under/Over Player Plus/Minus	
    1397,	// Under/Over Player Shots	
    1398,	// Top Victorian Club	
    1399,	// Under/Over Run Outs	
    1400,	// Under/Over Frames	
    1401,	// Top 20 Winner	
    1402,	// 1st Round Leader	
    1403,	// Under/Over Games In Set	
    1404,	// 1st Round Six Shooter - Group A	
    1405,	// 1st Round Six Shooter - Group B	
    1406,	// 1st Round 3 Balls	
    1407,	// 1st Round 18 Hole Match-Ups	
    1408,	// Match Handicap	
    1409,	// Team With Top Bowler	
    1410,	// To Win The Toss And The Match	
    1411,	// Under/Over Turrets Destroyed	
    1412,	// Under/Over Turrets Destroyed - 1st Period	
    1413,	// Under/Over Turrets Destroyed - 2nd Period	
    1414,	// Under/Over Turrets Destroyed - 3rd Period	
    1415,	// Highest Score After 1st Over	
    1416,	// Home Team Under/Over Runs - 1st Over to 6th Over	
    1417,	// Away Team Under/Over Runs - 1st Over to 6th Over	
    1418,	// Home Team Under/Over Runs - 1st Over to 8th Over	
    1419,	// Away Team Under/Over Runs - 1st Over to 8th Over	
    1420,	// Home Team Under/Over Runs - 1st Over to 10th Over	
    1421,	// Away Team Under/Over Runs - 1st Over to 10th Over	
    1422,	// To Chase Over 180 Runs And Team to Win	
    1423,	// How Many Runs Will Be Scored From The First Ball	
    1424,	// Under/Over Match Stumpings	
    1425,	// 1st Wicket Method	
    1426,	// First Ball Of The Match	
    1427,	// Under/Over - 1st Inning	
    1428,	// Top Non Victorian Club	
    1429,	// Grand Final Winner	
    1430,	// Grand Final Winning State	
    1431,	// To Reach the Grand Final	
    1432,	// Not To Finish In Top 8	
    1434,	// Under/Over Kills 4th Period - Away Team	
    1435,	// Under/Over Kills 5th Period - Away Team	
    1436,	// Under/Over Kills 4th Period - Home Team	
    1437,	// Under/Over Kills 5th Period - Home Team	
    1438,	// Under/Over Temperature At Airport (Celsius)	
    1439,	// Asian Handicap - Full Time	38	{"Id":46243074310529120,"Name":"1","Line":"-0.75","BaseLine":"-0.75","Status":1,"StartPrice":"1.0","Price":"2.136","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:37:56.652Z","ParticipantId":null}
    1440,	// Under/Over Value Of All Numbers Drawn	
    1441,	// Under/Over Value Of All Odd Numbers Drawn	
    1442,	// Under/Over Value Of All Even Numbers Drawn	
    1443,	// More Even Are Drawn Than Odd Numbers	
    1444,	// Consecutive Numbers Will Be Drawn	
    1445,	// Under/Exactly/Over - Number Of Odd Numbered Balls Drawn	
    1446,	// Under/Exactly/Over - Number Of Even Numbered Balls Drawn	
    1447,	// Sum of 5 Bonus Balls	
    1448,	// First Bonus Ball Drawn - Odd/Even	
    1449,	// Last Bonus Ball Drawn - Odd/Even	
    1450,	// First Bonus Ball	
    1451,	// Last Bonus Ball	
    1452,	// The Lowest of 5 Bonus Balls	
    1453,	// Bonus Ball - Odd/Even	
    1454,	// Identical Numbers Will Be Drawn	
    1455,	// Highest Number Drawn - Odd/Even	
    1456,	// Lowest Number Drawn - Odd/Even	
    1457,	// Ball 1 - Under/Over	
    1458,	// Ball 1 - Odd/Even	
    1459,	// Ball 2 - Under/Over	
    1460,	// Ball 2 - Odd/Even	
    1461,	// Ball 3 - Under/Over	
    1462,	// Ball 3 - Odd/Even	
    1463,	// Ball 4 - Under/Over	
    1464,	// Ball 4 - Odd/Even	
    1465,	// Ball 5 - Under/Over	
    1466,	// Ball 5 - Odd/Even	
    1467,	// Ball 6 - Under/Over	
    1468,	// Ball 6 - Odd/Even	
    1469,	// Ball 7 - Under/Over	
    1470,	// Ball 7 - Odd/Even	
    1471,	// Ball 8 - Under/Over	
    1472,	// Ball 8 - Odd/Even	
    1473,	// Ball 9 - Under/Over	
    1474,	// Ball 9 - Odd/Even	
    1475,	// Ball 10 - Under/Over	
    1476,	// Ball 10 - Odd/Even	
    1477,	// Ball 11 - Under/Over	
    1478,	// Ball 11 - Odd/Even	
    1479,	// Ball 12 - Under/Over	
    1480,	// Ball 12 - Odd/Even	
    1481,	// Ball 13 - Under/Over	
    1482,	// Ball 13 - Odd/Even	
    1483,	// Ball 14 - Under/Over	
    1484,	// Ball 14 - Odd/Even	
    1485,	// Ball 15 - Under/Over	
    1486,	// Ball 15 - Odd/Even	
    1487,	// Ball 16 - Under/Over	
    1488,	// Ball 16 - Odd/Even	
    1489,	// Ball 17 - Under/Over	
    1490,	// Ball 17 - Odd/Even	
    1491,	// Ball 18 - Under/Over	
    1492,	// Ball 18 - Odd/Even	
    1493,	// Ball 19 - Under/Over	
    1494,	// Ball 19 - Odd/Even	
    1495,	// Ball 20 - Under/Over	
    1496,	// Ball 20 - Odd/Even	
    1497,	// At Least One Of The Numbers Drawn Is Divisible By 3	
    1498,	// At Least One Of The Numbers Drawn Is Divisible By 4	
    1499,	// At Least One Of The Numbers Drawn Is Divisible By 5	
    1500,	// At Least One Of The Numbers Drawn Is Divisible By 7	
    1501,	// At Least One Of The Numbers Drawn Is Divisible By 10	
    1502,	// At Least One Of The Numbers Drawn Is Divisible By 15	
    1503,	// At Least One Of The Numbers Drawn Is Divisible By 20	
    1504,	// Highest Number Drawn - Under/Over	
    1505,	//  Total Value Of The Lowest And Highest Numbers Drawn - Under/Over	
    1506,	// Lowest Number Drawn - Under/Over	
    1507,	// Difference Between The Highest And The Lowest Numbers Drawn - Under/Over	
    1508,	// Total Value Of The Lowest And Highest Numbers Drawn - Odd/Even	
    1509,	//  Difference Between The Highest And The Lowest Numbers Drawn - Odd/Even	
    1510,	// First Number Drawn Is Greater Than The Last Number Drawn	
    1511,	// Last Number Drawn - Odd/Even	
    1512,	// First Number Drawn - Odd/Even	
    1513,	// All Drawn Numbers Even	
    1514,	// All Drawn Numbers Odd	
    1515,	// Number To Draw	
    1520,	// 4th Period - 1st Turret	
    1521,	// 5th Period - 1st Turret	
    1523,	// Under/Over Barons Slain - 4th Period	
    1524,	// Under/Over Barons Slain - 5th Period	
    1525,	// Under/Over Dragons Slain - 4th Period	
    1526,	// Under/Over Dragons Slain - 5th Period	
    1527,	// Under/Over Turrets Destroyed - 4th Period	
    1528,	// Under/Over Turrets Destroyed - 5th Period	
    1529,	// 4th Period Duration	
    1530,	// 5th Period Duration	
    1531,	// Odd/Even Kills - 4th Period	
    1532,	// Odd/Even Kills - 5th Period	
    1533,	// Under/Over Inhibitors - 1st Period	
    1534,	// Under/Over Inhibitors - 2nd Period	
    1535,	// Temperature At Airport in Range (Celsius)	
    1536,	// Under/Over Maps	
    1537,	// Home Team To Win & Under/Over - Including Overtime	
    1538,	// Away Team To Win & Under/Over - Including Overtime	
    1539,	// Round Winner	
    1540,	// Total Match Legs Under/Over	
    1541,	// Rounds Handicap	
    1542,	// 1st Leg Winner	
    1543,	// First To Win 3 Legs	
    1544,	// First To Win 6 Legs	
    1545,	// First To Win 9 Legs	
    1546,	// 4th Period - 1st Roshan	
    1547,	// 5th Period - 1st Roshan	
    1548,	// 4th Period - 1st Barracks	
    1549,	// 5th Period - 1st Barracks	
    1550,	// 4th Period - 1st Tower	
    1551,	// 5th Period - 1st Tower	
    1552,	// Asian Under/Over Corners	
    1553,	// Both Teams To Score Number Of Points - 1st Period	
    1554,	// Both Teams To Score Number Of Points - 1st Half	
    1555,	// Under/Over 5th Period - Home Team	
    1556,	// Under/Over 5th Period - Away Team	
    1558,	// 핸디캡	10	{"Id":{"low":-888120761,"high":7135865,"unsigned":false},"Name":"1","Line":"-3.5","BaseLine":"-3.5","Status":1,"StartPrice":"1.85","Price":"1.85","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:42:30.421Z","ParticipantId":null}
    1559,	// Cup Winner	
    1561,	// 1st 3 Innings Winner	
    1562,	// 1st 3 Innings Under/Over	
    1563,	// Time Of Scoring	
    1564,	// Time Of Scoring - Home Team	
    1565,	// Time Of Scoring - Away Team	
    1566,	// Match Time Result	
    1567,	// Top Nationality - South African	
    1568,	// Top Nationality - Spaniard	
    1569,	// Top Nationality - Irish	
    1570,	// Top Nationality - South American	
    1571,	// Top Nationality - Canadian	
    1572,	// Top Nationality - Englishman	
    1573,	// Top Nationality - Continental European	
    1575,	// To Make Cut	
    1576,	// To Miss Cut	
    1577,	// Top Nationality - American	
    1578,	// Nationality Of Winner	
    1579,	// Asian Handicap Points - 1st Period	
    1580,	// Asian Handicap Points - 2nd Period	
    1581,	// Asian Handicap Points - 3rd Period	
    1583,	// Top Team Bowler 1st Inning - Home Team	
    1584,	// Top Team Bowler 1st Inning - Away Team	
    1585,	// Top Team Batsman 1st Inning - Home Team	
    1586,	// Top Team Batsman 1st Inning - Away Team	
    1587,	// Will there be an Ace Next Point 	
    1589,	// Will there be a Double Fault Next Point	
    1591,	// Under/Over - 1st Over	
    1592,	// To Win League	
    1593,	// To Win Division	
    1594,	// Most Hits - Including Overtime	
    1595,	// Fight to Go The Distance 	
    1596,	// When Will The Fight End	
    1597,	// Fight Outcome	
    1598,	// Round Betting	
    1599,	// Top 1st Hit	
    1600,	// Bottom 1st Hit	
    1601,	// Top 1st Run	
    1602,	// Bottom 1st Run	
    1603,	// Most Hits In The 1st Inning	
    1605,	// Team With Highest Scoring Inning	
    1606,	// Both Teams To Score 2 Or More Goals	
    1607,	// Both Teams To Score 3 Or More Goals	
    1608,	// Team To Win The Most Periods	
    1609,	// Asian Handicap Full Time - 1st Period	
    1610,	// Asian Handicap Full Time - 2nd Period	
    1611,	// Asian Handicap Full Time - 3rd Period	
    1612,	// MVP	
    1613,	// Regular Season Wins	
    1614,	// To Win Conference	
    1615,	// Winning Conference 	
    1616,	// Season Specials	
    1617,	// Season Player Specials	
    1618,	// 1st 5 Innings Winner - 12	
    1619,	// 1st Period - Halftime Winner Home/Away 	
    1620,	// 1st Period - Halftime Asian Handicap	
    1621,	// 2nd Period - Halftime Winner Home/Away	
    1622,	// 2nd Period - Halftime Asian Handicap	
    1624,	// Under/Over Player Runs	
    1625,	// Under/Over Player Singles	
    1626,	// Under/Over Player Home Runs	
    1627,	// Under/Over Player Stolen Bases	
    1628,	// Under/Over Player Doubles	
    1629,	// Under/Over Player Triples	
    1630,	// Pitcher To Record The Win	
    1631,	// Under/Over Player Total Bases	
    1635,	// Under/Over Pitcher Runs Earned	
    1636,	// Under/Over Pitcher Hits Allowed	
    1637,	// Under/Over Pitcher Strikeouts	
    1638,	// Team Classification	
    1639,	// Young Rider Classification	
    1640,	// Points Classification	
    1641,	// King of the Mountains	
    1642,	// Stage 1	
    1649,	// Fastest Lap	
    1650,	// Winning Car	
    1651,	// First Driver to Retire	
    1652,	//  Qualifying Winning Car	
    1653,	// Fastest in Practice 1	
    1654,	// Points Finish	
    1655,	// Fastest Qualifier	
    1657,	// Stage 3	
    1658,	// Stage 2	
    1659,	// First Constructor Retirement	
    1660,	// Grid Position of Winner	
    1661,	// Safety Car Period During Race	
    1662,	// Number of Classified Drivers	
    1663,	// Virtual Safety Car Period During Race	
    1664,	// Hole Score	
    1665,	// Player Scores - Specific Hole	
    1666,	// Player Matchups - Specific Hole	
    1667,	// To Win Hole	
    1668,	// Player Matchups - Specific Holes	
    1669,	// Player Scores - Specific Holes	
    1670,	// Tied Match	
    1671,	// Under/Over Goals - 2nd Period	
    1672,	// Under/Over Goals - 2nd Half	
    1673,	// Odd/Even Rounds 4th Period	
    1674,	// Odd/Even Rounds 5th Period	
    1675,	// 2nd Round Leader	
    1676,	// Both Teams to Score - Including Overtime	
    1677,	// Last Team to Score - Including Overtime	
    1678,	// Top Nationality - German	
    1679,	// Top Nationality - Austrian	
    1680,	// Top Nationality - New Zealander	
    1681,	// Top Left Handed Player	
    1682,	// Top Amateur	
    1683,	// Top Nationality - Korean	
    1684,	// Top Nationality - Scandinavian	
    1685,	// Top Nationality - Frenchman	
    1686,	// Top Former Winner	
    1687,	// Top Nationality - Swede	
    1688,	// Top Nationality - Japanese	
    1689,	// Top Nationality - Scotsman	
    1690,	// Top Nationality - Belgian	
    1691,	//  European Handicap 4th Period	
    1692,	// European Handicap 3rd Period	9	{"Id":176948151010525730,"Name":"1","Line":"0:1","BaseLine":"0:1","Status":1,"StartPrice":"1.0","Price":"2.13","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:57:42.582Z","ParticipantId":null}
    1693,	// European Handicap 2nd Period	9	{"Id":143295310610525730,"Name":"2","Line":"1:0","BaseLine":"0:1","Status":1,"StartPrice":"1.0","Price":"1.72","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:32:21.937Z","ParticipantId":null}
    1694,	// European Handicap 1st Period	9	{"Id":212532958910525730,"Name":"1","Line":"1:0","BaseLine":"1:0","Status":3,"StartPrice":"1.0","Price":"1.8","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":2,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:38:34.261Z","ParticipantId":null}
    1695,	// Round Score	
    1696,	// Tournament Winning Score	
    1697,	// Leading Score After Round	
    1698,	// To Hit The Fairway With Tee Shot	
    1699,	// To Hit Green In Regulation	
    1700,	// 3rd Round Leader	
    1701,	// 4th Round Leader	
    1702,	// Under/Over Player Passing Attempts	
    1703,	// Under/Over Player Passing Completions	
    1704,	// Touchdown on 1st Period	
    1705,	// Touchdown on 2nd Period	
    1706,	// Touchdown on 3rd Period	
    1707,	// Touchdown on 4th Period	
    1708,	// Under/Exactly/Over - Home Team Touchdowns 	
    1709,	// Under/Exactly/Over - Away Team Touchdowns 	
    1710,	// Under/Exactly/Over - Home Team 1st Half Touchdowns	
    1711,	// Under/Exactly/Over - Away Team 1st Half Touchdowns	
    1712,	// 16th Round Winner - 4th Period	
    1713,	// 16th Round Winner - 5th Period	
    1714,	// Under/Over Towers Destroyed - 4th Period	
    1715,	// Under/Over Towers Destroyed - 5th Period	
    1716,	// Most Regular Season Passing Yards	
    1717,	// Most Regular Season Receiving Yards	
    1718,	// Most Regular Season Rushing Yards	
    1719,	// Defensive Rookie Of The Year	
    1720,	// AP NFL Defensive Player of The Year	
    1721,	// Offensive Rookie of The Year	
    1722,	// Set to Finish to Nil	
    1723,	// Under/Over Kills - 1st Period - 1st Round	
    1724,	// Under/Over Kills - 2nd Period - 1st Round	
    1725,	// Under/Over Kills - 3rd Period - 1st Round	
    1726,	// Under/Over Kills - 4th Period - 1st Round	
    1727,	// Under/Over Kills - 5th Period - 1st Round	
    1728,	// Both Teams to Score - Extra Time	
    1729,	// Double Chance - Extra Time	
    1730,	// Will The Game Go To Super Over?	
    1731,	// Double Chance 5th Period	
    1732,	// Double Chance 6th Period	
    1733,	// Double Chance 7th Period	
    1734,	// Double Chance 8th Period	
    1735,	// Double Chance 9th Period	
    1736,	// Number of Runs 1st Inning	
    1737,	// Number of Runs 2nd Inning	
    1738,	// Number of Runs 3rd Inning	
    1739,	// Number of Runs 4th Inning	
    1740,	// Number of Runs 5th Inning	
    1741,	// Number of Runs 6th Inning	
    1742,	// Number of Runs 7th Inning	
    1743,	// Number of Runs 8th Inning	
    1744,	// A Fifty to be Scored in the 1st Innings	
    1745,	// Fall Of 1st Wicket	
    1746,	// To Score Most Runs	
    1747,	// Next Man Out	
    1748,	// Completed Match	
    1749,	// Century Scored	
    1750,	// Century Scored - 1st Inning	
    1751,	// Home Team First Dismissal 6-Way	
    1752,	// Away Team First Dismissal 6-Way	
    1753,	// Top Match Batsman	
    1754,	// To Score a Penalty	
    1755,	// To Win Conference - NBA Eastern Conference	
    1756,	// Coach of the Year	
    1757,	// Most Improved Player	
    1758,	// 6th Man of the Year	
    1759,	// Defensive Player of the Year	
    1760,	// Rookie of the Year	
    1761,	// Regular Season MVP	
    1762,	// Under/Exactly/Over - 4th Period Including Overtime	
    1763,	// Batsman to Score a Hundred in 1st Innings	
    1765,	// 9 Dart Finish in the match	
    1766,	// Time of First Try	
    1767,	// Time of Last Try	
    1770,	// 9 Dart Finish in the Match - Home Team 	
    1771,	// 9 Dart Finish in the Match - Away Team 	
    1772,	// Top Run Scorer	
    1773,	// Top Run Scorer - Home Team	
    1774,	// Top Run Scorer - Away Team	
    1775,	// Team of Top Run Scorer	
    1776,	// Under/Over Punts	
    1777,	// Under/Over Sacks	
    1778,	// Under/Over 1st Downs 	
    1779,	// 1st Team To Get A First Down	
    1780,	// 1st Half Under/Over Field Goals - Home Team	
    1781,	// 1st Half Under/Over Field Goals - Away Team	
    1782,	// Under/Exactly/Over - Field Goals 1st Half	
    1783,	// Under/Over Touchdowns 1st Period	
    1784,	// Under/Over Penalties Accepted	
    1785,	// Most Kills in the Match	
    1786,	// Team with Most Kills in the Match	
    1787,	// Under/Over Pass Attempts	
    1788,	//  Under/Over Pass Completions	
    1789,	// Under/Over Passing Yards	
    1790,	// Under/Over Rush Attempts	
    1791,	// Under/Over Rush Yards	
    1792,	// Under/Over Player Tackles and Assist	
    1793,	// Team to Score Punt First	
    1794,	// Team to Punt First	
    1795,	// 1st Period 1X2 And Under/Over	
    1796,	// 1X2 Assists	
    1797,	// Double Chance Assists	
    1798,	// Team to Lead After Every Period	
    1799,	// Team with Most Passing Yards	
    1800,	// Team with Most Rushing Yards	
    1801,	// Successful 2 Point Conversion	
    1802,	// Under/Over Touchdown Passes 	
    1803,	// Under/Over Field Goals 1st Period	
    1804,	// Score in Last 2 Minutes of the 1st Half	
    1805,	// Team to Receive Opening Kick Off	
    1806,	// Under/Over Home Team Touchdowns - 1st period	
    1807,	// Under/Over Away Team Touchdowns - 1st period	
    1808,	// Under/Exactly/Over Home Team Touchdowns - 1st period	
    1809,	// Under/Exactly/Over Away Team Touchdowns - 1st period	
    1810,	// Under/Over Home Team Field Goals - 1st period	
    1812,	// Under/Over Away Team Field Goals - 1st period	
    // 1813,	// Away Team to Win Every Quarter	
    // 1814,	// Home Team to Win Every Quarter	
    1815,	// First Offensive Play of the Game	
    // 1816,	// To Win Quarter	
    1817,	// To Reach the Final	
    1818,	// Home Team to Score 25 Goals	
    1819,	// Home Team to Score 30 Goals	
    1820,	// Away Team to Score 25 Goals	
    1821,	// Away Team to Score 30 Goals	
    1822,	// Home Team To Win Either Half	
    1823,	// Away Team To Win Either Half	
    1824,	// Stage of Elimination	
    1825,	// Under/Over Assists	
    1826,	// Under/Over Rebounds	
    1827,	// Under/Over Home team Assists	
    1828,	// Under/Over Away Team Assists	
    1829,	// Under/Over Home Team Rebounds	
    1830,	// Under/Over Away Team Rebounds	
    1831,	// 1X2 3 Points Made	
    1832,	// Under/Over 3 Points Made	
    1833,	// Under/Over Home Team 3 Points Made	
    1834,	// Under/Over Away Team 3 Points Made	
    1835,	// Asian Handicap 3 Points Made	
    1836,	// 1X2 and Double Chance - Corners	
    1837,	// 1X2 and Double Chance - Corners 1st Period	
    1838,	// 1X2 and Double Chance - Corners 2nd Period	
    1839,	// 1X2 and Double Chance Yellow Cards - 1st Period 	
    1840,	// 1X2 and Double Chance - Yellow Cards	
    1841,	// First Substitutions	
    1842,	// 2nd Goal in the match	
    1843,	// 3rd Goal in the match	
    1844,	// 4th Goal in the match	
    1845,	// 5th Goal in the match	
    1846,	// 60 Minute Result	
    1847,	// 75 Minute Result	
    1848,	// Goal Scored In The First 5 Minutes?	
    1849,	// First Throw-in in the Match	
    1850,	// Draw in Either Half	
    1851,	// Headed Goal in the Match?	
    1852,	// Under/Over Goal Minutes	
    1853,	// Under/Over Tie Break in the match	6	{"Id":59027925910507020,"Name":"Under","Line":"2.5","BaseLine":"2.5","Status":2,"StartPrice":"1.0","Price":"1.001","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:58:00.448Z","ParticipantId":null}
    1854,	// Under/Over Break points	
    1855,	// Under/Over Break Points Home Team	
    1856,	// Under/Over Break Points Away Team	
    // 1857,	// Under/Over Highest Scoring Quarter	
    // 1858,	// Under/Over Lowest Scoring Quarter	
    1859,	// Most Tries 3-Way	
    1860,	// 10 Minute Winning Margin 5-Way	
    1861,	// Most Losses Team	
    1862,	// A Sub Will score in the Game	
    1863,	// Win All Periods - Home Team	
    1864,	// Win All Periods - Away Team	
    1865,	// First 10 Minute Under/Over Tries	
    1866,	// 15 Minute Under/Over - Corners	
    1867,	// 2 Goals in a Row by Home Team	
    1868,	// 2 Goals in a Row by Away Team	
    1869,	// Most Converted Tries 	
    1870,	// Under/Over Saves	
    1871,	// 1X2 Saves	
    1872,	// Unseeded Finalist?	
    1873,	// Wild Card To Reach Final?	
    1874,	// Winning Half - Tennis Outright	
    // 1875,	// Winning Quarter - Tennis Outright	
    1876,	// 1X2 Rebounds	
    1877,	// Asian Handicap Rebounds	
    1878,	// Asian Handicap Assists	
    1881,	// Hole In One	
    1882,	// Will There Be a Play-off?	
    1883,	// 72 Hole Match Ups	
    1884,	// 54 Hole Match Ups	
    1885,	// Number 1 Draft Pick	
    1886,	// 1X2 and Double Chance	
    1887,	// Home Team to Win\Draw and Both teams to score	
    1888,	// Away Team to Win\Draw and Both teams to score	
    1889,	// Winning Margin - 1st Half	13	{"Id":94861379910512940,"Name":"Away 4-6","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"126.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T01:07:32.306Z","ParticipantId":null}
    1890,	// Under/Over 1st Innings 6 Over	
    1891,	// American League Cy Young	
    1892,	// American League MVP	
    1893,	// National League Cy Young	
    1894,	// National League MVP	
    1895,	// Pitcher To Record The Most Regular Season Wins	
    1896,	// Player To Hit The Most Regular Season Home Runs	
    1897,	// Will Game Decided in Extra Time?	
    1898,	// Regular season Winning %	
    1899,	// Point Betting	310	{"Id":51003222010512936,"Name":"2","Line":"29.0","BaseLine":"29.0","Status":2,"StartPrice":"1.0","Price":"1.833","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T00:40:53.849Z","ParticipantId":null}
    1900,	// Player Top Goalscorer	
    1901,	// Under/Over Tackles	
    1902,	// Number 2 Draft Pick	
    1903,	// Minor Premiership Winner	
    1904,	// Under/Over Tackles - Home Team	
    1905,	// Under/Over Tackles - Away Team	
    1906,	// First Offensive Lineman Drafted	
    1907,	// First Running Back Draft Pick	
    1908,	// First Wide Receiver Draft Pick	
    1909,	// First Quarterback Draft Pick	
    1910,	// Under\Over Quarterbacks Drafted in 1st Round	
    1911,	// PFA Player of the Year	
    1912,	// 1st Innings 6 Over Total	
    1913,	// 1st Innings Runs	
    1914,	// 2nd Innings Runs	
    1915,	// Season Race Wins	
    1916,	// Under/Over Fouls	
    1917,	// Under/Over Posts and Crossbars	
    1918,	// 1x2 Posts and Crossbars	
    1919,	// Under/Over Posts and Crossbars - Home Team	
    1920,	// Under/Over Posts and Crossbars - Away Team	
    1921,	//  Double Chance Posts and Crossbars	
    1922,	// Asian Handicap and Under/Over	
    1923,	// To Win Regional	
    1924,	// 1st Innings Runs - Home Team 	
    1925,	// 1st Innings Runs - Away Team 	
    1926,	// Under/Over - 1st Period - Goals	
    1927,	// Under/Over Goal Kicks	
    1928,	// Under/Over Goal Kicks - Home Team	
    1929,	// Under/Over Goal Kicks - Away Team	
    1930,	// Under/Over Saves - Home Team	
    1931,	// Under/Over Saves - Away Team	
    1932,	// Under/Over Ball Possession	
    1933,	// Under/Over Ball Possession - Home Team	
    1934,	// Under/Over Ball Possession - Away Team	
    1935,	// Score Draw?	
    1936,	// 1st Corner - 1st Period	
    1937,	// 1st Corner - 2nd Period	
    // 1938,	// To Reach the Quarter Finals	
    1940,	// Under/Over Corners between 15:01 Min to 30:00 min	
    1941,	// Under/Over Corners between 30:01 Min to Half Time	
    1942,	// Under/Over Corners between  Half Time to 60.00 Min	
    1943,	// Under/Over Corners between  60:01 Min to 75:00 Min	
    1944,	// Under/Over Corners between  75:01 Min to Full Time	
    1945,	// Will Hit the post or crossbar?	
    1946,	// Race To 2 Goals	
    1947,	// Race To 3 Goals	
    1948,	// Match Play H2H	
    1949,	// National League Rookie of the Year	
    1950,	// Most Regular Season Strikeouts	
    1951,	// Most Regular Season Stolen Bases	
    1952,	// Most Regular Season Saves	
    1953,	// Most Regular Season Runs Scored	
    1954,	// Most Regular Season RBIs	
    1955,	// Most Regular Season Hits	
    1956,	// American League Rookie of the Year	
    1957,	// Under/Over 1st Period Minutes	
    1958,	// Under/Over Match Minutes	
    1959,	// Under/Over Winning % on 1st Serve - Home Team	
    1960,	// Under/Over Winning % on 1st Serve - Away Team	
    1961,	// Under/Over Winning % on 2nd Serve - Home Team	
    1962,	// Under/Over Winning % on 2nd Serve - Away Team	
    1963,	// 1st Serve % Asian Handicap	
    1964,	// 1X2 Goal Kick	
    1965,	// Double Chance - Goal Kick	
    1966,	// Odd/Even Goal Kick	
    1967,	// Goal Kick Handicap	
    1968,	// Under/Over 10 Minute Penalties Scored	
    1969,	// Under/Over Penalties Scored	
    1970,	// Most Tries 2-Way	
    1971,	// 10 Minute Result 2-Way	
    1972,	// Regular Season Winner	
    1973,	// Under/Over Steals	
    1975,	// Under/Over Added Time - 1st Period	
    1976,	// Under/Over Added Time - 2nd Period	
    1977,	// Under/Over Distance Covered, km	
    1978,	// Under/Over Distance Covered, km - Home Team	
    1979,	// Under/Over Distance Covered, km - Away Team	
    1980,	// Under/Over Passes Completed % - Away Team	
    1981,	// Under/Over Passes Completed % - Home Team	
    1982,	// Under/Over Short Passes Completed % - Home Team	
    1983,	// Under/Over Short Passes Completed % - Away Team	
    1984,	// Under/Over Medium Passes Completed % - Home Team	
    1985,	// Under/Over Medium Passes Completed % - Away Team	
    1986,	// Under/Over Long Passes Completed % - Home Team	
    1987,	// Under/Over Long Passes Completed % - Away Team	
    1988,	// Under/Over Steals - Home Team	
    1989,	// Under/Over Steals - Away Team	
    1990,	// Under/Over Breaks	
    1991,	// Under/Over Breaks - Home team	
    1992,	// Under/Over Breaks - Away team	
    1993,	// Under/Over Breaks 1st Period	
    1994,	// Under/Over Breaks 1st Period - Home Team	
    1995,	// Under/Over Breaks 1st Period - Away Team	
    1996,	// Under/Over Free Throws Scored	
    1997,	// Under/Over Free Throws Scored - Home Team	
    1998,	// Under/Over Free Throws Scored - Away Team	
    1999,	// 3-Way Team With Highest Scoring Period 	
    2000,	// Fall Of 1st Wicket, 1st Inning	
    2001,	// Wicket in Over 1, 1st Innings?	
    2002,	// Most Runs in 1st 15 Overs?	
    2003,	// Under/Over 1st Over Runs Scored, 1st Innings 	
    2004,	// 1st Round 2 Balls	
    2005,	// Under/Over 2 Points Made	
    2006,	// Under/Over Home Team 2 Points Made	
    2007,	// Under/Over Away Team 2 Points Made	
    2008,	// Match Corners Between 	
    2009,	// Home Team Corners Between	
    2010,	// Away Team Corners Between	
    2011,	// Match Cards Between	
    2012,	// Home team Card Between	
    2013,	// Away Team Card Between	
    2014,	// Match Goal Between	
    2015,	// Home team Goal Between	
    2016,	// Away Team Goal Between	
    2017,	// All Periods Score Under	
    2018,	// All Periods Score Over	
    2019,	// All Periods Score Under - Home Team	
    2020,	// All Periods Score Over - Home Team	
    2021,	// All Periods Score Under - Away Team	
    2022,	// All Periods Score Over - Away Team	
    2023,	// Will Any Player Score a Double?	
    2024,	// Top Nationality - Italian	
    2025,	// More Tries Or Penalties	
    2026,	// Under/Over Blocked Shots	
    2027,	// Double Chance Blocked Shots	
    2028,	// Blocked Shots Handicap	
    2029,	// Under/Over Blocked Shots - Home Team	
    2030,	// Under/Over Blocked Shots - Away Team	
    2031,	// Under/Over Blocked Shots 1st period	
    2032,	// Blocked Shots Handicap 1st Period	
    2033,	// Under/Over Powerplay Goals	
    2034,	// Double Chance Powerplay Goals	
    2035,	// Powerplay Goals Handicap	
    2036,	// Under/Over Powerplay Goals - Home Team	
    2037,	// Under/Over Powerplay Goals - Away Team	
    2038,	// Under/Over Powerplay Goals 1st period	
    2039,	// Handicap Powerplay Goals 1st period	
    2040,	// Hits Handicap	
    2041,	// Double Chance Hits	
    2042,	// 1X2 Hits	
    2043,	// Under/Over Penalty time	
    2044,	// Double Chance Penalty time	
    2045,	// Penalty Time Handicap	
    2046,	// Under/Over Penalty Time - Home Team	
    2047,	// Under/Over Penalty Time - Away Team	
    2048,	// Under/Over Penalty Time 1st Period	
    2049,	// Penalty Time Handicap 1st Period	
    2050,	// Under/Over Win Face-Offs	
    2051,	// Double Chance Win Face-Offs	
    2052,	// Win Face-Offs Handicap	
    2053,	// Under/Over Win Face-Offs - Home Team	
    2054,	// Under/Over Win Face-Offs - Away Team	
    2055,	// Under/Over Win Face-Offs 1st Period	
    2056,	// Win Face-Offs Handicap 1st Period	
    2057,	// 1st 3 Innings Handicap	
    2058,	// Each Team to Score in All Periods	
    2059,	// Number Of Runs - Both Teams to Score 	
    2060,	// Under/Over Points Scored Including Overtime	
    2061,	// End of Round Leader	
    2062,	// 1X2 Steals	
    2063,	// Asian Handicap Steals	
    2064,	// Current Game - Correct Score	
    2065,	// First Linebacker Drafted	
    2066,	// First Safety Drafted	
    2067,	// First Cornerback Drafted	
    2068,	// Running Backs Drafted in 1st Round	
    2069,	// Offensive Linemen Drafted in 1st Round	
    2070,	// First Non QB Selected	
    2071,	// Cornerbacks Drafted in 1st Round	
    2072,	// Wide Receivers Drafted in 1st Round	
    2073,	// Number 3 Overall Pick	
    2074,	// Top 5 Pick	
    2075,	// Linebackers Drafted in 1st Round	
    2076,	// Tight Ends Drafted in 1st Round	
    2077,	// Offensive Players Drafted in 1st Round	
    2078,	// First Defensive Linesman Drafted	
    2079,	// Top 10 Pick 	
    2080,	// Defensive Linesmen Drafted in 1st Round	
    2081,	// Safeties Drafted in 1st Round	
    2082,	// 1X2 Powerplay Goals	
    2083,	// 1X2 Win Face-Offs	
    2084,	// 1X2 Penalty Time	
    2085,	// 1X2 shots On Goal	
    2086,	// 1X2 Blocked Shots	
    2087,	// Draft Position	
    2088,	// Team Players Drafted in 1st Round	
    2089,	// 1st 3 Innings Winner -12	
    2090,	// Podium Finish	
    2091,	// Under/Over Saves - Home Team 1st Period	
    2092,	// Under/Over Saves - Away Team 1st Period	
    2093,	// Under/Over Saves - Home Team 2nd Period	
    2094,	// Under/Over Saves - Away Team 2nd Period	
    2095,	// Asian Handicap Saves	
    2096,	// Asian Handicap Goal Kicks 1st Period	
    2097,	// Asian Handicap Goal Kicks 2nd Period	
    2098,	// Under/Over Goal Kicks - Home Team 1st Period	
    2099,	// Under/Over Goal Kicks  - Away Team 1st Period	
    2100,	// Under/Over Goal Kicks  - Home Team 2nd Period	
    2101,	// Under/Over Goal Kicks - Away Team 2nd Period	
    2102,	// Throw-ins Handicap - 2nd Period	
    2103,	// Odd/Even Saves	
    2104,	// Odd/Even Throw-Ins	
    2121,	// 2nd Round 18 Hole Match-Ups	
    2122,	// 3rd Round 18 Hole Match-Ups	
    2123,	// 4th Round 18 Hole Match-Ups	
    2124,	// Lowest scoring period	
    2125,	// 10 Minuets Corner?	
    2126,	// Asian Handicap Yellow Cards - 2nd Period	
    2127,	// Odd/Even Yellow cards	
    2128,	// Double Chance Fouls - 1st Period	
    2129,	// Double Chance Fouls - 2nd Period	
    2130,	// 1X2 Fouls - 1st Period	
    2131,	// 1X2 Fouls - 2nd Period	
    2132,	// Odd/Even Total Shots	
    2133,	// Double Chance Total Shots - 1st Period	
    2134,	// Double Chance Total Shots - 2nd Period	
    2140,	// Under/Over Total Shots - 2nd Period	
    2146,	// 1X2 Shots On Target 1st Period	
    2147,	// Double Chance Shots On Target 1st Period	
    2148,	// Under/Over Shots on Target Home Team 1st Period	
    2149,	// Under/Over Shots On Target Away Team 1st Period	
    2150,	// 1X2 Shots On Target 2nd Period	
    2151,	// Double Chance Shots On Target 2nd Period	
    2152,	// Under/Over Shots On Target 2nd Period	
    2153,	// Under/Over Shots on Target Home Team 2nd Period	
    2155,	// Odd/Even Shots On Target	
    2156,	// Group Betting	
    2157,	// Under/Over Goal Kicks 1st Period	
    2158,	// Under/Over Goal Kicks 2nd Period	
    2159,	// 1X2 Goal Kicks 1st Period	
    2160,	// 1X2 Goal Kicks 2nd Period	
    2161,	// Double Chance Saves	
    2162,	// 1X2 Saves 1st Period	
    2163,	// Double Chance Saves 1st Period	
    2164,	// Asian Handicap Saves 1st Period	
    2165,	// Under/Over Saves 1st Period	
    2166,	// 1X2 Saves 2nd Period	
    2167,	// Double Chance Saves 2nd Period	
    2168,	// Asian Handicap Saves 2nd Period	
    2170,	// Under/Over Saves 2nd Period	
    2171,	// First Driver to Make a Pit Stop	
    2172,	// Both Cars Points Finish	
    2173,	// 1X2 Offsides 1st Period	
    2174,	// 1X2 Offsides 2nd Period	
    2175,	// Double Chance Offsides 1st Period	
    2176,	// Double Chance Offsides 2nd Period	
    2177,	// Under/Over Offsides Home Team 1st Period	
    2178,	// Under/Over Offsides Away Team 1st Period	
    2179,	// Under/Over Offsides Home Team 2nd Period	
    2180,	// Under/Over Offsides Away Team 2nd Period	
    2181,	// 1X2 Throw-Ins 1st Period	
    2182,	// 1X2 Throw-Ins 2nd Period	
    2183,	// Double Chance Throw-Ins 1st Period	
    2184,	// Double Chance Throw-Ins 2nd Period	
    2185,	// Both Cars to be Classified	
    2186,	// To be Classified	
    2187,	// To Finish In Top 20	
    2188,	// To Make The Playoffs	
    2189,	// Not To Make The Playoffs	
    2190,	// Division of Super Bowl Winner Will be?	
    2191,	// Hits Handicap - 1st Inning	
    2192,	// Under/Over Hits - 1st Inning	
    2193,	// 1st Round Six Shooter	
    2194,	// Highest Scoring Team	
    2195,	// Lowest Scoring Team	
    2196,	// To Finish Bottom of Group	
    2197,	// UEFA Player of the Tournament	
    2198,	// Group Qualification Yes-No	
    2199,	// Eliminated by Penalty Shootout	
    2200,	// Finalists	
    2201,	// 8th Period Odd/Even	
    2202,	// 9th Period Odd/Even	
    2203,	// Series Winner - 12	
    2204,	// Winner and Top Goalscorer	
    2205,	// 1X2 Including Super Tie-Break	
    2206,	// Handicap Including Super Tie-Break	
    2207,	// Correct Score Including Super Tie-Break	
    2208,	// Under/Over Including Super Tie-Break	
    2209,	// Under/Over Throw-Ins - 2nd Period	
    2210,	// Player To Hit a Home Run	
    2211,	// Player To Record A Hit	
    2212,	// Player To Record 2 or More Hits	
    2213,	// Player To Record 3 or More Hits	
    2214,	// Player To Record 4 or More Hits	
    2215,	// First To Happen	
    2216,	// Heisman Trophy Winner	
    2217,	// To be a Play Off (Golf)	
    2218,	// Handicap Betting (Golf)	
    2219,	// Straight Forecast	
    2220,	// Winning Margin - Golf	
    2221,	// Under/Over Throw-Ins 2nd Period	
    2222,	// Under/Over Throw-Ins 1st Period - Home Team	
    2223,	// Under/Over Throw-Ins 1st Period - Away Team	
    2224,	// Under/Over Shots 1st Period - Away Team	
    2225,	// Under/Over Shots 1st Period - Home Team	
    2226,	// 1X2 Shots - 1st Period	
    2227,	// 1X2 Shots - 2nd Period	
    2228,	// Asian Handicap - Distance Covered, km 	
    2229,	// Double Chance Goal Kicks - 1st Period	
    2230,	// Double Chance Goal Kicks - 2nd Period	
    2231,	// Top Nationality - Mexican	
    2232,	// 1st Round Six Shooter - Group C	
    2233,	// 1st Round Six Shooter - Group D	
    2234,	// Winning Score 3-Way	
    2235,	// Lowest Tournament Round	
    2236,	// Top Nationality 1st Round - Top American	
    2237,	// Top Nationality 1st Round - Top Continental European	
    2238,	// Top Nationality 1st Round - Top Great Britain & Ireland	
    2239,	// 1st Round - Top 5 Winner	
    2240,	// 1st Round - Top 10 Winner	
    2241,	// 1st Round - Top 20 Winner	
    2242,	// Top Nationality - Danish	
    2243,	// Top Nationality - Welsh	
    2244,	// Most Gold Medals	
    2245,	// Most Medals	
    2246,	// Gold Medal Winner With Line	
    2247,	// Under/Over 1st Innings 6 Over - Home Team	
    2248,	// Under/Over 1st Innings 6 Over - Away Team	
    2249,	// Odd/Even 1st Innings 6 Over - Home Team	
    2250,	// Odd/Even 1st Innings 6 Over - Away Team	
    2251,	// Will The Match End In a Tie?	
    // 2252,	// To Win Quarter - 1st Quarter (Outright)	
    // 2253,	// To Win Quarter - 2nd Quarter (Outright)	
    // 2254,	// To Win Quarter - 3rd Quarter (Outright)	
    // 2255,	// To Win Quarter - 4th Quarter (Outright)	
    2256,	// Race To 50 Points	
    2257,	// Race To 10 Points	
    2258,	// Race To 30 Points	
    2259,	// Asian Handicap 2 Points Made	
    2260,	// Asian Handicap Free Throws Scored	
    2261,	// Double Chance Penalty time - 1st Period	
    2266,	// Under/Over Penalty Time Away Team - 1st Period	
    2267,	// Under/Over Penalty Time Home Team - 1st Period	
    2269,	// Double Chance Powerplay Goals - 1st Period	
    2270,	// Under/Over Powerplay Goals Away Team - 1st Period	
    2271,	// Under/Over Powerplay Goals Home Team - 1st Period	
    2272,	// Under/Over Runs	
    2273,	// 2nd Innings Runs - Home Team	
    2274,	// 2nd Innings Runs - Away Team	
    2275,	// Not To Reach Top 3	
    2277,	// HT/FT Extra Time	
    2278,	// Time Trial	
    2280,	// Under/Over Tries 1st Period	
    2281,	// Under/Over Tries 2nd Period	
    2282,	// Regular Season Wins - Outright	
    2284,	// Asian Under/Over Corners 1st Period	
    2285,	// Double Fault Handicap	
    2286,	// Corners Handicap - 2nd Half 	
    2288,	// Odd/Even Offsides	
    2289,	// Under/Over Fouls 1st Period - Home Team	
    2290,	// Under/Over Fouls 1st Period - Away Team	
    2296,	// Under/Over Player Fours - 1st Inning	
    2297,	// Under/Over Batsman Runs - 1st Inning	
    2298,	// Player Dismissal Method - 1st Inning	
    2299,	// Under/Over Spreads - Home team 1st Inning	
    2300,	// Under/Over Spreads - Away team 1st Inning	
    2301,	// Dismissal Method - Home Team	
    2302,	// Dismissal Method - Away Team	
    2303,	// Dismissal Method - Home Team 1st Inning	
    2304,	// Dismissal Method - Away Team 1st Inning	
    2305,	// Under/Over Runs After Overs - Home Team 1st Inning	
    2306,	// Under/Over Runs After Overs - Away Team 1st Inning	
    2307,	// Under/Over Dismissal - Home Team 1st Inning	
    2308,	// Under/Over Dismissal - Away Team 1st Inning	
    2309,	// To Score - Player - 1st Inning	
    2310,	// Dismissal in Over 1st Inning - Home Team	
    2311,	// Dismissal in Over 1st Inning - Away Team	
    2313,	// Under/Over Runs in Delivery of Over - Home Team 1st Inning	
    2314,	// Under/Over Runs in Delivery of Over - Away Team 1st Inning	
    2334,	// Asian Handicap Break Points	
    2335,	// Most Break Points	
    2336,	// Most Breaks	
    2337,	// Asian Handicap Breaks 	
    2338,	// Team To Make Next Score - 12	
    2339,	// Under/Over Goals - 1st Half	
    2340,	// Under/Over Goals	
    2341,	// 1X2 Home Runs	
    2342,	// Asian Handicap Home Runs 	
    2343,	// Under/Over Home Runs	
    2344,	// Under/Over Home Runs - Away Team	
    2345,	// Under/Over Home Runs - Home Team	
    2346,	// Under/Over Home Runs - 1st Inning	
    2347,	// 1X2 Home Runs - 1st Inning	
    2348,	// Asian Handicap Home Runs - 1st Inning	
    2349,	// Under/Over Home Runs - Away Team 1st Inning	
    2350,	// Under/Over Home Runs - Home Team 1st Inning	
    2351,	// Under/Over Player Shots On Target	
    2352,	// Under/Over Player Tackles 	
    2353,	// Tie-Break Winner - 1st Period	
    2354,	// Tie-Break Winner - 2nd Period	
    2355,	// Tie-Break Winner - 3rd Period	
    2356,	// Enhanced Win Only	
    2357,	// Best Regular Season Record	
    2358,	// Comeback Player of the Year	
    2359,	// Home To Win a Set	
    2360,	// Away To Win a Set	
    2361,	// Young Player of the Year	
    2362,	// League Winner Without a Team	
    2363,	// Winning Manufacturer	
    2364,	// Under/Over 1st serve % -  Away Team	
    2365,	// Under/Over 1st serve % -  Home Team	
    2366,	// Double Result - 1st Period\Match Without Draw	4	{"Id":95035035410507020,"Name":"1/2","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"21.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:58:39.202Z","ParticipantId":null}
    2367,	// Next Score Type - With Line	
    2368,	// Team To Make Next Score - With Line	
    2372,	// 1X2 Yellow Cards - 2nd Period 	
    2373,	// Double Chance Yellow Cards - 2nd Period 	
    2374,	// Half With Most Yellow Cards	
    2375,	// Under/Over Fouls 2nd Period - Home Team 	
    2376,	// Under/Over Fouls 2nd Period - Away Team 	
    2377,	// Under/Over Shots on Target Away Team 2nd Period	
    2378,	// Under/Over Shots 2nd Period - Home Team	
    2379,	// Under/Over Shots 2nd Period - Away Team	
    2380,	// Under/Over Throw-Ins 2nd Period - Home Team 	
    2381,	// Under/Over Throw-Ins 2nd Period - Away Team 	
    2382,	// Group Round Betting 	
    2383,	// 1st Period - Most Clutches Won	
    2384,	// 2nd Period - Most Clutches Won	
    2385,	// 3rd Period - Most Clutches Won	
    2386,	// 4th Period - Most Clutches Won	
    2387,	// 5th Period - Most Clutches Won	
    2388,	// 1st Period - 1st Half - Correct Score	
    2389,	// Asian Handicap - 1st Period - 1st Half 	
    2390,	// 2nd Period - 1st Half - Correct Score	
    2391,	// Asian Handicap - 2nd Period - 1st Half 	
    2392,	// 3rd Period - 1st Half - Correct Score	
    2393,	// Asian Handicap - 3rd Period - 1st Half 	
    2394,	// 4th Period - 1st Half - Correct Score	
    2395,	// Asian Handicap - 4th Period - 1st Half 	
    2396,	// 5th Period - 1st Half - Correct Score	
    2397,	// Asian Handicap - 5th Period - 1st Half 	
    2398,	// Fight Outcome Inc. Submission 	
    2399,	// Under/Over Pitcher Outs	
    2400,	// Under/Over Player Passing Yards	
    2401,	// Under/Over Player Touchdown Receptions	
    2402,	// A Run in the 1st Inning	
    2403,	// Next Score Type With Line	
    2404,	// Under/Over Rounds - 4th Period	
    2405,	// Under/Over Rounds - 5th Period	
    2406,	// 1X2 Penalty Time 1st period	
    2407,	// 1X2 Powerplay Goals 1st Period	
    2408,	// Asian Handicap Puck Line - 1st Period 	
    2409,	// Asian Handicap Puck Line - 2nd Period 	
    2410,	// Asian Handicap Puck Line - 3rd Period 	
    2411,	// Asian Handicap Puck Line Including Overtime	
    2412,	// To Score In Every Period	
    2413,	// First Scoring Play - 2nd Half	
    2414,	// Team to Score last - 1st half	
    2415,	// Both Teams to score Touchdown in Each Half	
    2416,	// Both Teams to score 2+ Touchdowns in Each Half	
    2417,	// Both Teams to score 3+ Touchdowns in Each Half	
    2418,	// Both Teams to score 4+ Touchdowns in Each Half	
    2419,	// First to take down 1st Barracks	
    2420,	// 1st Period - Most First Kills	
    2421,	// 2nd Period - Most First Kills	
    2422,	// 3rd Period - Most First Kills	
    2424,	// 1st Drive Result	
    2425,	// 2nd Drive Result	
    2426,	// 3rd Drive Result	
    2427,	// Double Chance - Yes\No	
    2430,	// Under/Over Bombs Plants 1st Period 	
    2431,	// Under/Over Bombs Plants 2nd Period	
    2432,	// Under/Over Bombs Plants 3rd Period	
    2433,	// Under/Over Bombs defuse 1st Period 	
    2434,	// Under/Over Bombs Defuse 2nd Period 	
    2435,	// Under/Over Bombs Defuse 3rd Period 	
    2436,	// Win Inside Distance -12	
    2437,	// Fight Wins in Distance	
    2438,	// 2nd Period - 1st Half Winner 	
    2439,	// Under/Over Bombs Defuse 1st Period - 1st Half	
    2440,	// 1st Period - 1st Half Winner	
    2441,	// 3rd Period - 1st Half Winner	
    2442,	// Under/Over Bombs Plants 1st Period  - 1st Half	
    2443,	// Under/Over Bombs Plants 2nd Period - 1st Half	
    2444,	// Under/Over Bombs Plants 3rd Period  - 1st Half	
    2445,	// Under/Over Bombs Defuse 1st Period  - 1st Half	
    2446,	// Under/Over Bombs Defuse 2nd Period  - 1st Half	
    2447,	// Under/Over Bombs Defuse 3rd Period  - 1st Half	
    2448,	// Double Chance Corners - 2nd Period 	
    2449,	// Under/Over Player Defensive Assists	
    2450,	// Under/Over Player Defensive Tackles	
    2451,	// 2nd Round 3 Balls	
    2452,	// 3rd Round 3 Balls	
    2453,	// 4th Round 3 Balls	
    2456,	// To Win Outright	
    2457,	// Towers Handicap - 1st Period	
    2458,	// Towers Handicap - 2nd Period	
    2459,	// Towers Handicap - 3rd Period	
    2460,	// Roshan Handicap - 1st Period	
    2461,	// Roshan Handicap - 2nd Period	
    2462,	// Roshan Handicap - 3rd Period	
    2463,	// Aegis Steal - 1st period	
    2464,	// Aegis Steal - 2nd period	
    2465,	// Aegis Steal - 3rd period	
    2466,	// Under/Over Roshans - 1st period	
    2467,	// Under/Over Roshans - 2nd period	
    2468,	// Under/Over Roshans - 3rd period	
    2469,	// Under/Over Roshans - 4th period	
    2470,	// Towers Handicap - 4th Period	
    2471,	// Roshan Handicap - 4th Period	
    2472,	// Aegis Steal - 4th period	
    2473,	// Under/Over Barraks - 1st Period	
    2474,	// Under/Over Barraks - 2nd Period	
    2475,	// Under/Over Barraks - 3rd Period	
    2476,	// Under/Over Barraks - 4th Period	
    2477,	// Race To Kills - 4th Period	
    2478,	// Home Team to win At Least 1 Period	
    2479,	// Away Team to win At Least 1 Period	
    2480,	// Both teams to Destroy a Barraks - 1st Period 	
    2481,	// Both teams to Destroy a Barraks - 2nd Period 	
    2482,	// Both teams to Destroy a Barraks - 3rd Period 	
    2483,	// Both teams to Destroy a Barraks - 4th Period	
    2484,	// Both teams to Slay a Roshan - 1st Period 	
    2485,	// Both teams to Slay a Roshan - 2nd  Period 	
    2486,	// Both teams to Slay a Roshan - 3rd Period 	
    2487,	// Both teams to Slay a Roshan - 4th Period 	
    2488,	// Top Bowler 	
    2489,	// Top Batter	
    2490,	// Top Team Bowler	
    2491,	// Top Team Batsman	
    2492,	// Team with highest innings score	
    2493,	// Under\Over Player Longest Rushing Attempt	
    2494,	// National League Winner 	
    2495,	// American League Winner	
    2496,	// Player to Score at least 1 Point - Including Overtime	
    2497,	// Player to Score at least 2 Point - Including Overtime	
    2498,	// Player to Score at least 3 Point - Including Overtime	
    2499,	// 1X2 and Double Chance - 1st Period	
    2500,	// NCAAF FCS - Outright Winner	
    2501,	// NCAAF FBS - Outright Winner	
    2502,	// Top Goaltender Player	
    2503,	// President's Trophy Winner	
    2504,	// Jack Adams Award Winner	
    2505,	// Exact Number Of Goals 	
    2506,	// Number of Field Goals	
    2508,	// When the fight ends	
    2510,	// Winning Conference - East / West	
    2511,	// Winning Conference - NFC / AFC	
    2512,	// Hart Trophy Winner - MVP	
    2513,	// Vezina Trophy Winner - Best Goalkeeper 	
    2515,	// James Norris Memorial Trophy Winner - Best Defensive Player	
    2516,	// Calder Memorial Trophy Winner - Best Season Rookie	
    2517,	// Maurice Rocket Richard Trophy Winner - Top GoalScorer	
    2518,	// Jack Adams Award Winner - Best Coach	
    2519,	// To Win the Division	
    2520,	// Winning Nation	
    2521,	// Winning Division	
    2522,	// Atlantic Coast Conference Winner	
    2523,	// Big 12 Conference Winner	
    2524,	// Pacific 12 Conference Winner	
    2525,	// Big East Conference Winner	
    2526,	// Big 10 Conference Winner	
    2527,	// Southeastern Conference Winner	
    2528,	// AFC Championship Winner	
    2529,	// NFC Championship Winner	
    2530,	// To Make The Final Four	
    2531,	// To Win Conference - NBA Western Conference	
    2532,	// John R. Wooden Award	
    2533,	// To Win Conference - Eastern Conference	
    2534,	// To Win Conference - Western Conference	
    2535,	// Race To 5 Kills - 1st Period	
    2536,	// Race To 10 Kills - 1st Period	
    2537,	// Race To 15 Kills - 1st Period 	
    2538,	// Race To 20 Kills - 1st Period 	
    2539,	// Under/Over Player Double Double 	
    2540,	// Points Scored In The First 7:30 Minutes?	
    2541,	// Under/Over Touchdowns Scored - 2nd Half	
    2542,	// Under/Over Home Team Touchdowns - 2nd Half	
    2543,	// Under/Over Away Team Touchdowns - 2nd Half	
    2544,	// Both Teams to Score 10 Points 	
    2545,	// Both Teams to Score 15 Points	
    2546,	// Both Teams to Score 20 Points 	
    2547,	// Both Teams to Score 25 Points	
    2548,	// Both Teams to Score 30 Points	
    2549,	// Both Teams to Score 35 Points	
    2550,	// Both Teams to Score 40 Points	
    2551,	// First Scoring Play by Home team	
    2552,	// First Scoring Play by Away team	
    2553,	// Finish Exactly 2nd Place	
    2554,	// Finish Exactly 3rd Place	
    2555,	// Finish Exactly 4th Place	
    2556,	// Away Team Points Range	
    2557,	// Home Team Points Range	
    2558,	// Home Team - Goal Range (0-2+) 	
    2559,	// Home Team - Goal Range (0-3+) 	
    2560,	// Away Team - Goal Range (0-2+)	
    2561,	// Away Team - Goal Range (0-3+)	
    2562,	// 1st Period - Goal Range (0-2+) 	
    2563,	// 1st Period - Goal Range (0-3+) 	
    2564,	// 2nd Period - Goal Range (0-2+) 	
    2565,	// 2nd Period - Goal Range (0-3+) 	
    2566,	// 1st Period - Extra Points?	
    2567,	// Test	
    2568,	// Under/Over Centuries	
    2569,	// Points Range 1st Half - Home team 	
    2570,	// Points Range 1st Half - Away team 	
    2571,	// Points Range - Halftime	
    2572,	// Odd/Even Halftime - Home Team	
    2573,	// Odd/Even Halftime - Away Team	
    2574,	// 1st Period - 1st To Slay Rift Herald	
    2575,	// 1st Period - First Dragon to Spawn	
    2576,	// 2nd Period - First Dragon to Spawn	
    2577,	// 3rd Period - First Dragon to Spawn	
    2578,	// 1st Period 1X2 And Both Teams To Score	
    2579,	// Number of Touchdowns - 1st Half 	
    2580,	// Number of Touchdowns 11-Way	
    2581,	// Under/Over Home Team - Touchdowns 2nd Half Including OT	
    2582,	// Under/Over Away Team - Touchdowns 2nd Half Including OT	
    2583,	// Under/Over With Score	
    2584,	// Mid-American Conference Winner	
    2585,	// Mountain West Conference Winner	
    2586,	// Big West Conference Winner	
    2587,	// Southwestern Athletic Conference Winner	
    2588,	// Conference USA Winner	
    2589,	// Ivy League Conference Winner	
    2590,	// Western Athletic Conference Winner	
    2591,	// Metro Atlantic Athletic Conference Winner	
    2592,	// Mid-Eastern Athletic Conference Winner 	
    2593,	// Big Sky Conference Winner	
    2594,	// West Coast Conference Winner	
    2595,	// Southland Conference Winner	
    2596,	// Horizon League Conference Winner	
    2597,	// American Athletic Conference Winner	
    2598,	// America East Conference Winner	
    2599,	// Under/Over With Score - 1st Peiod 	
    2600,	// Atlantic 10 Conference Winner	
    2601,	// Under / & Over - 1st Period	
    2602,	// Under / & Over - 2nd Period	
    2603,	// Under / & Over - 3rd Period	
    2604,	// Under / & Over - 4th Period	
    2605,	// Under / & Over - 5th Period	
    2606,	// Under / & Over - 6th Period	
    2607,	// Under / & Over - 7th Period	
    2608,	// Under / & Over - 8th Period	
    2609,	// Under / & Over - 9th Period	
    2610,	// Under / & Over - 10th Period	
    2611,	// Under / & Over - 11th Period	
    2612,	// Under / & Over - 12th Period	
    2613,	// Under / & Over - 13th Period	
    2614,	// Under / & Over - 14th Period	
    2615,	// Under / & Over - 15th Period	
    2616,	// Under / & Over - 16th Period	
    2617,	// Under / & Over - 17th Period	
    2618,	// Under / & Over - 18th Period	
    2619,	// Under / & Over - 19th Period	
    2620,	// Under / & Over - 20th Period	
    2621,	// Under / & Over - 21th Period	
    2622,	// Under / & Over - 22th Period	
    2623,	// Under / & Over - 23th Period	
    2624,	// American League West - Winner	
    2625,	// American League Central - Winner	
    2626,	// American League East - Winner	
    2627,	// National League Central - Winner	
    2628,	// National League East - Winner	
    2629,	// National League West - Winner	
    2630,	// Antepost	
    2631,	// Season Match Bets	
    2632,	// No Runner No Bet	
    2637,	// Top Golfer by Category	
    2638,	// Podium	
    2639,	// Stage 4	
    2640,	// Stage 5	
    2641,	// Stage 6	
    2642,	// Stage 7	
    2643,	// Stage 8	
    2644,	// 1st 5 Innings Under/Over - Home Team	
    2645,	// 1st 5 Innings Under/Over - Away Team	
    2646,	// To Reach Semi Finals	
    2647,	// Runner Up 	
    2648,	// Winning Confederation	
    2649,	// First Time Winner?	
    2650,	// Under/Over Inhibitors - 3rd Period 	
    2651,	//  Most Outstanding Player	
    2652,	// Match Centuries - Home Team	
    2653,	// Enhanced Winner	
    2654,	// Top 30 Finish	
    2655,	// Top 40 Finish	
    2656,	// To Make the Cut 	
    2657,	// Group A Betting	
    2658,	// Group B Betting	
    2659,	// Group C Betting	
    2660,	// Group D Betting	
    2661,	// Group E Betting	
    2662,	// Group F Betting	
    2663,	// Group G Betting	
    2664,	// 2nd Period - 1st To Slay Rift Herald	
    2665,	// 3rd Period - 1st To Slay Rift Herald	
    2666,	// To be in Finals Squad (Outright)	
    2667,	// Defensive Players Drafted in 1st Round	
    2668,	// Race Match-Ups	
    2669,	// Stage 1 Match-Ups	
    2670,	// Stage 2 Match-Ups	
    2671,	// Under/Over Centuries - Home Team	
    2672,	// Under/Over Centuries - Away Team	
    2673,	// AP NFL Offensive Player of The Year	
    2674,	// Driver Lap 10 Leader	
    2675,	// Corners Handicap With Score	
    2676,	// Match Centuries - Away Team	
    2677,	// Next 1 minute - Throw-In	
    2678,	// Next 1 minute - Free-Kick	
    2679,	// Next 1 minute - Card	
    2680,	// Next 1 minute - Corner	
    2681,	// Next 1 minute - Goal	
    2682,	// Next 5 minute - Penalty	
    2683,	// Next 5 minute - Corner	
    2684,	// Next 5 minute - Goal	
    2685,	// What will happen First? - Next 1 Minute	
    2686,	// What will happen First? - Next 5 Minute	
    2687,	// Next 1 minute - Goal-Kick	
    2688,	// Game Winner, Set	
    2689,	// Under/Over Player Points - High	
    2690,	// Under/Over Player Points - Low	
    2691,	// Under/Over Pitcher Hits	
    2692,	// Under/Over Player RBIs	
    2694,	// Winning Margin - Teams With Any Other Score, Inc. OT	
    2695,	// Will There Be a Deciding Period?	
    2696,	// Northwest Division Winner	
    2697,	// Atlantic Division Winner	
    2698,	// Pacific Division Winner	
    2699,	// Central Division Winner	
    2700,	// Southeast Division Winner	
    2701,	// Southwest Division Winner	
    2702,	// NFC North - Division Winner	
    2703,	// NFC East - Division Winner	
    2704,	// NFC West - Division Winner	
    2705,	// NFC South - Division Winner	
    2706,	// AFC South - Division Winner	
    2707,	// AFC North - Division Winner	
    2708,	// AFC West - Division Winner	
    2709,	// AFC East - Division Winner	
    2721,	// test1	
    2722,	// test2	
    2723,	// test3	
    2732,	// Asian Handicap - 1st Period	18	{"Id":67504949810529120,"Name":"1","Line":"-1.25","BaseLine":"-1.25","Status":2,"StartPrice":"1.0","Price":"2.865","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:53:33.252Z","ParticipantId":null}
    2733,	// 12 And Under/Over - Including Overtime	
    2734,	// Under/Over Player Passes	
    2736,	// Under/Over Runs After Overs - Home Team	
    2737,	// Under/Over Runs After Overs - Away Team	
    2738,	// To Make Playoffs - Eastern Conference	
    2739,	// To Make Playoffs - Western Conference	
    2740,	// First Player to Score Basket	
    2741,	// Team With Highest Scoring Period - 3-Way	
    2742,	// Correct Score by Any Player - 1st Period	
    2743,	// Correct Score by Any Player - 2nd Period	
    2744,	// Correct Score by Any Player - 3rd Period	
    2745,	// Correct Score by Any Player - 4th Period	
    2746,	// Correct Score by Any Player - 5th Period	
    2747,	// 2nd Period - Multiple Correct Score	
    2748,	// Winner of Next Two Games	
    2749,	// Next Two Games – Either Game to Deuce?	
    2750,	// Corners Handicap - 1st Period With Score	
    156,	    // Under/Over 2nd Period - Away Team	6	{"Id":52893392410507020,"Name":"Under","Line":"6.5","BaseLine":"6.5","Status":2,"StartPrice":"1.0","Price":"1.47","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:23:49.348Z","ParticipantId":null}

]

//------------------------------------------------------------------------------
export const EsportsMainMarketData = [
    // 1, //승무패
    // 2, //오버언더
    // 3, //핸디캡 
    // 5, //홀짝
    // 7, //더블 찬스 
    // 52, //승패
    // // 226, //승패
    // 101, //언더오버 <홈팀>
    // 102, //언더오버 <원정팀>
    // 149, //홈팀 득점수
    // 150, //원정팀 득점수
    // 322, //정확한 오버언더
    1,	    // 승무패	3	{"Id":{"low":-1671467999,"high":40824458,"unsigned":false},"Name":"1","Line":null,"BaseLine":null,"Status":1,"StartPrice":"2.8","Price":"2.99","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:43:31.317Z","ParticipantId":null}
    52,	    // 승패	2	{"Id":{"low":1005511201,"high":13798009,"unsigned":false},"Name":"1","Line":null,"BaseLine":null,"Status":1,"StartPrice":"1.909","Price":"2.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:08:32.857Z","ParticipantId":null}
    2,	    // 오버언더	26	{"Id":{"low":-419037663,"high":19580342,"unsigned":false},"Name":"Over","Line":"2.5","BaseLine":"2.5","Status":1,"StartPrice":"1.668","Price":"1.71","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:43:31.317Z","ParticipantId":null}
    3,	    // 핸디캡	34	{"Id":{"low":-2109679583,"high":14362612,"unsigned":false},"Name":"1","Line":"1.75 (0-0)","BaseLine":"1.75 (0-0)","Status":1,"StartPrice":"1.112","Price":"1.122","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:43:31.317Z","ParticipantId":null}
    // 4,	    // 전반전 및 풀타임	
    5,	    // 홀짝	2	{"Id":171056844310507040,"Name":"Even","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"3.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:09:32.328Z","ParticipantId":null}
    // 6,	    // 정확한스코어	4	{"Id":163598667610507040,"Name":"2-0","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:58:39.202Z","ParticipantId":null}
    7,	    // 더블찬스	3	{"Id":115605479010529120,"Name":"1X","Line":null,"BaseLine":null,"Status":1,"StartPrice":"1.0","Price":"1.184","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:38:06.650Z","ParticipantId":null}
    // 9,	    // 정확한스코어 [1 피리어드]	14	{"Id":52135507510507020,"Name":"0-6","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"21.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:28:23.753Z","ParticipantId":null}
    // 11,	    // 코너 합계	
    // 12,	    // 파울 합계	
    // 13,	    // 유럽 핸디캡	3	{"Id":158830754310529120,"Name":"2","Line":"1:0","BaseLine":"0:1","Status":2,"StartPrice":"1.0","Price":"2.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:52:07.711Z","ParticipantId":null}
    16,	    // 첫 득점팀	
    // 17,	    // 양팀 모두득점	2	{"Id":130851972410529120,"Name":"No","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"2.75","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:52:07.711Z","ParticipantId":null}
    19,	    // 첫 카드	
    21,	    // 오버언더 전반전	14	{"Id":{"low":-1150875615,"high":37465254,"unsigned":false},"Name":"Over","Line":"2.0","BaseLine":"2.0","Status":1,"StartPrice":"4.64","Price":"4.74","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:43:31.317Z","ParticipantId":null}
    // 22,	    // 원정팀 득점	
    // 23,	    // 홈팀 득점	
    // 25,	    // 더블찬스 [전반전]	
    28,	    // 오버언더_연장포함	18	{"Id":5814717310516551,"Name":"Under","Line":"9.5","BaseLine":"9.5","Status":1,"StartPrice":"1.15","Price":"1.15","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T05:54:42.295Z","ParticipantId":null}
    29,	    // 언더오버 - 라운드	
    30,	    // 언더오버 - 코너 [홈팀]	
    31,	    // 언더오버 - 코너 [원정팀]	
    34,	    // 홈팀 득점 [전반후반]	
    35,	    // 원정팀 득점 [전반후반]	
    // 41,	    // 승무패 전반전	3	{"Id":{"low":1419017249,"high":32703296,"unsigned":false},"Name":"2","Line":null,"BaseLine":null,"Status":1,"StartPrice":"2.8","Price":"2.94","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:43:31.317Z","ParticipantId":null}
    // 42,	    // 승무패 [2 피리어드]	3	{"Id":186168072710517760,"Name":"X","Line":null,"BaseLine":null,"Status":3,"StartPrice":"1.0","Price":"13.3","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:48.352Z","ParticipantId":null}
    // 43,	    // 승무패 [3 피리어드]	3	{"Id":175295516610512930,"Name":"1","Line":null,"BaseLine":null,"Status":3,"StartPrice":"1.0","Price":"1.4","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":2,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:02:13.263Z","ParticipantId":null}
    // 44,	    // 승무패 [4 피리어드]	3	{"Id":55417015610512936,"Name":"2","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"3.8","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:12:37.609Z","ParticipantId":null}
    // 45,	    // 언더오버 [2 피리어드]	12	{"Id":54648981010507020,"Name":"Over","Line":"8.5","BaseLine":"8.5","Status":2,"StartPrice":"1.0","Price":"1.01","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:12:11.729Z","ParticipantId":null}
    // 46,	    // 언더오버 [3 피리어드]	12	{"Id":23938273810507028,"Name":"Under","Line":"10.5","BaseLine":"10.5","Status":3,"StartPrice":"1.0","Price":"3.4","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:34.361Z","ParticipantId":null}
    // 47,	    // 언더오버 [4 피리어드]	24	{"Id":82031954010517780,"Name":"Over","Line":"33.5","BaseLine":"33.5","Status":1,"StartPrice":"1.0","Price":"2.464","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:16:17.188Z","ParticipantId":null}
    // 48,	    // 언더오버 [5 피리어드]	
    // 49,	    // 승무패 [5 피리어드]	
    50,	    // 승무패 [연장포함]	
    51,	    // 홀짝 [연장포함]	2	{"Id":7547284410517773,"Name":"Odd","Line":null,"BaseLine":null,"Status":1,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:26:05.116Z","ParticipantId":null}
    // 53,	    // 핸디캡 [전반전]	40	{"Id":12913579210517772,"Name":"1","Line":"9.5 (0-0)","BaseLine":"9.5 (0-0)","Status":3,"StartPrice":"1.0","Price":"3.58","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:48.352Z","ParticipantId":null}
    // 55,	    // 첫득점팀 [1 피리어드]	
    // 56,	    // 마지막득점팀	
    // 57,	    // 마지막득점팀 [전반전]	
    59,	    // 다음득점	3	{"Id":99850833010529120,"Name":"1","Line":"1.0","BaseLine":"1.0","Status":1,"StartPrice":"1.0","Price":"1.765","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:38:14.646Z","ParticipantId":null}
    // 61,	    // 유럽 핸디캡 [전반전]	3	{"Id":189818325010529120,"Name":"1","Line":"0:1","BaseLine":"0:1","Status":2,"StartPrice":"1.0","Price":"4.5","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:52:07.711Z","ParticipantId":null}
    // 62,	    // 홀짝 [전반전]	2	{"Id":111599954910517780,"Name":"Even","Line":null,"BaseLine":null,"Status":3,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:48.352Z","ParticipantId":null}
    // 63,	    // 승패 [전반전]	2	{"Id":51993559610512936,"Name":"1","Line":null,"BaseLine":null,"Status":3,"StartPrice":"1.0","Price":"1.007","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":2,"ProviderBetId":null,"LastUpdate":"2023-04-26T01:21:43.261Z","ParticipantId":null}
    // 64,	    // 핸디캡 전반전	18	{"Id":{"low":2002385697,"high":41637933,"unsigned":false},"Name":"2","Line":"1.5 (0-0)","BaseLine":"-1.5 (0-0)","Status":1,"StartPrice":"1.035","Price":"1.03","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:43:31.317Z","ParticipantId":null}
    // 65,	    // 핸디캡 [2 피리어드]	6	{"Id":167006010210507040,"Name":"2","Line":"1.5 (0-0)","BaseLine":"-1.5 (0-0)","Status":2,"StartPrice":"1.0","Price":"1.8","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:24:52.719Z","ParticipantId":null}
    // 66,	    // 핸디캡 [3 피리어드]	8	{"Id":1811514110507028,"Name":"2","Line":"1.5 (0-0)","BaseLine":"-1.5 (0-0)","Status":2,"StartPrice":"1.0","Price":"1.064","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:09:38.222Z","ParticipantId":null}
    // 67,	    // 핸디캡 [4 피리어드]	16	{"Id":13422452810517772,"Name":"2","Line":"-2.5 (0-0)","BaseLine":"2.5 (0-0)","Status":1,"StartPrice":"1.0","Price":"2.005","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:16:17.188Z","ParticipantId":null}
    // 68,	    // 핸디캡 [5 피리어드]	
    69,	    // 연장전 발생	2	{"Id":202657557110512930,"Name":"No","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.004","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T01:46:15.068Z","ParticipantId":null}
    // 70,	    // 최고득점 피리어드	
    71,	    // 최고득점 하프	3	{"Id":59075605510512936,"Name":"1st Half","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"2.7","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:11:05.267Z","ParticipantId":null}
    // 72,	    // 홀짝 [1 피리어드]	2	{"Id":12863882110517772,"Name":"Odd","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:42:39.161Z","ParticipantId":null}
    // 73,	    // 홀짝 [2 피리어드]	2	{"Id":141408646210517780,"Name":"Even","Line":null,"BaseLine":null,"Status":3,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:48.352Z","ParticipantId":null}
    // 74,	    // 홀짝 [3 피리어드]	2	{"Id":12553919810517772,"Name":"Odd","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:16:21.212Z","ParticipantId":null}
    // 75,	    // 홀짝 [4 피리어드]	2	{"Id":163916956110517760,"Name":"Odd","Line":null,"BaseLine":null,"Status":1,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:26:05.116Z","ParticipantId":null}
    // 76,	    // 홀짝 [5 피리어드]	
    // 77,	    // 언더오버 [전반전]	26	{"Id":113663409810517780,"Name":"Over","Line":"72.5","BaseLine":"72.5","Status":3,"StartPrice":"1.0","Price":"3.11","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":2,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:48.352Z","ParticipantId":null}
    78,	    // 식스 최다 득점	
    79,	    // 패널티 발생	
    80,	    // 첫 코너	
    81,	    // 마지막 코너	
    82,	    // 레드카드 발생	
    83,	    // 득점 미발생	
    84,	    // 전후반모두 승리	
    85,	    // 후반 역전승	
    86,	    // 무실점 승리	
    88,	    // 최종 승팀	
    89,	    // 	
    // 90,	    // 5세트 발생	
    91,	    // 첫득점 발생 하프	
    // 92,	    // 첫 득점팀 [후반전]	
    95,	    // 코너 - 핸디캡  	
    96,	    // 원정팀 무실점승리	
    97,	    // 홈팀 무실점승리	
    98,	    // 홈팀 무득점	
    99,	    // 원정팀 무득점	
    // 100,	    // 정확한스코어 [2 피리어드]	14	{"Id":109394050210507020,"Name":"3-6","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:20:10.125Z","ParticipantId":null}
    101,	    // 언더오버 <홈팀>	16	{"Id":72726783710507020,"Name":"Under","Line":"12.5","BaseLine":"12.5","Status":2,"StartPrice":"1.0","Price":"2.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:40:36.884Z","ParticipantId":null}
    102,	    // 언더오버 <원정팀>	8	{"Id":138006790010507020,"Name":"Over","Line":"14.5","BaseLine":"14.5","Status":3,"StartPrice":"1.0","Price":"1.727","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":2,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:34.361Z","ParticipantId":null}
    104,	    // 전후반모두 승리 <원정팀>	
    105,	    // 전후반모두 승리 <홈팀>	
    106,	    // 후반 역전승 <홈팀>	
    107,	    // 후반 역전승 <원정팀>	
    108,	    // 홈팀 패널티 득점	
    109,	    // 원정팀 패널티 득점	
    110,	    // 전반 또는 후반승 <원정팀>	
    111,	    // 전반 또는 후반승 <홈팀>	
    // 113,	    // 양팀 모두득점 [전반전]	2	{"Id":170335094510529120,"Name":"Yes","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"2.75","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:52:07.711Z","ParticipantId":null}
    114,	    // 어떤 선수든 최소 2골 득점	
    117,	    // 어떤 선수든 최소 3골 득점	
    122,	    // 첫득점팀이 승리	
    123,	    // 원정팀 첫득점 후 승리	
    124,	    // 홈팀 첫득점 후 승리	
    125,	    // 첫 서브	
    128,	    // 득점수	
    // 129,	    // 언더오버 - 코너 [전반전]	
    132,	    // 유효슈팅 언더/오버	
    133,	    // 슈팅 합계 언더/오버	
    // 134,	    // 득점수 [전반전]	
    135,	    // 언더오버 - 프리킥	
    136,	    // 언더오버 - 오프사이드	
    137,	    // [승X] 무패	
    138,	    // 승무 [패X]	
    139,	    // 첫득점 발생하프 <홈팀>	
    140,	    // 첫득점 발생하프 <원정팀>	
    143,	    // 더많은득점 발생하프 <홈팀>	
    144,	    // 더많은득점 발생하프 <원정팀>	
    // 145,	    // 홈팀 득점수 [전반전]	
    // 146,	    // 원정팀 득점수 [전반전]	
    147,	    // 원정팀 득점수 [후반전]	
    148,	    // 홈팀 득점수 [후반전]	
    // 149,	    // 홈팀 득점수	
    // 150,	    // 원정팀 득점수	
    151,	    // 더블찬스 [후반전]	
    // 153,	    // 언더오버 [1 피리어드] <홈팀>	8	{"Id":192019580710507040,"Name":"Under","Line":"4.5","BaseLine":"4.5","Status":2,"StartPrice":"1.0","Price":"1.755","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:48:25.582Z","ParticipantId":null}
    // 154,	    // 언더오버 [2 피리어드] <홈팀>	6	{"Id":138954876810507020,"Name":"Over","Line":"5.5","BaseLine":"5.5","Status":2,"StartPrice":"1.0","Price":"1.185","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:25:04.387Z","ParticipantId":null}
    // 155,	    // 언더오버 [1 피리어드] <원정팀>	4	{"Id":9978145210507028,"Name":"Over","Line":"6.5","BaseLine":"6.5","Status":2,"StartPrice":"1.0","Price":"9.99","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:58:58.359Z","ParticipantId":null}
    // 156,	    // 언더오버 [2 피리어드] <원정팀>	6	{"Id":52893392410507020,"Name":"Under","Line":"6.5","BaseLine":"6.5","Status":2,"StartPrice":"1.0","Price":"1.47","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:23:49.348Z","ParticipantId":null}
    157,	    // 언더오버 - 옐로우카드 [전반전]	
    158,	    // 언더오버 - 옐로우카드	
    159,	    // 타이 브레이크 발생	
    160,	    // 레이스 승자	
    161,	    // 승무패 [10분]	
    162,	    // 언더오버 [10분]	
    163,	    // 득점수 [후반전]	
    // 164,	    // 타이 브레이크 발생 [1세트]	
    // 165,	    // 오버언더 세트	
    166,	    // 언더오버 - 게임	28	{"Id":190139174610507040,"Name":"Over","Line":"17.5","BaseLine":"17.5","Status":2,"StartPrice":"1.0","Price":"1.585","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:43:55.418Z","ParticipantId":null}
    168,	    // 자살골 발생	
    169,	    // 전후반 모두득점	
    170,	    // 홀짝 - 코너	
    171,	    // 어느 하프든 승리	
    // 175,	    // 타이 브레이크 발생 [2세트]	
    // 176,	    // 타이 브레이크 발생 [3세트]	
    // 177,	    // 타이 브레이크 발생 [4세트]	
    // 178,	    // 타이 브레이크 발생 [5세트]	
    180,	    // 언더오버 - 드로잉	
    181,	    // 언더오버 - 옐로우카드 <홈팀>	
    182,	    // 언더오버 - 옐로우카드 [전반전] <홈팀>	
    183,	    // 언더오버 - 옐로우카드 [후반전] <홈팀>	
    184,	    // 언더오버 - 옐로우카드 <원정팀>	
    185,	    // 언더오버 - 옐로우카드 [전반전] <원정팀>	
    186,	    // 언더오버 - 옐로우카드 [후반전] <원정팀>	
    187,	    // 언더오버 - 옐로우카드 [후반전]	
    188,	    // 첫 옐로우카드	
    189,	    // 첫 레드카드	
    190,	    // 첫 옐로우카드 [후반전]	
    191,	    // Will Any Player Score a Hat-Trick?	
    192,	    // 전후반 모두 득점발생	
    // 194,	    // 홈팀 무득점 [1 피리어드]	
    // 195,	    // 홈팀 무득점 [2 피리어드]	
    // 196,	    // 원정팀 무득점 [1 피리어드]	
    // 197,	    // 원정팀 무득점 [2피리어드]	
    198,	    // 홀짝 <홈팀>	
    199,	    // 홀짝 <원정팀>	
    200,	    // 첫득점팀이 승리	
    201,	    // 핸디캡 - 게임	22	{"Id":181953278310507040,"Name":"1","Line":"3.5","BaseLine":"3.5","Status":2,"StartPrice":"1.0","Price":"1.395","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:25:08.799Z","ParticipantId":null}
    // 202,	    // 승패 1세트	2	{"Id":{"low":874367728,"high":6172758,"unsigned":false},"Name":"1","Line":null,"BaseLine":null,"Status":1,"StartPrice":"1.4","Price":"1.4","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T04:22:21.296Z","ParticipantId":null}
    // 203,	    // 승패 [2 Peroid]	2	{"Id":207898845910507040,"Name":"2","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"34.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:26:22.446Z","ParticipantId":null}
    // 204,	    // 승패 [3 피리어드]	2	{"Id":141031230810507020,"Name":"2","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.565","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:26:00.253Z","ParticipantId":null}
    // 205,	    // 승패 [4 피리어드]	2	{"Id":27344948210512936,"Name":"2","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"3.75","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:12:37.609Z","ParticipantId":null}
    // 206,	    // 승패 [5 피리어드]	
    207,	    // 승무패  [15분]	
    208,	    // 승무패  [30분]	
    210,	    // 코너합계  [후반전]	
    // 211,	    // 양팀 모두득점 [후반전]	
    // 212,	    // 양팀 모두득점 [전반후반]	
    // 213,	    // 양팀모두동점 [전반후반 모두]	
    214,	    // 언더오버 - 카드	
    // 215,	    // 원정팀 득점 [전반전]	
    // 216,	    // 원정팀 득점 [후반전]	
    // 217,	    // 정확한스코어 [3 피리어드]	14	{"Id":142132694810507020,"Name":"6-2","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"9.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:57:59.144Z","ParticipantId":null}
    218,	    // 홈팀 득점 [전반전]	
    // 219,	    // 홈팀 득점 [후반전]	
    220,	    // 언더오버 [연장포함] <원정팀>	30	{"Id":42834577010517780,"Name":"Over","Line":"78.5","BaseLine":"78.5","Status":1,"StartPrice":"1.0","Price":"2.52","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:16:15.434Z","ParticipantId":null}
    221,	    // 언더오버 [연장포함[ <홈팀>	44	{"Id":171637180410517760,"Name":"Over","Line":"71.5","BaseLine":"71.5","Status":2,"StartPrice":"1.0","Price":"3.264","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:37:55.056Z","ParticipantId":null}
    // 222,	    // 언더오버 [3 피리어드] <원정팀>	8	{"Id":168712774410507040,"Name":"Under","Line":"5.5","BaseLine":"5.5","Status":3,"StartPrice":"1.0","Price":"2.03","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:34.361Z","ParticipantId":null}
    // 223,	    // 언더오버 [3 피리어드] <홈팀>	8	{"Id":200849253310507040,"Name":"Under","Line":"3.5","BaseLine":"3.5","Status":2,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:34:54.867Z","ParticipantId":null}
    // 224,	    // 더블찬스 [3 피리어드]	
    // 225,	    // 더블찬스 [4 피리어드]	
    226,	    // 승패	2	{"Id":{"low":1316040263,"high":9411403,"unsigned":false},"Name":"1","Line":null,"BaseLine":null,"Status":1,"StartPrice":"1.9","Price":"1.6","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:57:32.000Z","ParticipantId":null}
    227,	    // 레이스 승자 2 자리	
    228,	    // 레이스 승자 3 자리	
    229,	    // 레이스 승자 4 자리	
    233,	    // 우승 대 영점 아님	
    // 235,	    // 승패 5이닝	3	{"Id":{"low":204088972,"high":48021758,"unsigned":false},"Name":"X","Line":null,"BaseLine":null,"Status":1,"StartPrice":"6.1","Price":"6.4","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:40:52.937Z","ParticipantId":null}
    // 236,	    // 오버언더 5이닝	20	{"Id":{"low":2092297771,"high":37937157,"unsigned":false},"Name":"Under","Line":"1.5","BaseLine":"1.5","Status":1,"StartPrice":"6.75","Price":"7.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T00:36:37.928Z","ParticipantId":null}
    // 237,	    // 득점발생 [1이닝]	
    238,	    // 남은 매치	
    239,	    // 골 범위	
    240,	    // 홀짝 1차 오버 <홈팀>	
    241,	    // 홀짝 1차 오버 <원정팀>	
    // 242,	    // 홀짝 [1 피리어드] <홈팀>	
    // 243,	    // 홀짝 [1 피리어드] <원정팀>	
    244,	    // 최고 오프닝 파트너십	
    245,	    // 득점무득점	
    247,	    // 남은 1차 하프	
    250,	    // 핸디캡 - 코너 [전반전]	
    254,	    // 카드 범위	
    255,	    // 1차 카드 시간	
    256,	    // 홈팀 - 카드 범위	
    257,	    // 원정팀 - 카드 범위	
    258,	    // 코너 범위	
    259,	    // 코너가 많은 팀	
    260,	    // 코너가 많은 팀 [전반전]	
    261,	    // 코너가 많은 팀 [후반전]	
    262,	    // 홈팀 - 코너 범위	
    263,	    // 원정팀 - 코너 범위	
    264,	    // 홈팀 - 코너 범위 1차 하프	
    265,	    // 원정팀 - 코너 범위 1차 하프	
    266,	    // 홈팀 - 코너 범위 2차 하프	
    267,	    // 원정팀 - 코너 범위 2차 하프	
    269,	    // 멀티 골	
    271,	    // 찬스 믹스	
    274,	    // 완전한 승자	
    275,	    // 골 범위 2차 피리어드	
    278,	    // 골 범위 홈팀	
    279,	    // 골 범위 원정팀	
    281,	    // 핸디캡 5이닝	2	{"Id":{"low":-740717940,"high":21204554,"unsigned":false},"Name":"1","Line":"0.0 (0-0)","BaseLine":"0.0 (0-0)","Status":1,"StartPrice":"1.91","Price":"1.91","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:40:52.937Z","ParticipantId":null}
    282,	    // 승무패 [전반전]	3	{"Id":143448908810517780,"Name":"X","Line":null,"BaseLine":null,"Status":3,"StartPrice":"1.0","Price":"15.4","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:48.352Z","ParticipantId":null}
    // 283,	    // 핸디캡 [후반전]	
    // 284,	    // 승무패 [후반전]	3	{"Id":134676060910517780,"Name":"2","Line":null,"BaseLine":null,"Status":1,"StartPrice":"1.0","Price":"1.33","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:16:15.434Z","ParticipantId":null}
    // 285,	    // 홀짝 [후반전]	2	{"Id":190790932910517760,"Name":"Odd","Line":null,"BaseLine":null,"Status":1,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:26:05.116Z","ParticipantId":null}
    // 286,	    // 승패 [후반전]	
    // 287,	    // 언더오버 [4 피리어드] <홈팀>	18	{"Id":40551964510517780,"Name":"Over","Line":"17.5","BaseLine":"17.5","Status":1,"StartPrice":"1.0","Price":"3.264","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:16:17.188Z","ParticipantId":null}
    // 288,	    // 언더오버 [4 피리어드] <원정팀>	14	{"Id":187735405610517760,"Name":"Under","Line":"20.5","BaseLine":"20.5","Status":2,"StartPrice":"1.0","Price":"1.264","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:13:03.969Z","ParticipantId":null}
    // 289,	    // 홀짝 [2 피리어드] <홈팀>	
    // 290,	    // 홀짝 [3 피리어드] <홈팀>	
    // 291,	    // 홀짝 [4 피리어드] <홈팀>	
    // 292,	    // 홀짝 [2 피리어드] <원정팀>	
    // 293,	    // 홀짝 [3 피리어드] <원정팀>	
    // 294,	    // 홀짝 [4 피리어드] <원정팀>	
    297,	    // SP	
    299,	    // 포인트 승자	492	{"Id":11091886910507028,"Name":"1","Line":"3/1/4","BaseLine":"3/1/4","Status":2,"StartPrice":"1.0","Price":"2.625","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:29:05.094Z","ParticipantId":null}
    300,	    // 게임 승자	64	{"Id":130031015210507020,"Name":"1","Line":"3/9","BaseLine":"3/9","Status":2,"StartPrice":"1.0","Price":"21.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:02:26.872Z","ParticipantId":null}
    301,	    // Goal Before	
    302,	    // Goal After	
    304,	    // Team With Highest Scoring Period	
    305,	    // 코너 - 정확한 언더오버	
    306,	    // 첫득점 및 마지막득점	
    307,	    // 유럽핸디캡 - 게임	
    308,	    // 언더오버 - 높은득점 피리어드	
    309,	    // 언더오버 - 낮은득점 피리어드 	
    310,	    // 시리즈 승자	
    315,	    // 그룹 승자	
    // 317,	    // 정확한 언더오버 [1 피리어드]	21	{"Id":13810279610512936,"Name":"Over","Line":"44.0","BaseLine":"44.0","Status":3,"StartPrice":"1.0","Price":"2.5","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-26T00:48:41.252Z","ParticipantId":null}
    // 318,	    // 정확한 언더오버 [2 피리어드]	3	{"Id":204373654810512930,"Name":"Exactly","Line":"40.0","BaseLine":"40.0","Status":3,"StartPrice":"1.0","Price":"13.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-26T01:21:43.261Z","ParticipantId":null}
    // 319,	    // 정확한 언더오버 [3 피리어드]	30	{"Id":73867311410512940,"Name":"Over","Line":"45.0","BaseLine":"45.0","Status":3,"StartPrice":"1.0","Price":"2.25","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:02:13.263Z","ParticipantId":null}
    // 320,	    // 정확한 언더오버 [4 피리어드]	3	{"Id":141854680410512940,"Name":"Over","Line":"40.0","BaseLine":"40.0","Status":2,"StartPrice":"1.0","Price":"1.87","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:03:12.799Z","ParticipantId":null}
    // 321,	    // 정확한 언더오버 [5 피리어드]	
    322,	    // 정확한 언더오버	12	{"Id":168032600810529120,"Name":"Exactly","Line":"2.0","BaseLine":"2.0","Status":1,"StartPrice":"1.0","Price":"3.45","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:38:06.650Z","ParticipantId":null}
    329,	    // 1st Period Race To	8	{"Id":44166278510507020,"Name":"2","Line":"3.0","BaseLine":"3.0","Status":2,"StartPrice":"1.0","Price":"1.03","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:39:23.554Z","ParticipantId":null}
    330,	    // 2nd Period Race To	8	{"Id":24788335810507028,"Name":"1","Line":"3.0","BaseLine":"3.0","Status":2,"StartPrice":"1.0","Price":"1.005","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:11:52.529Z","ParticipantId":null}
    331,	    // 3rd Period Race To	8	{"Id":44832626110507020,"Name":"2","Line":"4.0","BaseLine":"4.0","Status":2,"StartPrice":"1.0","Price":"6.5","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:53:27.979Z","ParticipantId":null}
    332,	    // 4th Period Race To	9	{"Id":113213317310512940,"Name":"2","Line":"20.0","BaseLine":"20.0","Status":2,"StartPrice":"1.0","Price":"5.25","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:12:37.609Z","ParticipantId":null}
    333,	    // 5th Period Race To	
    337,	    // 언더오버 [후반전]	
    338,	    // 다음득점 [1 피리어드]	
    339,	    // 다음득점 [2 피리어드]	
    340,	    // 다음득점 [3 피리어드]	
    341,	    // Race To	
    342,	    // 핸디캡_연장포함	4	{"Id":{"low":1731653191,"high":11660535,"unsigned":false},"Name":"1","Line":"-1.5 (0-0)","BaseLine":"-1.5 (0-0)","Status":1,"StartPrice":"2.95","Price":"2.5","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:57:32.000Z","ParticipantId":null}
    343,	    // Game Range 1st Period	
    344,	    // Game Range 2nd Period	
    345,	    // Game Range 3rd Period	
    346,	    // Game Range 4th Period	
    347,	    // Game Range 5th Period	
    348,	    // 6th Period Winner	
    349,	    // 7th Period Winner	
    // 350,	    // 홀짝 [6 피리어드]	
    // 351,	    // 홀짝 [7 피리어드]	
    // 352,	    // 언더오버 [6 피리어드]	
    // 353,	    // 언더오버 [7 피리어드]	
    354,	    // 언더오버 [전반전] <홈팀>	28	{"Id":52029666110517780,"Name":"Over","Line":"34.5","BaseLine":"34.5","Status":3,"StartPrice":"1.0","Price":"3.015","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:48.352Z","ParticipantId":null}
    355,	    // 언더오버 [전반전] <원정팀>	28	{"Id":126561374410517780,"Name":"Under","Line":"32.5","BaseLine":"32.5","Status":3,"StartPrice":"1.0","Price":"2.496","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:48.352Z","ParticipantId":null}
    356,	    // Method Of Dismissal 6-Way	
    357,	    // Dismissal Method	
    358,	    // Runs at fall of Wicket Home Team 2-way	
    359,	    // Runs at fall of Wicket Away Team 2-way	
    360,	    // Runs at fall of Wicket Home Team 3-way	
    361,	    // Runs at fall of Wicket Away Team 3-way	
    362,	    // Over at fall of Wicket Home Team 2-way	
    363,	    // Over at fall of Wicket Away Team 2-way	
    364,	    // Over at fall of Wicket Home Team 3-way	
    365,	    // Over at fall of Wicket Away Team 3-way	
    366,	    // Total Runs Odd/Even in Over - Home Team	
    367,	    // Total Runs Odd/Even in Over - Away Team	
    368,	    // Runs Odd/Even in Over - Home Team	
    369,	    // Runs Odd/Even in Over - Away Team	
    370,	    // Total Runs in Over - Home Team	
    371,	    // Total Runs in Over - Away Team	
    372,	    // Wicket in Over - Home Team	
    373,	    // Wicket in Over - Away Team	
    374,	    // Runs Off 1st Delivery - Home Team	
    375,	    // Runs Off 2nd Delivery - Home Team	
    376,	    // Runs Off 3rd Delivery - Home Team	
    377,	    // Runs Off 4th Delivery - Home Team	
    378,	    // Runs Off 5th Delivery - Home Team	
    379,	    // Runs Off 6th Delivery - Home Team	
    380,	    // Runs Off 1st Delivery - Away Team	
    381,	    // Runs Off 2nd Delivery - Away Team	
    382,	    // Runs Off 3rd Delivery - Away Team	
    383,	    // Runs Off 4th Delivery - Away Team	
    384,	    // Runs Off 5th Delivery - Away Team	
    385,	    // Runs Off 6th Delivery - Away Team	
    386,	    // 유럽핸디캡 [연장포함]	
    387,	    // 홀짝 [연장포함] <홈팀>	2	{"Id":71082138610509440,"Name":"Even","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:00:28.028Z","ParticipantId":null}
    388,	    // 홀짝 [연장포함] <원정팀>	2	{"Id":49990999610509440,"Name":"Odd","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:00:28.028Z","ParticipantId":null}
    390,	    // 전반전 및 풀타임 [연장포함]	6	{"Id":162524683410512930,"Name":"1/1","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.025","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T01:16:29.704Z","ParticipantId":null}
    391,	    // 다음득점 [연장전]	
    392,	    // Home Team Penalty Shootout	
    393,	    // Away Team Penalty Shootout	
    394,	    // 정확한스코어 [4 피리어드]	16	{"Id":{"low":409294872,"high":10499902,"unsigned":false},"Name":"25-22","Line":null,"BaseLine":null,"Status":3,"StartPrice":"1.0","Price":"18.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-22T06:49:50.765Z","ParticipantId":null}
    395,	    // 정확한스코어 [5 피리어드]	
    396,	    // Total Runs in first Overs - Home Team	
    397,	    // Total Runs in first Overs - Away Team	
    398,	    // Odd/Even Cards	
    399,	    // Half With Most Corners	
    400,	    // Odd/Even Cards 1st Half	
    401,	    // 언더오버 - 코너 [전반전] <홈팀>	
    402,	    // 언더오버 - 코너 [전반전] <원정팀>	
    403,	    // 언더오버 - 코너 [후반전]	
    404,	    // 언더오버 - 코너 [후반전] <홈팀>	
    405,	    // 언더오버 - 코너 [후반전] <원정팀>	
    406,	    // 홀짝 - 코너 [전반전]	
    407,	    // Asian Handicap Cards	
    408,	    // Asian Handicap Cards 1st Half	
    409,	    // 승무패 및 코너	
    410,	    // 승무패 및 코너 [전반전]	
    411,	    // 승패 및 코너	
    412,	    // 승패 및 코너 [전반전]	
    414,	    // Under/Over Cards 1st Half	
    415,	    // 승무패 및 양팀모두득점	6	{"Id":115806137210529120,"Name":"Both Teams Not To Score","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"21.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:52:07.711Z","ParticipantId":null}
    416,	    // 언더오버 [연장전]	
    417,	    // 언더오버 [연장전반전]	
    418,	    // 언더오버 [연장후반전]	
    419,	    // 승무패 [연장전]	
    420,	    // Remaining Match - Extra Time	
    421,	    // 다음득점 [연장전반전]	
    423,	    // Fast Market - Shots off Target	
    427,	    // 승무패 및 언더오버	
    428,	    // Multiple Correct Score	
    430,	    // 정확한 언더오버 [전반전]	
    // 431,	    // 정확한 언더오버 [후반전]	3	{"Id":94013643310512940,"Name":"Under","Line":"85.0","BaseLine":"85.0","Status":2,"StartPrice":"1.0","Price":"1.87","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T01:38:21.339Z","ParticipantId":null}
    433,	    // 유럽핸디캡 - 코너	
    434,	    // 8th Period Winner	
    435,	    // 9th Period Winner	
    // 436,	    // 언더오버 [8 피리어드]	
    // 437,	    // 언더오버 [9 피리어드]	
    438,	    // Total Runs Odd/Even in Over	
    439,	    // Total Runs in Over	
    440,	    // Points Scored	
    441,	    // Points Scored - 1st Period	
    442,	    // Morning Line	
    443,	    // 6th Period Race To	
    444,	    // 7th Period Race To	
    // 445,	    // 승패 [6 피리어드]	
    // 446,	    // 승패 [7 피리어드]	
    // 447,	    // 핸디캡 [6 피리어드]	
    // 448,	    // 핸디캡 [7 피리어드]	
    // 449,	    // 핸디캡 [8 피리어드]	
    // 450,	    // 핸디캡 [9 피리어드]	
    // 451,	    // 승패 [8 피리어드]	
    // 452,	    // 승패 [9 피리어드]	
    453,	    // First Score Method	
    454,	    // First Score Method - Home Team	
    455,	    // First Score Method - Away Team	
    // 456,	    // 더블찬스 [1 피리어드]	3	{"Id":2395254710529119,"Name":"1X","Line":null,"BaseLine":null,"Status":3,"StartPrice":"1.0","Price":"1.03","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":2,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:37:42.267Z","ParticipantId":null}
    // 457,	    // 더블찬스 [2 피리어드]	
    // 459,	    // 홈팀 전체쿼터 득점	
    // 460,	    // 원정팀 전체쿼터 득점	
    461,	    // Winning Margin	
    462,	    // Top 5 Finish	
    463,	    // Top 10 Winner	
    464,	    // 승패 [후반 및 연장포함] 	2	{"Id":114601831010512940,"Name":"2","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"4.5","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:12:37.609Z","ParticipantId":null}
    465,	    // 승패 [4 피리어드 및 연장포함]	
    466,	    // 언더오버 [4 피리어드 및 연장포함]	
    467,	    // 핸디캡 [4 피리어드 및 연장포함]	
    468,	    // 핸디캡 [후반전 및 연장포함]	28	{"Id":98795464310517780,"Name":"1","Line":"10.5 (0-0)","BaseLine":"10.5 (0-0)","Status":2,"StartPrice":"1.0","Price":"1.375","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:10:50.710Z","ParticipantId":null}
    469,	    // 언더오버 [후반전 및 연장포함]	10	{"Id":111183019810512940,"Name":"Over","Line":"87.5","BaseLine":"87.5","Status":2,"StartPrice":"1.0","Price":"2.25","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T01:38:21.339Z","ParticipantId":null}
    472,	    // Will Game Go to Shootout?	
    // 475,	    // Under/Over Runs In Over - Home Team 1st Inning	
    // 476,	    // Under/Over Runs In Over - Away Team 1st Inning	
    // 477,	    // Under/Over Runs In Over - Home Team 2nd Inning	
    // 478,	    // Under/Over Runs In Over - Away Team 2nd Inning	
    // 479,	    // Odd/Even Runs In Over - Home Team 1st Inning	
    // 480,	    // Odd/Even Runs In Over - Away Team 1st Inning	
    // 481,	    // Odd/Even Runs In Over - Home Team 2nd Inning	
    // 482,	    // Odd/Even Runs In Over - Away Team 2nd Inning	
    // 483,	    // Will Home Team Get A Wicket in Over - 1st Inning?	
    // 484,	    // Will Away Team Get A Wicket in Over - 1st Inning?	
    // 485,	    // Will Home Team Get A Wicket in Over - 2nd Inning?	
    // 486,	    // Will Away Team Get A Wicket in Over - 2nd Inning?	
    // 491,	    // Will there be a home team hit in 5th inning?	
    // 500,	    // Will there be a away team hit in 5th inning?	
    // 505,	    // A Run Scored - home team 1st inning	
    523,	    // 언더오버 및 양팀모두득점	
    // 524,	    // 1st 7 Innings Winner	
    // 525,	    // 1st 7 Innings Under/Over	
    // 526,	    // 1st 7 Innings Asian Handicap	
    527,	    // Next Score Type	
    528,	    // 승무패 [후반전 및 연장포함]	
    529,	    // 홀짝 [후반전 및 연장포함]	
    531,	    // 3-Way Winning Margin Range	
    532,	    // Winning Margin Range	
    533,	    // Exact Winning Margin	
    535,	    // 3-Way Winning Margin Range - 1st Half	
    536,	    // 3-Way Winning Margin Range - 1st Period	
    537,	    // 3-Way Winning Margin Range - 2nd Period	
    538,	    // 3-Way Winning Margin Range - 3rd Period	
    539,	    // 3-Way Winning Margin Range - 4th Period	
    540,	    // 3-Way Winning Margin Range - 5th Period	
    // 541,	    // Winning Margin - 1st Period	
    542,	    // Winning Margin - 2nd Period	
    543,	    // Winning Margin - 3rd Period	
    544,	    // Winning Margin - 4th Period	
    545,	    // Winning Margin - 5th Period	
    546,	    // 3-Way Winning Margin Range Including Overtime	
    547,	    // Exact Winning Margin Including Overtime	
    548,	    // Winning Margin Range Including Overtime	
    549,	    // Exact Winning Margin - 1st Period	
    550,	    // Exact Winning Margin - 2nd Period	
    551,	    // Exact Winning Margin - 3rd Period	
    552,	    // Exact Winning Margin - 4th Period	
    553,	    // Under/Over Shootout Penalties Taken	
    554,	    // 12 Shootout	
    555,	    // Asian Handicap Shootout	
    556,	    // Correct Score Shootout	
    557,	    // Under/Over Shootout	
    558,	    // Under/Over Shootout - Home Team	
    559,	    // Under/Over Shootout - Away Team	
    560,	    // Team To Take Last Shootout Penalty	
    563,	    // Race To Including Overtime	
    564,	    // 1X2 And Under/Over 5 way	
    566,	    // 10th Period Winner Home/Away	
    567,	    // 11th Period Winner Home/Away	
    568,	    // 12th Period Winner Home/Away	
    569,	    // 13th Period Winner Home/Away	
    570,	    // 14th Period Winner Home/Away	
    571,	    // 15th Period Winner Home/Away	
    573,	    // 16th Period Winner Home/Away	
    574,	    // 17th Period Winner Home/Away	
    575,	    // 18th Period Winner Home/Away	
    576,	    // 19th Period Winner Home/Away	
    577,	    // 10 Minute Under/Over - Corners	
    578,	    // 10 Minute Under/Over - Cards	
    579,	    // Next Corner	
    581,	    // Top 3 Finish	
    582,	    // Top 6 Winner	
    584,	    // Top 8 Winner	
    586,	    // To Finish In Top Half	
    587,	    // To Finish In Bottom Half	
    588,	    // To Finish Bottom	
    589,	    // Not To Finish In Top 4	
    590,	    // To Be Relegated	
    591,	    // Not To Be Relegated	
    592,	    // To Reach Final	
    593,	    // To Finish In Bottom 6	
    594,	    // To Be Promoted	
    595,	    // First Goal Time	
    596,	    // Goals Range Home Team 1st Period	
    597,	    // Goals Range Home Team 2nd Period	
    598,	    // Goals Range Away Team 1st Period	
    599,	    // Goals Range Away Team 2nd Period	
    600,	    // 1st Period Winner And Both Teams To Score	
    601,	    // HT/FT Double Chance	
    602,	    // Correct Score Including Overtime	
    603,	    // Negative HT/FT	
    604,	    // Goals Range Home Team Both Periods	
    605,	    // Goals Range Away Team Both Periods	
    606,	    // Winner And Goals Type One	
    607,	    // Double Chance And Goals	
    608,	    // Winner And Goals Type Two	
    609,	    // Both Teams To Score And Goals	
    610,	    // Double Chance Mix	
    628,	    // To Finish In Top 7	
    629,	    // To Finish In Top 6	
    630,	    // To Finish In Top 3	
    631,	    // To Finish In Top 2	
    632,	    // To Finish In Top 4	
    633,	    // To Finish In Top 5	
    // 634,	    // Odd/Even Rounds 1st Period	
    635,	    // Odd/Even Rounds 2nd Period	
    636,	    // Odd/Even Rounds 3rd Period	
    637,	    // Will There Be An Ace?	
    638,	    // Will There Be A Knife Kill?	
    639,	    // 1st Round Winner	
    640,	    // 16th Round Winner	
    641,	    // Will there be a knife kill? - 1st Period	
    642,	    // Will there be a knife kill? - 2nd Period	
    643,	    // Will there be a knife kill? - 3rd Period	
    644,	    // Will There Be An Ace? - 1st Period	
    645,	    // Will There Be An Ace? - 2nd Period	
    646,	    // Will There Be An Ace? - 3rd Period	
    // 647,	    // Will There Be Overtime? - 1st Period	
    648,	    // Will There Be Overtime? - 2nd Period	
    649,	    // Will There Be Overtime? - 3rd Period	
    // 650,	    // 16th Round Winner - 1st Period	
    // 651,	    // 16th Round Winner - 2nd Period	
    // 652,	    // 16th Round Winner - 3rd Period	
    // 653,	    // 1st Round Winner - 1st Period	
    // 654,	    // 1st Round Winner - 2nd Period	
    655,	    // 1st Round Winner - 3rd Period	
    660,	    // Game Duration	
    662,	    // Odd/Even Rounds	
    663,	    // 1st Period Duration	
    664,	    // 2nd Period Duration	
    665,	    // 3rd Period Duration	
    // 666,	    // 1st Period - 1st Roshan	
    // 667,	    // 2nd Period - 1st Roshan	
    // 668,	    // 3rd Period - 1st Roshan	
    // 669,	    // 1st Period - 1st Blood	
    // 670,	    // 2nd Period - 1st Blood	
    671,	    // 3rd Period - 1st Blood	
    // 672,	    // 1st Period - 1st Tower	
    // 673,	    // 2nd Period - 1st Tower	
    // 674,	    // 3rd Period - 1st Tower	
    675,	    // 1st Period - 1st Barracks	
    677,	    // 2nd Period - 1st Barracks	
    678,	    // 3rd Period - 1st Barracks	
    679,	    // 1st Period - 1st Turret	
    680,	    // 2nd Period - 1st Turret	
    681,	    // 3rd Period - 1st Turret	
    682,	    // Race To Kills - 1st Period	
    683,	    // Race To Kills - 2nd Period	
    684,	    // Race To Kills - 3rd Period	
    685,	    // Both Teams to kill a Dragon - 1st Period	
    686,	    // Both Teams to kill a Dragon - 2nd Period	
    687,	    // Both Teams to kill a Dragon - 3rd Period	
    688,	    // Both Teams to kill a Inhibitor - 1st Period	
    689,	    // Both Teams to kill a Inhibitor - 2nd Period	
    690,	    // Both Teams to kill a Inhibitor - 3rd Period	
    691,	    // Odd/Even Kills	
    // 692,	    // Odd/Even Kills - 1st Period	
    // 693,	    // Odd/Even Kills - 2nd Period	
    694,	    // Odd/Even Kills - 3rd Period	
    695,	    // HT/FT And Goals	
    697,	    // To Finish In Top 8	
    698,	    // To Finish In Top 9	
    711,	    // Player To Score In Anytime	
    712,	    // First Player To Score	
    713,	    // Last Player To Score	
    714,	    // Player To Score 2 Or More Goals	
    715,	    // Player To Score 3 Or More Goals	
    720,	    // To win 1st set & win the match	
    721,	    // To Lose 1st Set & win the Match	
    726,	    // To Win 1st Set & Lose The Match	
    727,	    // 1st Period Both Teams To Score	
    728,	    // 2nd Period Both Teams To Score	
    729,	    // 3rd Period Both Teams To Score	
    730,	    // 4th Period Both Teams To Score	
    731,	    // 1st Period Home Team To Score	
    732,	    // 2nd Period Home Team To Score	
    733,	    // 3rd Period Home Team To Score	
    734,	    // 4th Period Home Team To Score	
    735,	    // 1st Period Away Team To Score	
    736,	    // 2nd Period Away Team To Score	
    737,	    // 3rd Period Away Team To Score	
    738,	    // 4th Period Away Team To Score	
    751,	    // 1st Half Race To	
    752,	    // 2nd Half Race To - Including Overtime	27	{"Id":173864394710512930,"Name":"2","Line":"50.0","BaseLine":"50.0","Status":2,"StartPrice":"1.0","Price":"26.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:12:06.041Z","ParticipantId":null}
    754,	    // Game To Deuce	64	{"Id":177565877010507040,"Name":"No","Line":"3/10","BaseLine":"3/10","Status":2,"StartPrice":"1.0","Price":"1.533","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T08:05:21.268Z","ParticipantId":null}
    755,	    // Extra Time Corners - Under/Exactly/Over	
    756,	    // Under/Over- Extra Time Corners	
    757,	    // Asian Handicap - Extra Time	
    758,	    // 10 Minute Under/Over - Free Kicks	
    759,	    // 10 Minute Under/Over - Throw-ins	
    760,	    // 10 Minute Under/Over - Goal Kicks	
    762,	    // To Win The Toss	
    763,	    // Under/Over Runs In Match	
    765,	    // To Score Most Fours	
    766,	    // Under/Over - Match Fours	
    767,	    // Under/Over - Match Sixes	
    768,	    // A Fifty To Be Scored In The Match	
    769,	    // A Hundred To Be Scored In The Match	
    770,	    // Most Run Outs	
    791,	    // Top Batsman - Home Team	
    792,	    // Top Batsman - Away Team	
    793,	    // Top Bowler - Home Team	
    794,	    // Top Bowler - Away Team	
    795,	    // Man Of The Match	
    806,	    // Batsman To Score a Fifty in The match	
    807,	    // Most Runs - Batsman Matches	
    808,	    // Race To 10 Runs	
    809,	    // Highest 1st 6 Overs Score	
    813,	    // Player To Score Most Sixes	
    814,	    // Highest Individual Score	
    819,	    // To Have A Break Point In The Game	64	{"Id":88731541210507020,"Name":"Yes","Line":"1/7","BaseLine":"1/7","Status":2,"StartPrice":"1.0","Price":"3.75","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:45:33.999Z","ParticipantId":null}
    820,	    // Race To Corners	
    821,	    // League Top Goalscorer	
    822,	    // Top New Team 	
    823,	    // 2nd Player To Score	
    824,	    // Player To Be Booked	
    825,	    // Player To Be Sent Off	
    834,	    // Extra Points Set	
    835,	    // Asian Under/Over	22	{"Id":103624053210529120,"Name":"Under","Line":"6.25","BaseLine":"6.25","Status":2,"StartPrice":"1.0","Price":"1.125","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:41:06.976Z","ParticipantId":null}
    836,	    // Asian Under/Over 1st Period	8	{"Id":144132449810529120,"Name":"Under","Line":"1.25","BaseLine":"1.25","Status":3,"StartPrice":"1.0","Price":"1.12","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":2,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:37:42.267Z","ParticipantId":null}
    837,	    // 1st Half Home Team Win To Nil	
    838,	    // 1st Half Away Team Win To Nil	
    839,	    // 1st Half 1X2 And Under/Over	
    840,	    // 1st Period Home Team Win To Nil	
    841,	    // 1st Period Away Team Win To Nil	
    842,	    // Under/Exactly/Over - Home Team	
    843,	    // Under/Exactly/Over - Away Team	
    844,	    // First Team To Score - Home/Away	
    845,	    // Team To Call First Time Out	
    846,	    // Under/Over Hits - Including Overtime	
    // 848,	    // Under/Over 3rd Inning	
    // 849,	    // Under/Over 5th Inning	
    // 850,	    // Under/Over 7th Inning	
    851,	    // Team With Highest Scoring Half	
    852,	    //  Either Team to Score 3 Unanswered Times	
    853,	    // 12 And Under/Over	
    854,	    // Special Team or Defensive Touchdown Scored	
    855,	    // Points Range	
    859,	    // 147 Break In Match	
    861,	    // First Score Method 3 Way - Home Team	
    862,	    // First Score Method 3 Way - Away Team	
    863,	    // Team with Highest Scoring Period -1X2	
    864,	    // Team First Goalscorer	
    865,	    // Team Last Goalscorer	
    // 866,	    // 핸디캡 세트	2	{"Id":{"low":-1089902433,"high":47331811,"unsigned":false},"Name":"2","Line":"-1.5 (0-0)","BaseLine":"1.5 (0-0)","Status":1,"StartPrice":"2.0","Price":"2.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:57:20.336Z","ParticipantId":null}
    870,	    // First Score Method 6 Way Home/Away	
    878,	    // Goals Range 3rd Period	
    879,	    // Under/Over Tries	
    880,	    // First Half Corners - Under/Exactly/Over	
    881,	    // First Goal Method	
    882,	    // Number of points	120	{"Id":182248968310507040,"Name":"6","Line":"10.0","BaseLine":"10.0","Status":2,"StartPrice":"1.0","Price":"3.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:00:34.488Z","ParticipantId":null}
    891,	    // Team To Score Longest Touchdown	
    892,	    // Team To Score Longest Field Goal	
    893,	    // Longest Touchdown Scored	
    894,	    // Shortest Touchdown Scored	
    895,	    // Longest Field Goal Scored	
    896,	    // Time Of First Team Goal	
    897,	    // Game Score After 2 Points	
    898,	    // Game Score After 3 Points	
    899,	    // Game Score After 4 Points	
    900,	    // Game To Score	256	{"Id":107125991510507020,"Name":"2","Line":"1/9/30","BaseLine":"1/9/30","Status":2,"StartPrice":"1.0","Price":"1.8","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:56:21.849Z","ParticipantId":null}
    901,	    // 1st Period Lead After	
    902,	    // 2nd Period Lead After	
    903,	    // 3rd Period Lead After	
    904,	    // 4th Period Lead After	
    905,	    // 5th Period Lead After	
    906,	    // Score After 4 Games	18	{"Id":151793716310507040,"Name":"2","Line":"1/4-0","BaseLine":"1/4-0","Status":2,"StartPrice":"1.0","Price":"23.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:28:23.753Z","ParticipantId":null}
    907,	    // Score After 6 Games	23	{"Id":96315614410507020,"Name":"1","Line":"3/6-0","BaseLine":"3/6-0","Status":2,"StartPrice":"1.0","Price":"1.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:30:48.834Z","ParticipantId":null}
    908,	    // To Break Serve In Set	12	{"Id":143352132210507020,"Name":"Away - No","Line":"1.0","BaseLine":"1.0","Status":2,"StartPrice":"1.0","Price":"5.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:39:23.554Z","ParticipantId":null}
    909,	    // Home To Win In Straight Sets	2	{"Id":122321073610507020,"Name":"No","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.007","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:58:32.955Z","ParticipantId":null}
    910,	    // Away To Win In Straight Sets	2	{"Id":90288377110507020,"Name":"No","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"2.375","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:58:39.202Z","ParticipantId":null}
    911,	    // Score After 2 Sets	
    912,	    // Score After 3 Sets	
    913,	    // Score After 4 Sets	
    914,	    // Under/Over Field Goals Scored - 1st Half	
    915,	    // Under/Over Touchdowns Scored - 1st Half	
    916,	    // Under/Over Home Team Touchdowns - 1st Half	
    917,	    // Under/Over Away Team Touchdowns - 1st Half	
    918,	    // Under/Over Home Team Field Goals - 1st Half	
    919,	    // Under/Over Away Team Field Goals - 1st Half	
    920,	    // Under/Over Touchdowns	
    921,	    // Under/Exactly/Over - Touchdowns	
    922,	    // Under/Over Field Goals	
    923,	    // Under/Exactly/Over - Field Goals	
    924,	    // Time Of First Field Goal Scored	
    925,	    // Time Of First Touchdown Scored	
    926,	    // Time Of First Score	
    927,	    // Home Team Under/Over Touchdowns	
    928,	    // Away Team Under/Over Touchdowns	
    929,	    // Home Team Under/Over Field Goals	
    930,	    // Away Team Under/Over Field Goals	
    931,	    // Both Teams To Score Points	
    932,	    // Team to Have First Coaches Challenge	
    933,	    // Team to Commit First Accepted Penalty	
    934,	    // Safety Scored	
    935,	    // European Cards Handicap	
    936,	    // Asian Under/Over Cards	
    938,	    // Under/Over Cards - Home Team	
    939,	    // Under/Over Cards - Away Team	
    940,	    // Time Of First Card	
    941,	    // Next Player To Score	
    942,	    // Top Nationality - Asian 	
    943,	    // Top Nationality - Australian 	
    944,	    // Top Nationality - European	
    945,	    // Top Nationality - Great Britain & Ireland	
    946,	    // Top Nationality - Rest Of The World	
    947,	    // Under/Over Aces	2	{"Id":18537447510507028,"Name":"Under","Line":"13.5","BaseLine":"13.5","Status":2,"StartPrice":"1.0","Price":"2.22","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:22:01.645Z","ParticipantId":null}
    948,	    // Under/Over Aces - Home Team	
    949,	    // Exact Number Of Aces	
    950,	    // Under/Over Aces - Away Team	
    951,	    // Correct Number Of Aces	
    952,	    // Odd/Even Number Of Aces	
    953,	    // Odd/Even Number Of Aces - Home Team	
    954,	    // Odd/Even Number Of Aces - Away Team	
    955,	    // 1X2 Aces	
    956,	    // Exact Number Of Aces - Home Team	
    957,	    // Exact Number Of Aces - Away Team	
    958,	    // Aces Asian Handicap	2	{"Id":60668206710507020,"Name":"1","Line":"6.5","BaseLine":"6.5","Status":2,"StartPrice":"1.0","Price":"1.975","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:22:01.645Z","ParticipantId":null}
    959,	    // Race To Aces 	
    960,	    // Under/Over Aces - 1st Period	
    961,	    // Under/Over Aces - 2nd Period	
    962,	    // Under/Over Aces Home Team - 1st Period	
    963,	    // Under/Over Aces Home Team - 2nd Period	
    964,	    // Under/Over Aces Away Team - 1st Period	
    965,	    // Under/Over Aces Away Team - 2nd Period	
    966,	    // Exact Number Of Aces - 1st Period	
    967,	    // Exact Number Of Aces - 2nd Period	
    968,	    // Correct Number Of Aces - 1st Period	
    969,	    // Correct Number Of Aces - 2nd Period	
    970,	    // Odd/Even Number Of Aces - 1st Period	
    971,	    // Odd/Even Number Of Aces - 2nd Period	
    972,	    // Odd/Even Number Of Aces Home Team - 1st Period	
    973,	    // Odd/Even Number Of Aces Home Team - 2nd Period	
    974,	    // Odd/Even Number Of Aces Away Team - 1st Period	
    975,	    // Odd/Even Number Of Aces Away Team - 2nd Period	
    976,	    // 1X2 Aces - 1st Period	
    977,	    // 1X2 Aces - 2nd Period	
    978,	    // Exact Number Of Aces Home Team - 1st Period	
    979,	    // Exact Number Of Aces Home Team - 2nd Period	
    980,	    // Exact Number Of Aces Away Team - 1st Period	
    981,	    // Exact Number Of Aces Away Team - 2nd Period	
    982,	    // Aces Asian Handicap - 1st Period	
    983,	    // Aces Asian Handicap - 2nd Period	
    984,	    // Race To Aces - 1st Period	
    985,	    // Race To Aces - 2nd Period	
    986,	    // 12 Aces	
    987,	    // 12 Aces - 1st Period	
    988,	    // 12 Aces - 2nd Period	
    // 989,	    // Under/Over Kills - 1st Period	
    // 990,	    // Under/Over Kills - 2nd Period	
    // 991,	    // Under/Over Kills - 3rd Period	
    992,	    // Next Touchdown Scorer - Home Team	
    993,	    // Next Touchdown Scorer - Away Team	
    994,	    // Next Touchdown Scorer	
    995,	    // Player To Score Touchdown In Anytime	
    996,	    // Player To Score 2 Or More Touchdowns	
    997,	    // Player To Score 3 Or More Touchdowns	
    998,	    //  First Match Corner - 12	
    999,	    // Last Match Corner - 12	
    1000,	// Number Of Sets	2	{"Id":197829011910507040,"Name":"2 Sets","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"1.5","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:58:39.202Z","ParticipantId":null}
    1001,	// Under/Over Double Faults	2	{"Id":127048308710507020,"Name":"Over","Line":"4.5","BaseLine":"4.5","Status":2,"StartPrice":"1.0","Price":"1.775","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:21:55.393Z","ParticipantId":null}
    1002,	// Under/Over Double Faults - Away Team	
    1003,	// Under/Over Double Faults - Home Team	
    1004,	// Under/Over Double Faults  - 1st Period	
    1005,	// Under/Over Double Faults - 2nd Period	
    1006,	// Under/Over Double Faults Away Team - 1st Period	
    1007,	// Under/Over Double Faults Away Team - 2nd Period	
    1008,	// Under/Over Double Faults Home Team - 1st Period	
    1009,	// Under/Over Double Faults Home Team - 2nd Period	
    1010,	// 12 Double Faults	
    1011,	// 12 Double Faults - 1st Period	
    1012,	// 12 Double Faults - 2nd Period	
    1013,	// 1X2 Double Faults	
    1014,	// 1X2 Double Faults - 1st Period	
    1015,	// 1X2 Double Faults - 2nd Period	
    1016,	// Exact Number Of Double Faults	
    1017,	// Exact Number Of Double Faults - 1st Period	
    1018,	// Exact Number Of Double Faults - 2nd Period	
    1019,	// Exact Number Of Double Faults - Home Team	
    1020,	// Exact Number Of Double Faults - Away Team	
    1021,	// Exact Number Of Double Faults Home Team - 1st Period	
    1024,	// Exact Number Of Double Faults Home Team - 2nd Period	
    1025,	// Exact Number Of Double Faults Away Team - 1st Period	
    1026,	// Exact Number Of Double Faults Away Team - 2nd Period	
    1027,	// Correct Number Of Double Faults	
    1028,	// Correct Number Of Double Faults - 1st Period	
    1029,	// Correct Number Of Double Faults - 2nd Period	
    1030,	// Time Of First Corner	
    1031,	// Multiple Corners 	
    1034,	// 20th Period Winner Home/Away	
    1035,	// 21th Period Winner Home/Away	
    1036,	// 22th Period Winner Home/Away	
    1037,	// 23th Period Winner Home/Away	
    1038,	// 24th Period Winner Home/Away	
    1039,	// 25th Period Winner Home/Away	
    1040,	// 26th Period Winner Home/Away	
    1041,	// 27th Period Winner Home/Away	
    1042,	// 28th Period Winner Home/Away	
    1043,	// 29th Period Winner Home/Away	
    1044,	// 30th Period Winner Home/Away	
    1045,	// 31th Period Winner Home/Away	
    1046,	// 32th Period Winner Home/Away	
    1047,	// 33th Period Winner Home/Away	
    1048,	// 34th Period Winner Home/Away	
    1049,	// 35th Period Winner Home/Away	
    1050,	// Race To 20 Points	
    1051,	// Under/Over 2nd Half - Home Team	2	{"Id":153174349710512930,"Name":"Under","Line":"43.5","BaseLine":"43.5","Status":2,"StartPrice":"1.0","Price":"1.769","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T01:38:21.339Z","ParticipantId":null}
    1052,	// Under/Over 2nd Half - Away Team	2	{"Id":153011310512937,"Name":"Over","Line":"42.5","BaseLine":"42.5","Status":2,"StartPrice":"1.0","Price":"1.909","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T01:38:21.339Z","ParticipantId":null}
    1053,	// Asian Under/Over 2nd Period	
    1054,	// Asian Under/Over 3rd Period	
    1055,	// Asian Under/Over 4th Period	
    1061,	// Asian Under/Over Including Overtime 	64	{"Id":182445178010512930,"Name":"Over","Line":"161.25","BaseLine":"161.25","Status":2,"StartPrice":"1.0","Price":"1.84","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:04:42.219Z","ParticipantId":null}
    1062,	// Highest Scoring Half - Home Team	
    1063,	// Highest Scoring Half - Away Team	
    1064,	// tmp1	
    1065,	// Home Team - First Goalscorer	
    1066,	// Home Team - Last Goalscorer	
    1067,	// Away Team - First Goalscorer	
    1068,	// Away Team - Last Goalscorer	
    1069,	// Under/Over Player Points	218	{"Id":43721363710509440,"Name":"Over","Line":"36.5","BaseLine":"Devin Booker#36.5","Status":3,"StartPrice":"1.0","Price":"1.952","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":2,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:55:53.977Z","ParticipantId":null}
    1070,	// Under/Over Player Blocks	42	{"Id":19605995410509436,"Name":"Under","Line":"0.5","BaseLine":"Bismack Biyombo#0.5","Status":3,"StartPrice":"1.0","Price":"2.05","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:31:55.258Z","ParticipantId":null}
    1071,	// Under/Over Player Assists	80	{"Id":169630335710509440,"Name":"Over","Line":"0.5","BaseLine":"Deandre Ayton#0.5","Status":3,"StartPrice":"1.0","Price":"2.55","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":2,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:05:39.260Z","ParticipantId":null}
    1072,	// Under/Over Player Rebounds	106	{"Id":201797937410509440,"Name":"Over","Line":"6.5","BaseLine":"Morris Marcus#6.5","Status":2,"StartPrice":"1.0","Price":"2.8","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:38:22.345Z","ParticipantId":null}
    1073,	// Under/Over Player Steals	44	{"Id":107514887210509440,"Name":"Over","Line":"0.5","BaseLine":"Torrey Craig#0.5","Status":2,"StartPrice":"1.0","Price":"6.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T04:01:24.264Z","ParticipantId":null}
    1074,	// Under/Over Player Turnovers	58	{"Id":162946801510509440,"Name":"Over","Line":"4.5","BaseLine":"Westbrook Russell#4.5","Status":2,"StartPrice":"1.0","Price":"1.476","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:57:18.857Z","ParticipantId":null}
    1075,	// Under/Over Player 3 Points Made	54	{"Id":148004922210509440,"Name":"Over","Line":"2.5","BaseLine":"Westbrook Russell#2.5","Status":2,"StartPrice":"1.0","Price":"2.9","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:59:02.311Z","ParticipantId":null}
    1076,	// Under/Over Player 3 Points Attempted	
    1077,	// Under/Over Player 2 Points Made	
    1078,	// Under/Over Player 2 Points Attempted	
    1079,	// Under/Over Player Free Throws Made	
    1080,	// Under/Over Player Free Throws Attempted	
    1081,	// 1X2 Yellow Cards	
    1082,	// Double Chance Yellow Cards	
    1083,	// Asian Handicap Yellow Cards	
    1084,	// Correct Score Yellow Cards	
    1085,	// Under/Over Red Cards	
    1086,	// Under/Exactly/Over Booking Points	
    1087,	// Under/Exactly/Over Booking Points - Home Team	
    1088,	// Under/Exactly/Over Booking Points - Away Team	
    1089,	// Under/Over Player Steals And Blocks	58	{"Id":184469861110509440,"Name":"Over","Line":"0.5","BaseLine":"Torrey Craig#0.5","Status":2,"StartPrice":"1.0","Price":"3.65","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T04:01:24.264Z","ParticipantId":null}
    1090,	// Under/Over Player Points, Assists And Rebounds	260	{"Id":201455310910509440,"Name":"Under","Line":"17.5","BaseLine":"Eric Gordon#17.5","Status":2,"StartPrice":"1.0","Price":"1.833","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:09:42.715Z","ParticipantId":null}
    1091,	// Under/Over Player Assists And Rebounds	132	{"Id":190123238010509440,"Name":"Over","Line":"3.5","BaseLine":"Torrey Craig#3.5","Status":2,"StartPrice":"1.0","Price":"2.65","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T04:01:42.497Z","ParticipantId":null}
    1092,	// Under/Over Player Points And Rebounds	228	{"Id":86000095710509440,"Name":"Under","Line":"9.5","BaseLine":"Bismack Biyombo#9.5","Status":2,"StartPrice":"1.0","Price":"2.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:06:02.192Z","ParticipantId":null}
    1093,	// Under/Over Player Points And Assists	226	{"Id":24077212710509436,"Name":"Under","Line":"5.5","BaseLine":"Torrey Craig#5.5","Status":2,"StartPrice":"1.0","Price":"1.645","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:03:53.801Z","ParticipantId":null}
    1094,	// Player Double Double	
    1095,	// Player Triple Double	
    1096,	// Under/Exactly/Over Booking Points - 1st Period	
    1098,	// Under/Over 180's In a Leg	
    1099,	// Under/Over Total Checkouts In a Leg	
    1100,	// Set Winner 	
    1101,	// Under/Over 180's In a Set	
    1102,	// Set/Leg Winner 	
    1103,	// Set/Leg Total Checkouts Under/Over 	
    1104,	// Set/Leg 180's Under/Over	
    1105,	// Under/Over Total 180's - Home Team	
    1106,	// Under/Over Total 180's - Away Team	
    1112,	// Under/Over Player Goals	
    1115,	// Under/Over Player Goals Allowed	
    // 1120,	// Under/Over Rounds - 1st Period	
    // 1121,	// Under/Over Rounds - 2nd Period	
    // 1122,	// Under/Over Rounds - 3rd Period	
    1123,	// 4th Period - 1st Blood	
    1124,	// 5th Period - 1st Blood	
    1125,	// Both Teams To Kill a Dragon	
    1126,	// Both Teams To Kill a Baron	
    1127,	// Both Teams To Kill a Inhibitor	
    1128,	// Under/Over Barons Slain	
    1129,	// Under/Over Barons Slain - 1st Period	
    1130,	// Under/Over Barons Slain - 2nd Period	
    1131,	// Under/Over Barons Slain - 3rd Period	
    1132,	// Under/Over Dragons Slain	
    1133,	// Under/Over Dragons Slain - 1st Period	
    1134,	// Under/Over Dragons Slain - 2nd Period	
    1135,	// Under/Over Dragons Slain - 3rd Period	
    1136,	// Under/Over 180's	
    1137,	// First 180	
    1138,	// Last 180	
    1139,	// Under/Over Highest Checkout Score	
    1140,	// Most 180's	
    1141,	// Under/Over Highest Checkout Score - Home Team	
    1142,	// Under/Over Highest Checkout Score - Away Team	
    1143,	// First Player To Score Touchdown	
    1144,	// Last Player To Score Touchdown	
    1145,	// First Player To Score Touchdown - Home Team	
    1146,	// First Player To Score Touchdown - Away Team	
    1147,	// Under/Over Kills - 4th Period	
    1148,	// Under/Over Kills - 5th Period	
    // 1149,	// Asian Handicap Kills - 1st Period	
    // 1150,	// Asian Handicap Kills - 2nd Period	
    // 1151,	// Asian Handicap Kills - 3rd Period	
    1152,	// Asian Handicap Kills - 4th Period	
    1153,	// Asian Handicap Kills - 5th Period	
    1154,	// Under/Exactly/Over 180's	
    1155,	// Under/Exactly/Over Total 180's - Home Team	
    1156,	// Under/Exactly/Over Total 180's - Away Team	
    1157,	// Most Checkouts	
    1158,	// First Try Scorer	
    1159,	// Last Try Scorer	
    1160,	// Anytime Try Scorer	
    1161,	// Under/Over Towers Destroyed	
    1162,	// Under/Over Towers Destroyed - 1st Period	
    1163,	// Under/Over Towers Destroyed - 2nd Period	
    1164,	// Under/Over Towers Destroyed - 3rd Period	
    1165,	// 1st Period - 1st Baron	
    1166,	// 2nd Period - 1st Baron	
    1167,	// 3rd Period - 1st Baron	
    1168,	// 4th Period - 1st Baron	
    1169,	// 5th Period - 1st Baron	
    1170,	// 1st Period - 1st Dragon	
    1171,	// 2nd Period - 1st Dragon	
    1172,	// 3rd Period - 1st Dragon	
    1173,	// 4th Period - 1st Dragon	
    1174,	// 5th Period - 1st Dragon	
    1175,	// Most Kills - 1st Period	
    1176,	// Most Kills - 2nd Period	
    1177,	// Most Kills - 3rd Period	
    1178,	// Most Kills - 4th Period	
    1179,	// Most Kills - 5th Period	
    1180,	// Most Kills - 6th Period	
    1181,	// Most Kills - 7th Period	
    1182,	// Player To Score 2 Or More Trys	
    1183,	// Player To Score 3 Or More Trys	
    1184,	// Not To Win The Leauge	
    1185,	// Under/Exactly/Over Including Overtime - Home Team	
    1186,	// Under/Exactly/Over Including Overtime - Away Team	
    1187,	// Under/Exactly/Over Including Overtime 	
    1188,	// Under/Over Substitutions	
    1189,	// Under/Over Substitutions - 1st Period	
    1190,	// Last Player To Score Touchdown - Home Team	
    1191,	// Last Player To Score Touchdown - Away Team	
    1192,	// First Player To Hit an Ace	
    1193,	// Under/Over Player Quarterback Passing Yards	
    1194,	// Under/Over Player Passing Touchdowns	
    1195,	// Under/Over Longest Player Pass Completion	
    1196,	// Under/Over Player Receiving Yards	
    1197,	// Under/Over Player Interceptions	
    1198,	// Under/Over Player Kicking Points	
    1199,	// Under/Over Player Rushing & Receiving Yards	
    1200,	// Under/Over Player Rushing Yards	
    1201,	// Under/Over Player Longest Reception	
    1202,	// Under/Over Player Receptions	
    1203,	// Under/Over Player Field Goals Made	
    1204,	// Under/Over Player Field Goals Attempted	
    1205,	// Under/Over Player Quarterback Passing Touchdowns	
    1206,	// Under/Over Player Receiver Reception Completions	
    1207,	// Under/Over Player Quarterback Passes Completed	
    1208,	// Under/Over Player Rushing Touchdowns	
    1209,	// Under/Over Player Receiver Reception Attempts	
    1210,	// Under/Over Player Quarterback Passes Attempted	
    1211,	// 1X2 Fouls	
    1212,	// Double Chance Fouls	
    1213,	// Under/Over Fouls - 1st Period	
    1214,	// Under/Over Fouls - 2nd Period	
    1215,	// Asian Handicap Fouls	
    1216,	// Under/Over Fouls - Home Team	
    1217,	// Under/Over Fouls - Away Team	
    1218,	// Under/Over Player Rush Attempts	
    1219,	// Under/Over Player Receiving Touchdowns	
    1222,	// Under/Over Throw-Ins - Home Team	
    1223,	// Under/Over Throw-Ins - Away Team	
    1224,	// 1X2 Throw-Ins	
    1225,	// Double Chance Throw-Ins	
    1226,	// Under/Over Throw-Ins - 1st Period	
    1227,	// Throw-ins Handicap	
    1228,	// Throw-ins Handicap - 1st Period	
    1229,	// Under/Over Shots on Target - Home Team	
    1230,	// Under/Over Shots on Target - Away Team	
    1231,	// Asian Handicap Shots on Target	
    1232,	// Asian Handicap Shots On Target - 1st Period	
    1233,	// Under/Over Shots On Target - 1st Period	
    1234,	// 1X2 Shots on Target	
    1235,	// Double Chance Shots on Target	
    1236,	// Under/Over Total Shots - Home Team	
    1237,	// Under/Over Total Shots - Away Team	
    1238,	// Double Chance Total Shots	
    1239,	// 1X2 Total Shots	
    1240,	// Asian Handicap Total Shots	
    1241,	// Asian Handicap Total Shots - 1st Period	
    1242,	// Under/Over Total Shots - 1st Period	
    1243,	// Double Chance Corners	
    1244,	// Double Chance Corners - 1st Period	
    1245,	// Corners From All 4 Corners Of The Pitch	
    1246,	// Double Chance Yellow Cards - 1st Period	
    1247,	// 1X2 Yellow Cards - 1st Period	
    1248,	// Asian Handicap Yellow Cards - 1st Period	
    1249,	// Double Chance & Under/Over	
    1250,	// Double Chance & Both Teams To Score	
    1251,	// 1st Period - 1st Inhibitor	
    1252,	// 2nd Period - 1st Inhibitor	
    1253,	// 3rd Period - 1st Inhibitor	
    1254,	// 4th Period - 1st Inhibitor	
    1255,	// 5th Period - 1st Inhibitor	
    1256,	// Both Teams To Kill a Baron - 1st Period	
    1257,	// Both Teams To Kill a Baron - 2nd Period	
    1258,	// Both Teams To Kill a Baron - 3rd Period	
    1259,	// Both Teams To Kill a Baron - 4th Period	
    1260,	// Both Teams To Kill a Baron - 5th Period	
    1261,	// Both Teams to kill a Dragon - 4th Period	
    1262,	// Both Teams to kill a Dragon - 5th Period	
    1263,	// Both Teams to kill a Inhibitor - 4th Period	
    1264,	// Both Teams to kill a Inhibitor - 5th Period	
    1265,	// Will There Be An Ace Next Game?	
    1266,	// Will There Be Double Fault Next Game?	
    1267,	// Odd/Even Fouls	
    1268,	// Asian Handicap Ball Possession 	
    1269,	// Double Chance Offsides	
    1270,	// Asian Handicap Offsides	
    1271,	// Under/Over Offsides - Home Team	
    1272,	// Under/Over Offsides - Away Team	
    1273,	// 1X2 Offsides	
    1274,	// Under/Over Kills 1st Period - Home Team	
    1275,	// Under/Over Kills 2nd Period - Home Team	
    1276,	// Under/Over Kills 3rd Period - Home Team	
    1277,	// Under/Over Kills 1st Period - Away Team	
    1278,	// Under/Over Kills 2nd Period - Away Team	
    1279,	// Under/Over Kills 3rd Period - Away Team	
    1280,	// Under/Over Wides	
    1281,	// Under/Over Ducks	
    1282,	// Under/Over Wickets	
    1283,	// Under/Over Match Fours - Home Team	
    1284,	// Under/Over Match Sixes - Home Team	
    1285,	// Under/Over Match Fours - Away Team	
    1286,	// Under/Over Match Sixes - Away Team	
    1287,	// Under/Over Extras	
    1288,	// Fall Of 1st Wicket - Home Team	
    1289,	// Fall Of 1st Wicket - Away Team	
    1290,	// Team Of Top Batsman	
    1291,	// Under/Over Match Sixes Home Team - 1st Inning	
    1292,	// Under/Over Match Sixes Away Team - 1st Inning	
    1293,	// Under/Over Match Fours Home Team - 1st Inning	
    1294,	// Under/Over Match Fours Away Team - 1st Inning	
    1295,	// Under/Over Top Batsman	
    1296,	// 1st inning 1st Over Dismissal - Home Team	
    1297,	// 1st Inning 2nd Over Dismissal - Home Team	
    1298,	// 1st Inning 3rd Over Dismissal - Home Team	
    1299,	// 1st Inning 2nd Over Dismissal - Away Team	
    1300,	// 1st Inning 3rd Over Dismissal - Away Team	
    1301,	// 1st Inning 1st Over Dismissal - Away Team	
    1302,	// Highest Scoring Over - Under/Over	
    1303,	// 1st Inning 2nd Over Under/Over - Home Team	
    1304,	// 1st Inning 3rd Over Under/Over - Home Team	
    1306,	// 1st Inning 3rd Over Under/Over - Away Team	
    1307,	// 1st Inning 2nd Over Under/Over - Away Team	
    1309,	// Winning Margin - Teams	
    1310,	// Winning Margin - Teams Including Overtime	14	{"Id":140288572010512940,"Name":"Away 14-16","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"351.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:12:37.609Z","ParticipantId":null}
    1311,	// Winning Margin - Teams With Draw	
    1312,	// Winning Margin Exact	
    1314,	// Winning Margin Ranges	
    1315,	// Winning Margin Exact - Teams	
    1316,	// Winning Margin - Teams With Any Other Score	3	{"Id":110722903210512940,"Name":"Any Other Result","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"17.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:06:22.469Z","ParticipantId":null}
    1318,	// Asian Handicap Fouls - 1st Period	
    1319,	// Asian Handicap Offsides - 1st Period	
    1320,	// Asian Handicap Offsides - 2nd Period	
    1321,	// Asian Handicap Fouls - 2nd Period	
    1322,	// Asian Handicap Shots On Target - 2nd Period	
    1323,	// Asian Handicap Total Shots - 2nd Period	
    1324,	// Under/Over Offsides - 1st Period	
    1325,	// Under/Over Offsides - 2nd Period	
    1326,	// First Foul	
    1327,	// First Two Pointer	
    1328,	// First Three Pointer	
    1329,	// Last Two Pointer	
    1330,	// Last Three Pointer	
    1331,	// Last Free Throw Scored	
    1332,	// First Free Throw Scored	
    1333,	// First Rebound	
    1334,	// Last Timeout	
    1335,	// Winning Margin Teams - 1st Period	13	{"Id":198417701410512930,"Name":"Away 7-8","Line":null,"BaseLine":null,"Status":3,"StartPrice":"1.0","Price":"101.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":1,"ProviderBetId":null,"LastUpdate":"2023-04-26T00:48:41.252Z","ParticipantId":null}
    1336,	// Winning Margin Teams - 2nd Period	
    1337,	// Winning Margin Teams - 3rd Period	
    1338,	// Winning Margin Teams - 4th Period	
    1339,	// Winning Margin Teams - 5th Period	
    1340,	// Last Foul	
    1341,	// Under/Over 10th Period	
    1342,	// Under/Over 11th Period	
    1343,	// Under/Over 12th Period	
    1344,	// Under/Over 13th Period	
    1345,	// Under/Over 14th Period	
    1346,	// Under/Over 15th Period	
    1347,	// Under/Over 16th Period	
    1348,	// Under/Over 17th Period	
    1349,	// Under/Over 18th Period	
    1350,	// Under/Over 19th Period	
    1351,	// Under/Over 20th Period	
    1352,	// Under/Over 21st Period	
    1353,	// Under/Over 22nd Period	
    1354,	// Under/Over 23rd Period	
    1355,	// Under/Over 24th Period	
    1356,	// Under/Over 25th Period	
    1357,	// Under/Over 26th Period	
    1358,	// Under/Over 27th Period	
    1359,	// Under/Over 28th Period	
    1360,	// Under/Over 29th Period	
    1361,	// Under/Over 30th Period	
    1362,	// Under/Over 31st Period	
    1363,	// Under/Over 32nd Period	
    1364,	// Under/Over 33rd Period	
    1365,	// Under/Over 34th Period	
    1366,	// Under/Over 35th Period	
    1367,	// Asian Handicap 11th Period	
    1368,	// Asian Handicap 12th Period	
    1369,	// Asian Handicap 13th Period	
    1370,	// Asian Handicap 14th Period	
    1371,	// Asian Handicap 15th Period	
    1372,	// Asian Handicap 16th Period	
    1373,	// Asian Handicap 17th Period	
    1374,	// Asian Handicap 18th Period	
    1375,	// Asian Handicap 19th Period	
    1376,	// Asian Handicap 20th Period	
    1377,	// Asian Handicap 21st Period	
    1378,	// Asian Handicap 22nd Period	
    1379,	// Asian Handicap 23rd Period	
    1380,	// Asian Handicap 24th Period	
    1381,	// Asian Handicap 25th Period	
    1382,	// Asian Handicap 26th Period	
    1383,	// Asian Handicap 27th Period	
    1384,	// Asian Handicap 28th Period	
    1385,	// Asian Handicap 29th Period	
    1386,	// Asian Handicap 30th Period	
    1387,	// Asian Handicap 31st Period	
    1388,	// Asian Handicap 32nd Period	
    1389,	// Asian Handicap 33rd Period	
    1390,	// Asian Handicap 34th Period	
    1391,	// Asian Handicap 35th Period	
    1392,	// To Finish In Top 10	
    1393,	// To Stay Up	
    1394,	// Asian Handicap 10th Period	
    1395,	// Under/Over Player Powerplay Points	
    1396,	// Under/Over Player Plus/Minus	
    1397,	// Under/Over Player Shots	
    1398,	// Top Victorian Club	
    1399,	// Under/Over Run Outs	
    1400,	// Under/Over Frames	
    1401,	// Top 20 Winner	
    1402,	// 1st Round Leader	
    1403,	// Under/Over Games In Set	
    1404,	// 1st Round Six Shooter - Group A	
    1405,	// 1st Round Six Shooter - Group B	
    1406,	// 1st Round 3 Balls	
    1407,	// 1st Round 18 Hole Match-Ups	
    1408,	// Match Handicap	
    1409,	// Team With Top Bowler	
    1410,	// To Win The Toss And The Match	
    1411,	// Under/Over Turrets Destroyed	
    1412,	// Under/Over Turrets Destroyed - 1st Period	
    1413,	// Under/Over Turrets Destroyed - 2nd Period	
    1414,	// Under/Over Turrets Destroyed - 3rd Period	
    1415,	// Highest Score After 1st Over	
    1416,	// Home Team Under/Over Runs - 1st Over to 6th Over	
    1417,	// Away Team Under/Over Runs - 1st Over to 6th Over	
    1418,	// Home Team Under/Over Runs - 1st Over to 8th Over	
    1419,	// Away Team Under/Over Runs - 1st Over to 8th Over	
    1420,	// Home Team Under/Over Runs - 1st Over to 10th Over	
    1421,	// Away Team Under/Over Runs - 1st Over to 10th Over	
    1422,	// To Chase Over 180 Runs And Team to Win	
    1423,	// How Many Runs Will Be Scored From The First Ball	
    1424,	// Under/Over Match Stumpings	
    1425,	// 1st Wicket Method	
    1426,	// First Ball Of The Match	
    1427,	// Under/Over - 1st Inning	
    1428,	// Top Non Victorian Club	
    1429,	// Grand Final Winner	
    1430,	// Grand Final Winning State	
    1431,	// To Reach the Grand Final	
    1432,	// Not To Finish In Top 8	
    1434,	// Under/Over Kills 4th Period - Away Team	
    1435,	// Under/Over Kills 5th Period - Away Team	
    1436,	// Under/Over Kills 4th Period - Home Team	
    1437,	// Under/Over Kills 5th Period - Home Team	
    1438,	// Under/Over Temperature At Airport (Celsius)	
    1439,	// Asian Handicap - Full Time	38	{"Id":46243074310529120,"Name":"1","Line":"-0.75","BaseLine":"-0.75","Status":1,"StartPrice":"1.0","Price":"2.136","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:37:56.652Z","ParticipantId":null}
    1440,	// Under/Over Value Of All Numbers Drawn	
    1441,	// Under/Over Value Of All Odd Numbers Drawn	
    1442,	// Under/Over Value Of All Even Numbers Drawn	
    1443,	// More Even Are Drawn Than Odd Numbers	
    1444,	// Consecutive Numbers Will Be Drawn	
    1445,	// Under/Exactly/Over - Number Of Odd Numbered Balls Drawn	
    1446,	// Under/Exactly/Over - Number Of Even Numbered Balls Drawn	
    1447,	// Sum of 5 Bonus Balls	
    1448,	// First Bonus Ball Drawn - Odd/Even	
    1449,	// Last Bonus Ball Drawn - Odd/Even	
    1450,	// First Bonus Ball	
    1451,	// Last Bonus Ball	
    1452,	// The Lowest of 5 Bonus Balls	
    1453,	// Bonus Ball - Odd/Even	
    1454,	// Identical Numbers Will Be Drawn	
    1455,	// Highest Number Drawn - Odd/Even	
    1456,	// Lowest Number Drawn - Odd/Even	
    1457,	// Ball 1 - Under/Over	
    1458,	// Ball 1 - Odd/Even	
    1459,	// Ball 2 - Under/Over	
    1460,	// Ball 2 - Odd/Even	
    1461,	// Ball 3 - Under/Over	
    1462,	// Ball 3 - Odd/Even	
    1463,	// Ball 4 - Under/Over	
    1464,	// Ball 4 - Odd/Even	
    1465,	// Ball 5 - Under/Over	
    1466,	// Ball 5 - Odd/Even	
    1467,	// Ball 6 - Under/Over	
    1468,	// Ball 6 - Odd/Even	
    1469,	// Ball 7 - Under/Over	
    1470,	// Ball 7 - Odd/Even	
    1471,	// Ball 8 - Under/Over	
    1472,	// Ball 8 - Odd/Even	
    1473,	// Ball 9 - Under/Over	
    1474,	// Ball 9 - Odd/Even	
    1475,	// Ball 10 - Under/Over	
    1476,	// Ball 10 - Odd/Even	
    1477,	// Ball 11 - Under/Over	
    1478,	// Ball 11 - Odd/Even	
    1479,	// Ball 12 - Under/Over	
    1480,	// Ball 12 - Odd/Even	
    1481,	// Ball 13 - Under/Over	
    1482,	// Ball 13 - Odd/Even	
    1483,	// Ball 14 - Under/Over	
    1484,	// Ball 14 - Odd/Even	
    1485,	// Ball 15 - Under/Over	
    1486,	// Ball 15 - Odd/Even	
    1487,	// Ball 16 - Under/Over	
    1488,	// Ball 16 - Odd/Even	
    1489,	// Ball 17 - Under/Over	
    1490,	// Ball 17 - Odd/Even	
    1491,	// Ball 18 - Under/Over	
    1492,	// Ball 18 - Odd/Even	
    1493,	// Ball 19 - Under/Over	
    1494,	// Ball 19 - Odd/Even	
    1495,	// Ball 20 - Under/Over	
    1496,	// Ball 20 - Odd/Even	
    1497,	// At Least One Of The Numbers Drawn Is Divisible By 3	
    1498,	// At Least One Of The Numbers Drawn Is Divisible By 4	
    1499,	// At Least One Of The Numbers Drawn Is Divisible By 5	
    1500,	// At Least One Of The Numbers Drawn Is Divisible By 7	
    1501,	// At Least One Of The Numbers Drawn Is Divisible By 10	
    1502,	// At Least One Of The Numbers Drawn Is Divisible By 15	
    1503,	// At Least One Of The Numbers Drawn Is Divisible By 20	
    1504,	// Highest Number Drawn - Under/Over	
    1505,	//  Total Value Of The Lowest And Highest Numbers Drawn - Under/Over	
    1506,	// Lowest Number Drawn - Under/Over	
    1507,	// Difference Between The Highest And The Lowest Numbers Drawn - Under/Over	
    1508,	// Total Value Of The Lowest And Highest Numbers Drawn - Odd/Even	
    1509,	//  Difference Between The Highest And The Lowest Numbers Drawn - Odd/Even	
    1510,	// First Number Drawn Is Greater Than The Last Number Drawn	
    1511,	// Last Number Drawn - Odd/Even	
    1512,	// First Number Drawn - Odd/Even	
    1513,	// All Drawn Numbers Even	
    1514,	// All Drawn Numbers Odd	
    1515,	// Number To Draw	
    1520,	// 4th Period - 1st Turret	
    1521,	// 5th Period - 1st Turret	
    1523,	// Under/Over Barons Slain - 4th Period	
    1524,	// Under/Over Barons Slain - 5th Period	
    1525,	// Under/Over Dragons Slain - 4th Period	
    1526,	// Under/Over Dragons Slain - 5th Period	
    1527,	// Under/Over Turrets Destroyed - 4th Period	
    1528,	// Under/Over Turrets Destroyed - 5th Period	
    1529,	// 4th Period Duration	
    1530,	// 5th Period Duration	
    1531,	// Odd/Even Kills - 4th Period	
    1532,	// Odd/Even Kills - 5th Period	
    1533,	// Under/Over Inhibitors - 1st Period	
    1534,	// Under/Over Inhibitors - 2nd Period	
    1535,	// Temperature At Airport in Range (Celsius)	
    1536,	// Under/Over Maps	
    1537,	// Home Team To Win & Under/Over - Including Overtime	
    1538,	// Away Team To Win & Under/Over - Including Overtime	
    1539,	// Round Winner	
    1540,	// Total Match Legs Under/Over	
    1541,	// Rounds Handicap	
    1542,	// 1st Leg Winner	
    1543,	// First To Win 3 Legs	
    1544,	// First To Win 6 Legs	
    1545,	// First To Win 9 Legs	
    1546,	// 4th Period - 1st Roshan	
    1547,	// 5th Period - 1st Roshan	
    1548,	// 4th Period - 1st Barracks	
    1549,	// 5th Period - 1st Barracks	
    1550,	// 4th Period - 1st Tower	
    1551,	// 5th Period - 1st Tower	
    1552,	// Asian Under/Over Corners	
    1553,	// Both Teams To Score Number Of Points - 1st Period	
    1554,	// Both Teams To Score Number Of Points - 1st Half	
    1555,	// Under/Over 5th Period - Home Team	
    1556,	// Under/Over 5th Period - Away Team	
    1558,	// 핸디캡	10	{"Id":{"low":-888120761,"high":7135865,"unsigned":false},"Name":"1","Line":"-3.5","BaseLine":"-3.5","Status":1,"StartPrice":"1.85","Price":"1.85","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:42:30.421Z","ParticipantId":null}
    1559,	// Cup Winner	
    1561,	// 1st 3 Innings Winner	
    1562,	// 1st 3 Innings Under/Over	
    1563,	// Time Of Scoring	
    1564,	// Time Of Scoring - Home Team	
    1565,	// Time Of Scoring - Away Team	
    1566,	// Match Time Result	
    1567,	// Top Nationality - South African	
    1568,	// Top Nationality - Spaniard	
    1569,	// Top Nationality - Irish	
    1570,	// Top Nationality - South American	
    1571,	// Top Nationality - Canadian	
    1572,	// Top Nationality - Englishman	
    1573,	// Top Nationality - Continental European	
    1575,	// To Make Cut	
    1576,	// To Miss Cut	
    1577,	// Top Nationality - American	
    1578,	// Nationality Of Winner	
    1579,	// Asian Handicap Points - 1st Period	
    1580,	// Asian Handicap Points - 2nd Period	
    1581,	// Asian Handicap Points - 3rd Period	
    1583,	// Top Team Bowler 1st Inning - Home Team	
    1584,	// Top Team Bowler 1st Inning - Away Team	
    1585,	// Top Team Batsman 1st Inning - Home Team	
    1586,	// Top Team Batsman 1st Inning - Away Team	
    1587,	// Will there be an Ace Next Point 	
    1589,	// Will there be a Double Fault Next Point	
    1591,	// Under/Over - 1st Over	
    1592,	// To Win League	
    1593,	// To Win Division	
    1594,	// Most Hits - Including Overtime	
    1595,	// Fight to Go The Distance 	
    1596,	// When Will The Fight End	
    1597,	// Fight Outcome	
    1598,	// Round Betting	
    1599,	// Top 1st Hit	
    1600,	// Bottom 1st Hit	
    1601,	// Top 1st Run	
    1602,	// Bottom 1st Run	
    1603,	// Most Hits In The 1st Inning	
    1605,	// Team With Highest Scoring Inning	
    1606,	// Both Teams To Score 2 Or More Goals	
    1607,	// Both Teams To Score 3 Or More Goals	
    1608,	// Team To Win The Most Periods	
    1609,	// Asian Handicap Full Time - 1st Period	
    1610,	// Asian Handicap Full Time - 2nd Period	
    1611,	// Asian Handicap Full Time - 3rd Period	
    1612,	// MVP	
    1613,	// Regular Season Wins	
    1614,	// To Win Conference	
    1615,	// Winning Conference 	
    1616,	// Season Specials	
    1617,	// Season Player Specials	
    1618,	// 1st 5 Innings Winner - 12	
    1619,	// 1st Period - Halftime Winner Home/Away 	
    1620,	// 1st Period - Halftime Asian Handicap	
    1621,	// 2nd Period - Halftime Winner Home/Away	
    1622,	// 2nd Period - Halftime Asian Handicap	
    1624,	// Under/Over Player Runs	
    1625,	// Under/Over Player Singles	
    1626,	// Under/Over Player Home Runs	
    1627,	// Under/Over Player Stolen Bases	
    1628,	// Under/Over Player Doubles	
    1629,	// Under/Over Player Triples	
    1630,	// Pitcher To Record The Win	
    1631,	// Under/Over Player Total Bases	
    1635,	// Under/Over Pitcher Runs Earned	
    1636,	// Under/Over Pitcher Hits Allowed	
    1637,	// Under/Over Pitcher Strikeouts	
    1638,	// Team Classification	
    1639,	// Young Rider Classification	
    1640,	// Points Classification	
    1641,	// King of the Mountains	
    1642,	// Stage 1	
    1649,	// Fastest Lap	
    1650,	// Winning Car	
    1651,	// First Driver to Retire	
    1652,	//  Qualifying Winning Car	
    1653,	// Fastest in Practice 1	
    1654,	// Points Finish	
    1655,	// Fastest Qualifier	
    1657,	// Stage 3	
    1658,	// Stage 2	
    1659,	// First Constructor Retirement	
    1660,	// Grid Position of Winner	
    1661,	// Safety Car Period During Race	
    1662,	// Number of Classified Drivers	
    1663,	// Virtual Safety Car Period During Race	
    1664,	// Hole Score	
    1665,	// Player Scores - Specific Hole	
    1666,	// Player Matchups - Specific Hole	
    1667,	// To Win Hole	
    1668,	// Player Matchups - Specific Holes	
    1669,	// Player Scores - Specific Holes	
    1670,	// Tied Match	
    1671,	// Under/Over Goals - 2nd Period	
    1672,	// Under/Over Goals - 2nd Half	
    1673,	// Odd/Even Rounds 4th Period	
    1674,	// Odd/Even Rounds 5th Period	
    1675,	// 2nd Round Leader	
    1676,	// Both Teams to Score - Including Overtime	
    1677,	// Last Team to Score - Including Overtime	
    1678,	// Top Nationality - German	
    1679,	// Top Nationality - Austrian	
    1680,	// Top Nationality - New Zealander	
    1681,	// Top Left Handed Player	
    1682,	// Top Amateur	
    1683,	// Top Nationality - Korean	
    1684,	// Top Nationality - Scandinavian	
    1685,	// Top Nationality - Frenchman	
    1686,	// Top Former Winner	
    1687,	// Top Nationality - Swede	
    1688,	// Top Nationality - Japanese	
    1689,	// Top Nationality - Scotsman	
    1690,	// Top Nationality - Belgian	
    1691,	//  European Handicap 4th Period	
    1692,	// European Handicap 3rd Period	9	{"Id":176948151010525730,"Name":"1","Line":"0:1","BaseLine":"0:1","Status":1,"StartPrice":"1.0","Price":"2.13","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:57:42.582Z","ParticipantId":null}
    1693,	// European Handicap 2nd Period	9	{"Id":143295310610525730,"Name":"2","Line":"1:0","BaseLine":"0:1","Status":1,"StartPrice":"1.0","Price":"1.72","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:32:21.937Z","ParticipantId":null}
    1694,	// European Handicap 1st Period	9	{"Id":212532958910525730,"Name":"1","Line":"1:0","BaseLine":"1:0","Status":3,"StartPrice":"1.0","Price":"1.8","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":2,"ProviderBetId":null,"LastUpdate":"2023-04-26T03:38:34.261Z","ParticipantId":null}
    1695,	// Round Score	
    1696,	// Tournament Winning Score	
    1697,	// Leading Score After Round	
    1698,	// To Hit The Fairway With Tee Shot	
    1699,	// To Hit Green In Regulation	
    1700,	// 3rd Round Leader	
    1701,	// 4th Round Leader	
    1702,	// Under/Over Player Passing Attempts	
    1703,	// Under/Over Player Passing Completions	
    1704,	// Touchdown on 1st Period	
    1705,	// Touchdown on 2nd Period	
    1706,	// Touchdown on 3rd Period	
    1707,	// Touchdown on 4th Period	
    1708,	// Under/Exactly/Over - Home Team Touchdowns 	
    1709,	// Under/Exactly/Over - Away Team Touchdowns 	
    1710,	// Under/Exactly/Over - Home Team 1st Half Touchdowns	
    1711,	// Under/Exactly/Over - Away Team 1st Half Touchdowns	
    1712,	// 16th Round Winner - 4th Period	
    1713,	// 16th Round Winner - 5th Period	
    1714,	// Under/Over Towers Destroyed - 4th Period	
    1715,	// Under/Over Towers Destroyed - 5th Period	
    1716,	// Most Regular Season Passing Yards	
    1717,	// Most Regular Season Receiving Yards	
    1718,	// Most Regular Season Rushing Yards	
    1719,	// Defensive Rookie Of The Year	
    1720,	// AP NFL Defensive Player of The Year	
    1721,	// Offensive Rookie of The Year	
    1722,	// Set to Finish to Nil	
    1723,	// Under/Over Kills - 1st Period - 1st Round	
    1724,	// Under/Over Kills - 2nd Period - 1st Round	
    1725,	// Under/Over Kills - 3rd Period - 1st Round	
    1726,	// Under/Over Kills - 4th Period - 1st Round	
    1727,	// Under/Over Kills - 5th Period - 1st Round	
    1728,	// Both Teams to Score - Extra Time	
    1729,	// Double Chance - Extra Time	
    1730,	// Will The Game Go To Super Over?	
    1731,	// Double Chance 5th Period	
    1732,	// Double Chance 6th Period	
    1733,	// Double Chance 7th Period	
    1734,	// Double Chance 8th Period	
    1735,	// Double Chance 9th Period	
    1736,	// Number of Runs 1st Inning	
    1737,	// Number of Runs 2nd Inning	
    1738,	// Number of Runs 3rd Inning	
    1739,	// Number of Runs 4th Inning	
    1740,	// Number of Runs 5th Inning	
    1741,	// Number of Runs 6th Inning	
    1742,	// Number of Runs 7th Inning	
    1743,	// Number of Runs 8th Inning	
    1744,	// A Fifty to be Scored in the 1st Innings	
    1745,	// Fall Of 1st Wicket	
    1746,	// To Score Most Runs	
    1747,	// Next Man Out	
    1748,	// Completed Match	
    1749,	// Century Scored	
    1750,	// Century Scored - 1st Inning	
    1751,	// Home Team First Dismissal 6-Way	
    1752,	// Away Team First Dismissal 6-Way	
    1753,	// Top Match Batsman	
    1754,	// To Score a Penalty	
    1755,	// To Win Conference - NBA Eastern Conference	
    1756,	// Coach of the Year	
    1757,	// Most Improved Player	
    1758,	// 6th Man of the Year	
    1759,	// Defensive Player of the Year	
    1760,	// Rookie of the Year	
    1761,	// Regular Season MVP	
    1762,	// Under/Exactly/Over - 4th Period Including Overtime	
    1763,	// Batsman to Score a Hundred in 1st Innings	
    1765,	// 9 Dart Finish in the match	
    1766,	// Time of First Try	
    1767,	// Time of Last Try	
    1770,	// 9 Dart Finish in the Match - Home Team 	
    1771,	// 9 Dart Finish in the Match - Away Team 	
    1772,	// Top Run Scorer	
    1773,	// Top Run Scorer - Home Team	
    1774,	// Top Run Scorer - Away Team	
    1775,	// Team of Top Run Scorer	
    1776,	// Under/Over Punts	
    1777,	// Under/Over Sacks	
    1778,	// Under/Over 1st Downs 	
    1779,	// 1st Team To Get A First Down	
    1780,	// 1st Half Under/Over Field Goals - Home Team	
    1781,	// 1st Half Under/Over Field Goals - Away Team	
    1782,	// Under/Exactly/Over - Field Goals 1st Half	
    1783,	// Under/Over Touchdowns 1st Period	
    1784,	// Under/Over Penalties Accepted	
    1785,	// Most Kills in the Match	
    1786,	// Team with Most Kills in the Match	
    1787,	// Under/Over Pass Attempts	
    1788,	//  Under/Over Pass Completions	
    1789,	// Under/Over Passing Yards	
    1790,	// Under/Over Rush Attempts	
    1791,	// Under/Over Rush Yards	
    1792,	// Under/Over Player Tackles and Assist	
    1793,	// Team to Score Punt First	
    1794,	// Team to Punt First	
    1795,	// 1st Period 1X2 And Under/Over	
    1796,	// 1X2 Assists	
    1797,	// Double Chance Assists	
    1798,	// Team to Lead After Every Period	
    1799,	// Team with Most Passing Yards	
    1800,	// Team with Most Rushing Yards	
    1801,	// Successful 2 Point Conversion	
    1802,	// Under/Over Touchdown Passes 	
    1803,	// Under/Over Field Goals 1st Period	
    1804,	// Score in Last 2 Minutes of the 1st Half	
    1805,	// Team to Receive Opening Kick Off	
    1806,	// Under/Over Home Team Touchdowns - 1st period	
    1807,	// Under/Over Away Team Touchdowns - 1st period	
    1808,	// Under/Exactly/Over Home Team Touchdowns - 1st period	
    1809,	// Under/Exactly/Over Away Team Touchdowns - 1st period	
    1810,	// Under/Over Home Team Field Goals - 1st period	
    1812,	// Under/Over Away Team Field Goals - 1st period	
    // 1813,	// Away Team to Win Every Quarter	
    // 1814,	// Home Team to Win Every Quarter	
    1815,	// First Offensive Play of the Game	
    // 1816,	// To Win Quarter	
    1817,	// To Reach the Final	
    1818,	// Home Team to Score 25 Goals	
    1819,	// Home Team to Score 30 Goals	
    1820,	// Away Team to Score 25 Goals	
    1821,	// Away Team to Score 30 Goals	
    1822,	// Home Team To Win Either Half	
    1823,	// Away Team To Win Either Half	
    1824,	// Stage of Elimination	
    1825,	// Under/Over Assists	
    1826,	// Under/Over Rebounds	
    1827,	// Under/Over Home team Assists	
    1828,	// Under/Over Away Team Assists	
    1829,	// Under/Over Home Team Rebounds	
    1830,	// Under/Over Away Team Rebounds	
    1831,	// 1X2 3 Points Made	
    1832,	// Under/Over 3 Points Made	
    1833,	// Under/Over Home Team 3 Points Made	
    1834,	// Under/Over Away Team 3 Points Made	
    1835,	// Asian Handicap 3 Points Made	
    1836,	// 1X2 and Double Chance - Corners	
    1837,	// 1X2 and Double Chance - Corners 1st Period	
    1838,	// 1X2 and Double Chance - Corners 2nd Period	
    1839,	// 1X2 and Double Chance Yellow Cards - 1st Period 	
    1840,	// 1X2 and Double Chance - Yellow Cards	
    1841,	// First Substitutions	
    1842,	// 2nd Goal in the match	
    1843,	// 3rd Goal in the match	
    1844,	// 4th Goal in the match	
    1845,	// 5th Goal in the match	
    1846,	// 60 Minute Result	
    1847,	// 75 Minute Result	
    1848,	// Goal Scored In The First 5 Minutes?	
    1849,	// First Throw-in in the Match	
    1850,	// Draw in Either Half	
    1851,	// Headed Goal in the Match?	
    1852,	// Under/Over Goal Minutes	
    1853,	// Under/Over Tie Break in the match	6	{"Id":59027925910507020,"Name":"Under","Line":"2.5","BaseLine":"2.5","Status":2,"StartPrice":"1.0","Price":"1.001","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:58:00.448Z","ParticipantId":null}
    1854,	// Under/Over Break points	
    1855,	// Under/Over Break Points Home Team	
    1856,	// Under/Over Break Points Away Team	
    // 1857,	// Under/Over Highest Scoring Quarter	
    // 1858,	// Under/Over Lowest Scoring Quarter	
    1859,	// Most Tries 3-Way	
    1860,	// 10 Minute Winning Margin 5-Way	
    1861,	// Most Losses Team	
    1862,	// A Sub Will score in the Game	
    1863,	// Win All Periods - Home Team	
    1864,	// Win All Periods - Away Team	
    1865,	// First 10 Minute Under/Over Tries	
    1866,	// 15 Minute Under/Over - Corners	
    1867,	// 2 Goals in a Row by Home Team	
    1868,	// 2 Goals in a Row by Away Team	
    1869,	// Most Converted Tries 	
    1870,	// Under/Over Saves	
    1871,	// 1X2 Saves	
    1872,	// Unseeded Finalist?	
    1873,	// Wild Card To Reach Final?	
    1874,	// Winning Half - Tennis Outright	
    // 1875,	// Winning Quarter - Tennis Outright	
    1876,	// 1X2 Rebounds	
    1877,	// Asian Handicap Rebounds	
    1878,	// Asian Handicap Assists	
    1881,	// Hole In One	
    1882,	// Will There Be a Play-off?	
    1883,	// 72 Hole Match Ups	
    1884,	// 54 Hole Match Ups	
    1885,	// Number 1 Draft Pick	
    1886,	// 1X2 and Double Chance	
    1887,	// Home Team to Win\Draw and Both teams to score	
    1888,	// Away Team to Win\Draw and Both teams to score	
    1889,	// Winning Margin - 1st Half	13	{"Id":94861379910512940,"Name":"Away 4-6","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"126.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T01:07:32.306Z","ParticipantId":null}
    1890,	// Under/Over 1st Innings 6 Over	
    1891,	// American League Cy Young	
    1892,	// American League MVP	
    1893,	// National League Cy Young	
    1894,	// National League MVP	
    1895,	// Pitcher To Record The Most Regular Season Wins	
    1896,	// Player To Hit The Most Regular Season Home Runs	
    1897,	// Will Game Decided in Extra Time?	
    1898,	// Regular season Winning %	
    1899,	// Point Betting	310	{"Id":51003222010512936,"Name":"2","Line":"29.0","BaseLine":"29.0","Status":2,"StartPrice":"1.0","Price":"1.833","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T00:40:53.849Z","ParticipantId":null}
    1900,	// Player Top Goalscorer	
    1901,	// Under/Over Tackles	
    1902,	// Number 2 Draft Pick	
    1903,	// Minor Premiership Winner	
    1904,	// Under/Over Tackles - Home Team	
    1905,	// Under/Over Tackles - Away Team	
    1906,	// First Offensive Lineman Drafted	
    1907,	// First Running Back Draft Pick	
    1908,	// First Wide Receiver Draft Pick	
    1909,	// First Quarterback Draft Pick	
    1910,	// Under\Over Quarterbacks Drafted in 1st Round	
    1911,	// PFA Player of the Year	
    1912,	// 1st Innings 6 Over Total	
    1913,	// 1st Innings Runs	
    1914,	// 2nd Innings Runs	
    1915,	// Season Race Wins	
    1916,	// Under/Over Fouls	
    1917,	// Under/Over Posts and Crossbars	
    1918,	// 1x2 Posts and Crossbars	
    1919,	// Under/Over Posts and Crossbars - Home Team	
    1920,	// Under/Over Posts and Crossbars - Away Team	
    1921,	//  Double Chance Posts and Crossbars	
    1922,	// Asian Handicap and Under/Over	
    1923,	// To Win Regional	
    1924,	// 1st Innings Runs - Home Team 	
    1925,	// 1st Innings Runs - Away Team 	
    1926,	// Under/Over - 1st Period - Goals	
    1927,	// Under/Over Goal Kicks	
    1928,	// Under/Over Goal Kicks - Home Team	
    1929,	// Under/Over Goal Kicks - Away Team	
    1930,	// Under/Over Saves - Home Team	
    1931,	// Under/Over Saves - Away Team	
    1932,	// Under/Over Ball Possession	
    1933,	// Under/Over Ball Possession - Home Team	
    1934,	// Under/Over Ball Possession - Away Team	
    1935,	// Score Draw?	
    1936,	// 1st Corner - 1st Period	
    1937,	// 1st Corner - 2nd Period	
    // 1938,	// To Reach the Quarter Finals	
    1940,	// Under/Over Corners between 15:01 Min to 30:00 min	
    1941,	// Under/Over Corners between 30:01 Min to Half Time	
    1942,	// Under/Over Corners between  Half Time to 60.00 Min	
    1943,	// Under/Over Corners between  60:01 Min to 75:00 Min	
    1944,	// Under/Over Corners between  75:01 Min to Full Time	
    1945,	// Will Hit the post or crossbar?	
    1946,	// Race To 2 Goals	
    1947,	// Race To 3 Goals	
    1948,	// Match Play H2H	
    1949,	// National League Rookie of the Year	
    1950,	// Most Regular Season Strikeouts	
    1951,	// Most Regular Season Stolen Bases	
    1952,	// Most Regular Season Saves	
    1953,	// Most Regular Season Runs Scored	
    1954,	// Most Regular Season RBIs	
    1955,	// Most Regular Season Hits	
    1956,	// American League Rookie of the Year	
    1957,	// Under/Over 1st Period Minutes	
    1958,	// Under/Over Match Minutes	
    1959,	// Under/Over Winning % on 1st Serve - Home Team	
    1960,	// Under/Over Winning % on 1st Serve - Away Team	
    1961,	// Under/Over Winning % on 2nd Serve - Home Team	
    1962,	// Under/Over Winning % on 2nd Serve - Away Team	
    1963,	// 1st Serve % Asian Handicap	
    1964,	// 1X2 Goal Kick	
    1965,	// Double Chance - Goal Kick	
    1966,	// Odd/Even Goal Kick	
    1967,	// Goal Kick Handicap	
    1968,	// Under/Over 10 Minute Penalties Scored	
    1969,	// Under/Over Penalties Scored	
    1970,	// Most Tries 2-Way	
    1971,	// 10 Minute Result 2-Way	
    1972,	// Regular Season Winner	
    1973,	// Under/Over Steals	
    1975,	// Under/Over Added Time - 1st Period	
    1976,	// Under/Over Added Time - 2nd Period	
    1977,	// Under/Over Distance Covered, km	
    1978,	// Under/Over Distance Covered, km - Home Team	
    1979,	// Under/Over Distance Covered, km - Away Team	
    1980,	// Under/Over Passes Completed % - Away Team	
    1981,	// Under/Over Passes Completed % - Home Team	
    1982,	// Under/Over Short Passes Completed % - Home Team	
    1983,	// Under/Over Short Passes Completed % - Away Team	
    1984,	// Under/Over Medium Passes Completed % - Home Team	
    1985,	// Under/Over Medium Passes Completed % - Away Team	
    1986,	// Under/Over Long Passes Completed % - Home Team	
    1987,	// Under/Over Long Passes Completed % - Away Team	
    1988,	// Under/Over Steals - Home Team	
    1989,	// Under/Over Steals - Away Team	
    1990,	// Under/Over Breaks	
    1991,	// Under/Over Breaks - Home team	
    1992,	// Under/Over Breaks - Away team	
    1993,	// Under/Over Breaks 1st Period	
    1994,	// Under/Over Breaks 1st Period - Home Team	
    1995,	// Under/Over Breaks 1st Period - Away Team	
    1996,	// Under/Over Free Throws Scored	
    1997,	// Under/Over Free Throws Scored - Home Team	
    1998,	// Under/Over Free Throws Scored - Away Team	
    1999,	// 3-Way Team With Highest Scoring Period 	
    2000,	// Fall Of 1st Wicket, 1st Inning	
    2001,	// Wicket in Over 1, 1st Innings?	
    2002,	// Most Runs in 1st 15 Overs?	
    2003,	// Under/Over 1st Over Runs Scored, 1st Innings 	
    2004,	// 1st Round 2 Balls	
    2005,	// Under/Over 2 Points Made	
    2006,	// Under/Over Home Team 2 Points Made	
    2007,	// Under/Over Away Team 2 Points Made	
    2008,	// Match Corners Between 	
    2009,	// Home Team Corners Between	
    2010,	// Away Team Corners Between	
    2011,	// Match Cards Between	
    2012,	// Home team Card Between	
    2013,	// Away Team Card Between	
    2014,	// Match Goal Between	
    2015,	// Home team Goal Between	
    2016,	// Away Team Goal Between	
    2017,	// All Periods Score Under	
    2018,	// All Periods Score Over	
    2019,	// All Periods Score Under - Home Team	
    2020,	// All Periods Score Over - Home Team	
    2021,	// All Periods Score Under - Away Team	
    2022,	// All Periods Score Over - Away Team	
    2023,	// Will Any Player Score a Double?	
    2024,	// Top Nationality - Italian	
    2025,	// More Tries Or Penalties	
    2026,	// Under/Over Blocked Shots	
    2027,	// Double Chance Blocked Shots	
    2028,	// Blocked Shots Handicap	
    2029,	// Under/Over Blocked Shots - Home Team	
    2030,	// Under/Over Blocked Shots - Away Team	
    2031,	// Under/Over Blocked Shots 1st period	
    2032,	// Blocked Shots Handicap 1st Period	
    2033,	// Under/Over Powerplay Goals	
    2034,	// Double Chance Powerplay Goals	
    2035,	// Powerplay Goals Handicap	
    2036,	// Under/Over Powerplay Goals - Home Team	
    2037,	// Under/Over Powerplay Goals - Away Team	
    2038,	// Under/Over Powerplay Goals 1st period	
    2039,	// Handicap Powerplay Goals 1st period	
    2040,	// Hits Handicap	
    2041,	// Double Chance Hits	
    2042,	// 1X2 Hits	
    2043,	// Under/Over Penalty time	
    2044,	// Double Chance Penalty time	
    2045,	// Penalty Time Handicap	
    2046,	// Under/Over Penalty Time - Home Team	
    2047,	// Under/Over Penalty Time - Away Team	
    2048,	// Under/Over Penalty Time 1st Period	
    2049,	// Penalty Time Handicap 1st Period	
    2050,	// Under/Over Win Face-Offs	
    2051,	// Double Chance Win Face-Offs	
    2052,	// Win Face-Offs Handicap	
    2053,	// Under/Over Win Face-Offs - Home Team	
    2054,	// Under/Over Win Face-Offs - Away Team	
    2055,	// Under/Over Win Face-Offs 1st Period	
    2056,	// Win Face-Offs Handicap 1st Period	
    2057,	// 1st 3 Innings Handicap	
    2058,	// Each Team to Score in All Periods	
    2059,	// Number Of Runs - Both Teams to Score 	
    2060,	// Under/Over Points Scored Including Overtime	
    2061,	// End of Round Leader	
    2062,	// 1X2 Steals	
    2063,	// Asian Handicap Steals	
    2064,	// Current Game - Correct Score	
    2065,	// First Linebacker Drafted	
    2066,	// First Safety Drafted	
    2067,	// First Cornerback Drafted	
    2068,	// Running Backs Drafted in 1st Round	
    2069,	// Offensive Linemen Drafted in 1st Round	
    2070,	// First Non QB Selected	
    2071,	// Cornerbacks Drafted in 1st Round	
    2072,	// Wide Receivers Drafted in 1st Round	
    2073,	// Number 3 Overall Pick	
    2074,	// Top 5 Pick	
    2075,	// Linebackers Drafted in 1st Round	
    2076,	// Tight Ends Drafted in 1st Round	
    2077,	// Offensive Players Drafted in 1st Round	
    2078,	// First Defensive Linesman Drafted	
    2079,	// Top 10 Pick 	
    2080,	// Defensive Linesmen Drafted in 1st Round	
    2081,	// Safeties Drafted in 1st Round	
    2082,	// 1X2 Powerplay Goals	
    2083,	// 1X2 Win Face-Offs	
    2084,	// 1X2 Penalty Time	
    2085,	// 1X2 shots On Goal	
    2086,	// 1X2 Blocked Shots	
    2087,	// Draft Position	
    2088,	// Team Players Drafted in 1st Round	
    2089,	// 1st 3 Innings Winner -12	
    2090,	// Podium Finish	
    2091,	// Under/Over Saves - Home Team 1st Period	
    2092,	// Under/Over Saves - Away Team 1st Period	
    2093,	// Under/Over Saves - Home Team 2nd Period	
    2094,	// Under/Over Saves - Away Team 2nd Period	
    2095,	// Asian Handicap Saves	
    2096,	// Asian Handicap Goal Kicks 1st Period	
    2097,	// Asian Handicap Goal Kicks 2nd Period	
    2098,	// Under/Over Goal Kicks - Home Team 1st Period	
    2099,	// Under/Over Goal Kicks  - Away Team 1st Period	
    2100,	// Under/Over Goal Kicks  - Home Team 2nd Period	
    2101,	// Under/Over Goal Kicks - Away Team 2nd Period	
    2102,	// Throw-ins Handicap - 2nd Period	
    2103,	// Odd/Even Saves	
    2104,	// Odd/Even Throw-Ins	
    2121,	// 2nd Round 18 Hole Match-Ups	
    2122,	// 3rd Round 18 Hole Match-Ups	
    2123,	// 4th Round 18 Hole Match-Ups	
    2124,	// Lowest scoring period	
    2125,	// 10 Minuets Corner?	
    2126,	// Asian Handicap Yellow Cards - 2nd Period	
    2127,	// Odd/Even Yellow cards	
    2128,	// Double Chance Fouls - 1st Period	
    2129,	// Double Chance Fouls - 2nd Period	
    2130,	// 1X2 Fouls - 1st Period	
    2131,	// 1X2 Fouls - 2nd Period	
    2132,	// Odd/Even Total Shots	
    2133,	// Double Chance Total Shots - 1st Period	
    2134,	// Double Chance Total Shots - 2nd Period	
    2140,	// Under/Over Total Shots - 2nd Period	
    2146,	// 1X2 Shots On Target 1st Period	
    2147,	// Double Chance Shots On Target 1st Period	
    2148,	// Under/Over Shots on Target Home Team 1st Period	
    2149,	// Under/Over Shots On Target Away Team 1st Period	
    2150,	// 1X2 Shots On Target 2nd Period	
    2151,	// Double Chance Shots On Target 2nd Period	
    2152,	// Under/Over Shots On Target 2nd Period	
    2153,	// Under/Over Shots on Target Home Team 2nd Period	
    2155,	// Odd/Even Shots On Target	
    2156,	// Group Betting	
    2157,	// Under/Over Goal Kicks 1st Period	
    2158,	// Under/Over Goal Kicks 2nd Period	
    2159,	// 1X2 Goal Kicks 1st Period	
    2160,	// 1X2 Goal Kicks 2nd Period	
    2161,	// Double Chance Saves	
    2162,	// 1X2 Saves 1st Period	
    2163,	// Double Chance Saves 1st Period	
    2164,	// Asian Handicap Saves 1st Period	
    2165,	// Under/Over Saves 1st Period	
    2166,	// 1X2 Saves 2nd Period	
    2167,	// Double Chance Saves 2nd Period	
    2168,	// Asian Handicap Saves 2nd Period	
    2170,	// Under/Over Saves 2nd Period	
    2171,	// First Driver to Make a Pit Stop	
    2172,	// Both Cars Points Finish	
    2173,	// 1X2 Offsides 1st Period	
    2174,	// 1X2 Offsides 2nd Period	
    2175,	// Double Chance Offsides 1st Period	
    2176,	// Double Chance Offsides 2nd Period	
    2177,	// Under/Over Offsides Home Team 1st Period	
    2178,	// Under/Over Offsides Away Team 1st Period	
    2179,	// Under/Over Offsides Home Team 2nd Period	
    2180,	// Under/Over Offsides Away Team 2nd Period	
    2181,	// 1X2 Throw-Ins 1st Period	
    2182,	// 1X2 Throw-Ins 2nd Period	
    2183,	// Double Chance Throw-Ins 1st Period	
    2184,	// Double Chance Throw-Ins 2nd Period	
    2185,	// Both Cars to be Classified	
    2186,	// To be Classified	
    2187,	// To Finish In Top 20	
    2188,	// To Make The Playoffs	
    2189,	// Not To Make The Playoffs	
    2190,	// Division of Super Bowl Winner Will be?	
    2191,	// Hits Handicap - 1st Inning	
    2192,	// Under/Over Hits - 1st Inning	
    2193,	// 1st Round Six Shooter	
    2194,	// Highest Scoring Team	
    2195,	// Lowest Scoring Team	
    2196,	// To Finish Bottom of Group	
    2197,	// UEFA Player of the Tournament	
    2198,	// Group Qualification Yes-No	
    2199,	// Eliminated by Penalty Shootout	
    2200,	// Finalists	
    2201,	// 8th Period Odd/Even	
    2202,	// 9th Period Odd/Even	
    2203,	// Series Winner - 12	
    2204,	// Winner and Top Goalscorer	
    2205,	// 1X2 Including Super Tie-Break	
    2206,	// Handicap Including Super Tie-Break	
    2207,	// Correct Score Including Super Tie-Break	
    2208,	// Under/Over Including Super Tie-Break	
    2209,	// Under/Over Throw-Ins - 2nd Period	
    2210,	// Player To Hit a Home Run	
    2211,	// Player To Record A Hit	
    2212,	// Player To Record 2 or More Hits	
    2213,	// Player To Record 3 or More Hits	
    2214,	// Player To Record 4 or More Hits	
    2215,	// First To Happen	
    2216,	// Heisman Trophy Winner	
    2217,	// To be a Play Off (Golf)	
    2218,	// Handicap Betting (Golf)	
    2219,	// Straight Forecast	
    2220,	// Winning Margin - Golf	
    2221,	// Under/Over Throw-Ins 2nd Period	
    2222,	// Under/Over Throw-Ins 1st Period - Home Team	
    2223,	// Under/Over Throw-Ins 1st Period - Away Team	
    2224,	// Under/Over Shots 1st Period - Away Team	
    2225,	// Under/Over Shots 1st Period - Home Team	
    2226,	// 1X2 Shots - 1st Period	
    2227,	// 1X2 Shots - 2nd Period	
    2228,	// Asian Handicap - Distance Covered, km 	
    2229,	// Double Chance Goal Kicks - 1st Period	
    2230,	// Double Chance Goal Kicks - 2nd Period	
    2231,	// Top Nationality - Mexican	
    2232,	// 1st Round Six Shooter - Group C	
    2233,	// 1st Round Six Shooter - Group D	
    2234,	// Winning Score 3-Way	
    2235,	// Lowest Tournament Round	
    2236,	// Top Nationality 1st Round - Top American	
    2237,	// Top Nationality 1st Round - Top Continental European	
    2238,	// Top Nationality 1st Round - Top Great Britain & Ireland	
    2239,	// 1st Round - Top 5 Winner	
    2240,	// 1st Round - Top 10 Winner	
    2241,	// 1st Round - Top 20 Winner	
    2242,	// Top Nationality - Danish	
    2243,	// Top Nationality - Welsh	
    2244,	// Most Gold Medals	
    2245,	// Most Medals	
    2246,	// Gold Medal Winner With Line	
    2247,	// Under/Over 1st Innings 6 Over - Home Team	
    2248,	// Under/Over 1st Innings 6 Over - Away Team	
    2249,	// Odd/Even 1st Innings 6 Over - Home Team	
    2250,	// Odd/Even 1st Innings 6 Over - Away Team	
    2251,	// Will The Match End In a Tie?	
    // 2252,	// To Win Quarter - 1st Quarter (Outright)	
    // 2253,	// To Win Quarter - 2nd Quarter (Outright)	
    // 2254,	// To Win Quarter - 3rd Quarter (Outright)	
    // 2255,	// To Win Quarter - 4th Quarter (Outright)	
    2256,	// Race To 50 Points	
    2257,	// Race To 10 Points	
    2258,	// Race To 30 Points	
    2259,	// Asian Handicap 2 Points Made	
    2260,	// Asian Handicap Free Throws Scored	
    2261,	// Double Chance Penalty time - 1st Period	
    2266,	// Under/Over Penalty Time Away Team - 1st Period	
    2267,	// Under/Over Penalty Time Home Team - 1st Period	
    2269,	// Double Chance Powerplay Goals - 1st Period	
    2270,	// Under/Over Powerplay Goals Away Team - 1st Period	
    2271,	// Under/Over Powerplay Goals Home Team - 1st Period	
    2272,	// Under/Over Runs	
    2273,	// 2nd Innings Runs - Home Team	
    2274,	// 2nd Innings Runs - Away Team	
    2275,	// Not To Reach Top 3	
    2277,	// HT/FT Extra Time	
    2278,	// Time Trial	
    2280,	// Under/Over Tries 1st Period	
    2281,	// Under/Over Tries 2nd Period	
    2282,	// Regular Season Wins - Outright	
    2284,	// Asian Under/Over Corners 1st Period	
    2285,	// Double Fault Handicap	
    2286,	// Corners Handicap - 2nd Half 	
    2288,	// Odd/Even Offsides	
    2289,	// Under/Over Fouls 1st Period - Home Team	
    2290,	// Under/Over Fouls 1st Period - Away Team	
    2296,	// Under/Over Player Fours - 1st Inning	
    2297,	// Under/Over Batsman Runs - 1st Inning	
    2298,	// Player Dismissal Method - 1st Inning	
    2299,	// Under/Over Spreads - Home team 1st Inning	
    2300,	// Under/Over Spreads - Away team 1st Inning	
    2301,	// Dismissal Method - Home Team	
    2302,	// Dismissal Method - Away Team	
    2303,	// Dismissal Method - Home Team 1st Inning	
    2304,	// Dismissal Method - Away Team 1st Inning	
    2305,	// Under/Over Runs After Overs - Home Team 1st Inning	
    2306,	// Under/Over Runs After Overs - Away Team 1st Inning	
    2307,	// Under/Over Dismissal - Home Team 1st Inning	
    2308,	// Under/Over Dismissal - Away Team 1st Inning	
    2309,	// To Score - Player - 1st Inning	
    2310,	// Dismissal in Over 1st Inning - Home Team	
    2311,	// Dismissal in Over 1st Inning - Away Team	
    2313,	// Under/Over Runs in Delivery of Over - Home Team 1st Inning	
    2314,	// Under/Over Runs in Delivery of Over - Away Team 1st Inning	
    2334,	// Asian Handicap Break Points	
    2335,	// Most Break Points	
    2336,	// Most Breaks	
    2337,	// Asian Handicap Breaks 	
    2338,	// Team To Make Next Score - 12	
    2339,	// Under/Over Goals - 1st Half	
    2340,	// Under/Over Goals	
    2341,	// 1X2 Home Runs	
    2342,	// Asian Handicap Home Runs 	
    2343,	// Under/Over Home Runs	
    2344,	// Under/Over Home Runs - Away Team	
    2345,	// Under/Over Home Runs - Home Team	
    2346,	// Under/Over Home Runs - 1st Inning	
    2347,	// 1X2 Home Runs - 1st Inning	
    2348,	// Asian Handicap Home Runs - 1st Inning	
    2349,	// Under/Over Home Runs - Away Team 1st Inning	
    2350,	// Under/Over Home Runs - Home Team 1st Inning	
    2351,	// Under/Over Player Shots On Target	
    2352,	// Under/Over Player Tackles 	
    2353,	// Tie-Break Winner - 1st Period	
    2354,	// Tie-Break Winner - 2nd Period	
    2355,	// Tie-Break Winner - 3rd Period	
    2356,	// Enhanced Win Only	
    2357,	// Best Regular Season Record	
    2358,	// Comeback Player of the Year	
    2359,	// Home To Win a Set	
    2360,	// Away To Win a Set	
    2361,	// Young Player of the Year	
    2362,	// League Winner Without a Team	
    2363,	// Winning Manufacturer	
    2364,	// Under/Over 1st serve % -  Away Team	
    2365,	// Under/Over 1st serve % -  Home Team	
    2366,	// Double Result - 1st Period\Match Without Draw	4	{"Id":95035035410507020,"Name":"1/2","Line":null,"BaseLine":null,"Status":2,"StartPrice":"1.0","Price":"21.0","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T06:58:39.202Z","ParticipantId":null}
    2367,	// Next Score Type - With Line	
    2368,	// Team To Make Next Score - With Line	
    2372,	// 1X2 Yellow Cards - 2nd Period 	
    2373,	// Double Chance Yellow Cards - 2nd Period 	
    2374,	// Half With Most Yellow Cards	
    2375,	// Under/Over Fouls 2nd Period - Home Team 	
    2376,	// Under/Over Fouls 2nd Period - Away Team 	
    2377,	// Under/Over Shots on Target Away Team 2nd Period	
    2378,	// Under/Over Shots 2nd Period - Home Team	
    2379,	// Under/Over Shots 2nd Period - Away Team	
    2380,	// Under/Over Throw-Ins 2nd Period - Home Team 	
    2381,	// Under/Over Throw-Ins 2nd Period - Away Team 	
    2382,	// Group Round Betting 	
    2383,	// 1st Period - Most Clutches Won	
    2384,	// 2nd Period - Most Clutches Won	
    2385,	// 3rd Period - Most Clutches Won	
    2386,	// 4th Period - Most Clutches Won	
    2387,	// 5th Period - Most Clutches Won	
    2388,	// 1st Period - 1st Half - Correct Score	
    2389,	// Asian Handicap - 1st Period - 1st Half 	
    2390,	// 2nd Period - 1st Half - Correct Score	
    2391,	// Asian Handicap - 2nd Period - 1st Half 	
    2392,	// 3rd Period - 1st Half - Correct Score	
    2393,	// Asian Handicap - 3rd Period - 1st Half 	
    2394,	// 4th Period - 1st Half - Correct Score	
    2395,	// Asian Handicap - 4th Period - 1st Half 	
    2396,	// 5th Period - 1st Half - Correct Score	
    2397,	// Asian Handicap - 5th Period - 1st Half 	
    2398,	// Fight Outcome Inc. Submission 	
    2399,	// Under/Over Pitcher Outs	
    2400,	// Under/Over Player Passing Yards	
    2401,	// Under/Over Player Touchdown Receptions	
    2402,	// A Run in the 1st Inning	
    2403,	// Next Score Type With Line	
    2404,	// Under/Over Rounds - 4th Period	
    2405,	// Under/Over Rounds - 5th Period	
    2406,	// 1X2 Penalty Time 1st period	
    2407,	// 1X2 Powerplay Goals 1st Period	
    2408,	// Asian Handicap Puck Line - 1st Period 	
    2409,	// Asian Handicap Puck Line - 2nd Period 	
    2410,	// Asian Handicap Puck Line - 3rd Period 	
    2411,	// Asian Handicap Puck Line Including Overtime	
    2412,	// To Score In Every Period	
    2413,	// First Scoring Play - 2nd Half	
    2414,	// Team to Score last - 1st half	
    2415,	// Both Teams to score Touchdown in Each Half	
    2416,	// Both Teams to score 2+ Touchdowns in Each Half	
    2417,	// Both Teams to score 3+ Touchdowns in Each Half	
    2418,	// Both Teams to score 4+ Touchdowns in Each Half	
    2419,	// First to take down 1st Barracks	
    2420,	// 1st Period - Most First Kills	
    2421,	// 2nd Period - Most First Kills	
    2422,	// 3rd Period - Most First Kills	
    2424,	// 1st Drive Result	
    2425,	// 2nd Drive Result	
    2426,	// 3rd Drive Result	
    2427,	// Double Chance - Yes\No	
    2430,	// Under/Over Bombs Plants 1st Period 	
    2431,	// Under/Over Bombs Plants 2nd Period	
    2432,	// Under/Over Bombs Plants 3rd Period	
    2433,	// Under/Over Bombs defuse 1st Period 	
    2434,	// Under/Over Bombs Defuse 2nd Period 	
    2435,	// Under/Over Bombs Defuse 3rd Period 	
    2436,	// Win Inside Distance -12	
    2437,	// Fight Wins in Distance	
    2438,	// 2nd Period - 1st Half Winner 	
    2439,	// Under/Over Bombs Defuse 1st Period - 1st Half	
    2440,	// 1st Period - 1st Half Winner	
    2441,	// 3rd Period - 1st Half Winner	
    2442,	// Under/Over Bombs Plants 1st Period  - 1st Half	
    2443,	// Under/Over Bombs Plants 2nd Period - 1st Half	
    2444,	// Under/Over Bombs Plants 3rd Period  - 1st Half	
    2445,	// Under/Over Bombs Defuse 1st Period  - 1st Half	
    2446,	// Under/Over Bombs Defuse 2nd Period  - 1st Half	
    2447,	// Under/Over Bombs Defuse 3rd Period  - 1st Half	
    2448,	// Double Chance Corners - 2nd Period 	
    2449,	// Under/Over Player Defensive Assists	
    2450,	// Under/Over Player Defensive Tackles	
    2451,	// 2nd Round 3 Balls	
    2452,	// 3rd Round 3 Balls	
    2453,	// 4th Round 3 Balls	
    2456,	// To Win Outright	
    2457,	// Towers Handicap - 1st Period	
    2458,	// Towers Handicap - 2nd Period	
    2459,	// Towers Handicap - 3rd Period	
    2460,	// Roshan Handicap - 1st Period	
    2461,	// Roshan Handicap - 2nd Period	
    2462,	// Roshan Handicap - 3rd Period	
    2463,	// Aegis Steal - 1st period	
    2464,	// Aegis Steal - 2nd period	
    2465,	// Aegis Steal - 3rd period	
    2466,	// Under/Over Roshans - 1st period	
    2467,	// Under/Over Roshans - 2nd period	
    2468,	// Under/Over Roshans - 3rd period	
    2469,	// Under/Over Roshans - 4th period	
    2470,	// Towers Handicap - 4th Period	
    2471,	// Roshan Handicap - 4th Period	
    2472,	// Aegis Steal - 4th period	
    2473,	// Under/Over Barraks - 1st Period	
    2474,	// Under/Over Barraks - 2nd Period	
    2475,	// Under/Over Barraks - 3rd Period	
    2476,	// Under/Over Barraks - 4th Period	
    2477,	// Race To Kills - 4th Period	
    2478,	// Home Team to win At Least 1 Period	
    2479,	// Away Team to win At Least 1 Period	
    2480,	// Both teams to Destroy a Barraks - 1st Period 	
    2481,	// Both teams to Destroy a Barraks - 2nd Period 	
    2482,	// Both teams to Destroy a Barraks - 3rd Period 	
    2483,	// Both teams to Destroy a Barraks - 4th Period	
    2484,	// Both teams to Slay a Roshan - 1st Period 	
    2485,	// Both teams to Slay a Roshan - 2nd  Period 	
    2486,	// Both teams to Slay a Roshan - 3rd Period 	
    2487,	// Both teams to Slay a Roshan - 4th Period 	
    2488,	// Top Bowler 	
    2489,	// Top Batter	
    2490,	// Top Team Bowler	
    2491,	// Top Team Batsman	
    2492,	// Team with highest innings score	
    2493,	// Under\Over Player Longest Rushing Attempt	
    2494,	// National League Winner 	
    2495,	// American League Winner	
    2496,	// Player to Score at least 1 Point - Including Overtime	
    2497,	// Player to Score at least 2 Point - Including Overtime	
    2498,	// Player to Score at least 3 Point - Including Overtime	
    2499,	// 1X2 and Double Chance - 1st Period	
    2500,	// NCAAF FCS - Outright Winner	
    2501,	// NCAAF FBS - Outright Winner	
    2502,	// Top Goaltender Player	
    2503,	// President's Trophy Winner	
    2504,	// Jack Adams Award Winner	
    2505,	// Exact Number Of Goals 	
    2506,	// Number of Field Goals	
    2508,	// When the fight ends	
    2510,	// Winning Conference - East / West	
    2511,	// Winning Conference - NFC / AFC	
    2512,	// Hart Trophy Winner - MVP	
    2513,	// Vezina Trophy Winner - Best Goalkeeper 	
    2515,	// James Norris Memorial Trophy Winner - Best Defensive Player	
    2516,	// Calder Memorial Trophy Winner - Best Season Rookie	
    2517,	// Maurice Rocket Richard Trophy Winner - Top GoalScorer	
    2518,	// Jack Adams Award Winner - Best Coach	
    2519,	// To Win the Division	
    2520,	// Winning Nation	
    2521,	// Winning Division	
    2522,	// Atlantic Coast Conference Winner	
    2523,	// Big 12 Conference Winner	
    2524,	// Pacific 12 Conference Winner	
    2525,	// Big East Conference Winner	
    2526,	// Big 10 Conference Winner	
    2527,	// Southeastern Conference Winner	
    2528,	// AFC Championship Winner	
    2529,	// NFC Championship Winner	
    2530,	// To Make The Final Four	
    2531,	// To Win Conference - NBA Western Conference	
    2532,	// John R. Wooden Award	
    2533,	// To Win Conference - Eastern Conference	
    2534,	// To Win Conference - Western Conference	
    2535,	// Race To 5 Kills - 1st Period	
    2536,	// Race To 10 Kills - 1st Period	
    2537,	// Race To 15 Kills - 1st Period 	
    2538,	// Race To 20 Kills - 1st Period 	
    2539,	// Under/Over Player Double Double 	
    2540,	// Points Scored In The First 7:30 Minutes?	
    2541,	// Under/Over Touchdowns Scored - 2nd Half	
    2542,	// Under/Over Home Team Touchdowns - 2nd Half	
    2543,	// Under/Over Away Team Touchdowns - 2nd Half	
    2544,	// Both Teams to Score 10 Points 	
    2545,	// Both Teams to Score 15 Points	
    2546,	// Both Teams to Score 20 Points 	
    2547,	// Both Teams to Score 25 Points	
    2548,	// Both Teams to Score 30 Points	
    2549,	// Both Teams to Score 35 Points	
    2550,	// Both Teams to Score 40 Points	
    2551,	// First Scoring Play by Home team	
    2552,	// First Scoring Play by Away team	
    2553,	// Finish Exactly 2nd Place	
    2554,	// Finish Exactly 3rd Place	
    2555,	// Finish Exactly 4th Place	
    2556,	// Away Team Points Range	
    2557,	// Home Team Points Range	
    2558,	// Home Team - Goal Range (0-2+) 	
    2559,	// Home Team - Goal Range (0-3+) 	
    2560,	// Away Team - Goal Range (0-2+)	
    2561,	// Away Team - Goal Range (0-3+)	
    2562,	// 1st Period - Goal Range (0-2+) 	
    2563,	// 1st Period - Goal Range (0-3+) 	
    2564,	// 2nd Period - Goal Range (0-2+) 	
    2565,	// 2nd Period - Goal Range (0-3+) 	
    2566,	// 1st Period - Extra Points?	
    2567,	// Test	
    2568,	// Under/Over Centuries	
    2569,	// Points Range 1st Half - Home team 	
    2570,	// Points Range 1st Half - Away team 	
    2571,	// Points Range - Halftime	
    2572,	// Odd/Even Halftime - Home Team	
    2573,	// Odd/Even Halftime - Away Team	
    2574,	// 1st Period - 1st To Slay Rift Herald	
    2575,	// 1st Period - First Dragon to Spawn	
    2576,	// 2nd Period - First Dragon to Spawn	
    2577,	// 3rd Period - First Dragon to Spawn	
    2578,	// 1st Period 1X2 And Both Teams To Score	
    2579,	// Number of Touchdowns - 1st Half 	
    2580,	// Number of Touchdowns 11-Way	
    2581,	// Under/Over Home Team - Touchdowns 2nd Half Including OT	
    2582,	// Under/Over Away Team - Touchdowns 2nd Half Including OT	
    2583,	// Under/Over With Score	
    2584,	// Mid-American Conference Winner	
    2585,	// Mountain West Conference Winner	
    2586,	// Big West Conference Winner	
    2587,	// Southwestern Athletic Conference Winner	
    2588,	// Conference USA Winner	
    2589,	// Ivy League Conference Winner	
    2590,	// Western Athletic Conference Winner	
    2591,	// Metro Atlantic Athletic Conference Winner	
    2592,	// Mid-Eastern Athletic Conference Winner 	
    2593,	// Big Sky Conference Winner	
    2594,	// West Coast Conference Winner	
    2595,	// Southland Conference Winner	
    2596,	// Horizon League Conference Winner	
    2597,	// American Athletic Conference Winner	
    2598,	// America East Conference Winner	
    2599,	// Under/Over With Score - 1st Peiod 	
    2600,	// Atlantic 10 Conference Winner	
    2601,	// Under / & Over - 1st Period	
    2602,	// Under / & Over - 2nd Period	
    2603,	// Under / & Over - 3rd Period	
    2604,	// Under / & Over - 4th Period	
    2605,	// Under / & Over - 5th Period	
    2606,	// Under / & Over - 6th Period	
    2607,	// Under / & Over - 7th Period	
    2608,	// Under / & Over - 8th Period	
    2609,	// Under / & Over - 9th Period	
    2610,	// Under / & Over - 10th Period	
    2611,	// Under / & Over - 11th Period	
    2612,	// Under / & Over - 12th Period	
    2613,	// Under / & Over - 13th Period	
    2614,	// Under / & Over - 14th Period	
    2615,	// Under / & Over - 15th Period	
    2616,	// Under / & Over - 16th Period	
    2617,	// Under / & Over - 17th Period	
    2618,	// Under / & Over - 18th Period	
    2619,	// Under / & Over - 19th Period	
    2620,	// Under / & Over - 20th Period	
    2621,	// Under / & Over - 21th Period	
    2622,	// Under / & Over - 22th Period	
    2623,	// Under / & Over - 23th Period	
    2624,	// American League West - Winner	
    2625,	// American League Central - Winner	
    2626,	// American League East - Winner	
    2627,	// National League Central - Winner	
    2628,	// National League East - Winner	
    2629,	// National League West - Winner	
    2630,	// Antepost	
    2631,	// Season Match Bets	
    2632,	// No Runner No Bet	
    2637,	// Top Golfer by Category	
    2638,	// Podium	
    2639,	// Stage 4	
    2640,	// Stage 5	
    2641,	// Stage 6	
    2642,	// Stage 7	
    2643,	// Stage 8	
    2644,	// 1st 5 Innings Under/Over - Home Team	
    2645,	// 1st 5 Innings Under/Over - Away Team	
    2646,	// To Reach Semi Finals	
    2647,	// Runner Up 	
    2648,	// Winning Confederation	
    2649,	// First Time Winner?	
    2650,	// Under/Over Inhibitors - 3rd Period 	
    2651,	//  Most Outstanding Player	
    2652,	// Match Centuries - Home Team	
    2653,	// Enhanced Winner	
    2654,	// Top 30 Finish	
    2655,	// Top 40 Finish	
    2656,	// To Make the Cut 	
    2657,	// Group A Betting	
    2658,	// Group B Betting	
    2659,	// Group C Betting	
    2660,	// Group D Betting	
    2661,	// Group E Betting	
    2662,	// Group F Betting	
    2663,	// Group G Betting	
    2664,	// 2nd Period - 1st To Slay Rift Herald	
    2665,	// 3rd Period - 1st To Slay Rift Herald	
    2666,	// To be in Finals Squad (Outright)	
    2667,	// Defensive Players Drafted in 1st Round	
    2668,	// Race Match-Ups	
    2669,	// Stage 1 Match-Ups	
    2670,	// Stage 2 Match-Ups	
    2671,	// Under/Over Centuries - Home Team	
    2672,	// Under/Over Centuries - Away Team	
    2673,	// AP NFL Offensive Player of The Year	
    2674,	// Driver Lap 10 Leader	
    2675,	// Corners Handicap With Score	
    2676,	// Match Centuries - Away Team	
    2677,	// Next 1 minute - Throw-In	
    2678,	// Next 1 minute - Free-Kick	
    2679,	// Next 1 minute - Card	
    2680,	// Next 1 minute - Corner	
    2681,	// Next 1 minute - Goal	
    2682,	// Next 5 minute - Penalty	
    2683,	// Next 5 minute - Corner	
    2684,	// Next 5 minute - Goal	
    2685,	// What will happen First? - Next 1 Minute	
    2686,	// What will happen First? - Next 5 Minute	
    2687,	// Next 1 minute - Goal-Kick	
    2688,	// Game Winner, Set	
    2689,	// Under/Over Player Points - High	
    2690,	// Under/Over Player Points - Low	
    2691,	// Under/Over Pitcher Hits	
    2692,	// Under/Over Player RBIs	
    2694,	// Winning Margin - Teams With Any Other Score, Inc. OT	
    2695,	// Will There Be a Deciding Period?	
    2696,	// Northwest Division Winner	
    2697,	// Atlantic Division Winner	
    2698,	// Pacific Division Winner	
    2699,	// Central Division Winner	
    2700,	// Southeast Division Winner	
    2701,	// Southwest Division Winner	
    2702,	// NFC North - Division Winner	
    2703,	// NFC East - Division Winner	
    2704,	// NFC West - Division Winner	
    2705,	// NFC South - Division Winner	
    2706,	// AFC South - Division Winner	
    2707,	// AFC North - Division Winner	
    2708,	// AFC West - Division Winner	
    2709,	// AFC East - Division Winner	
    2721,	// test1	
    2722,	// test2	
    2723,	// test3	
    2732,	// Asian Handicap - 1st Period	18	{"Id":67504949810529120,"Name":"1","Line":"-1.25","BaseLine":"-1.25","Status":2,"StartPrice":"1.0","Price":"2.865","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-26T02:53:33.252Z","ParticipantId":null}
    2733,	// 12 And Under/Over - Including Overtime	
    2734,	// Under/Over Player Passes	
    2736,	// Under/Over Runs After Overs - Home Team	
    2737,	// Under/Over Runs After Overs - Away Team	
    2738,	// To Make Playoffs - Eastern Conference	
    2739,	// To Make Playoffs - Western Conference	
    2740,	// First Player to Score Basket	
    2741,	// Team With Highest Scoring Period - 3-Way	
    2742,	// Correct Score by Any Player - 1st Period	
    2743,	// Correct Score by Any Player - 2nd Period	
    2744,	// Correct Score by Any Player - 3rd Period	
    2745,	// Correct Score by Any Player - 4th Period	
    2746,	// Correct Score by Any Player - 5th Period	
    2747,	// 2nd Period - Multiple Correct Score	
    2748,	// Winner of Next Two Games	
    2749,	// Next Two Games – Either Game to Deuce?	
    2750,	// Corners Handicap - 1st Period With Score	
    156,	    // Under/Over 2nd Period - Away Team	6	{"Id":52893392410507020,"Name":"Under","Line":"6.5","BaseLine":"6.5","Status":2,"StartPrice":"1.0","Price":"1.47","LayPrice":null,"PriceVolume":null,"LayPriceVolume":null,"Settlement":null,"ProviderBetId":null,"LastUpdate":"2023-04-24T07:23:49.348Z","ParticipantId":null}

]
//------------------------------------------------------------------------------

export let MainMarket = {
    name: "mainMarket",
    name_kor: "메인 마켓",
    data: MainMarketData
}

export const HalfData = [
    4, //전반전 및 풀타임
    21, //오버언더 전반전
    25, //더블찬스 [전반전] 
    41, //승무패 전반전
    53, //핸디캡 [전반전]  
    57, //마지막득점팀 [전반전]
    61, //유럽 핸디캡 [전반전]
    62, //홀짝 [전반전]
    63, //승패 [전반전]
    64, //핸디캡 전반전
    77, //언더오버 [전반전]
    113, //양팀 모두득점 [전반전]
    129, //언더오버 - 코너 [전반전]
    134, //득점수 [전반전]
    145, //홈팀 득점수 [전반전]
    146, //원정팀 득점수 [전반전]
    215, //원정팀 득점 [전반전]
    216, //홈팀 득점 [전반전]
    282, //승무패 [전반전]
    354, //언더오버 [전반전] <홈팀>"
    355, //언더오버 [전반전] <원정팀> 
    390, //전반전 및 풀타임 [연장포함]
    430, //정확한 언더오버 [전반전]
    92, //첫 득점팀 [후반전]
    147, //원정팀 득점수 [후반전]
    148, //홈팀 득점수 [후반전]
    151, //더블찬스 [후반전]
    211, //양팀 모두득점 [후반전]
    212, //양팀 모두득점 [전반후반]
    213, //양팀 모두득점 [전반후반]
    216, //원정팀 득점 [후반전]
    219, //홈팀 득점 [후반전]
    212, //양팀 모두득점 [전반후반]
    213, //양팀 모두득점 [전반후반]
    216, //원정팀 득점 [후반전]
    // 219, //홈팀 득점 [후반전]
    283, //홈팀 득점 [후반전]
    284, //승무패 [후반전]
    285, //홀짝 [후반전]
    286, //승패 [후반전]
    431, //정확한 언더오버 [후반전]
]

export const Half = {
    name: "1st Half/2nd Half",
    name_kor: "전반전/후반전",
    data: HalfData
}

export const PeriodData = [
    9, //정확한스코어 [1 피리어드]
    42, //승무패 [2 피리어드]
    43, //승무패 [3 피리어드]
    44, //승무패 [4 피리어드]
    45, //언더오버 [2 피리어드]
    46, //언더오버 [3 피리어드]
    47, //언더오버 [4 피리어드]
    48, //언더오버 [5 피리어드]
    49, //승무패 [5 피리어드]
    55, //첫득점팀 [1 피리어드]
    65, //핸디캡 [2 피리어드]
    66, //핸디캡 [3 피리어드]
    67, //핸디캡 [4 피리어드]
    68, //핸디캡 [5 피리어드]
    70, //최고득점 피리어드
    72, //홀짝 [1 피리어드]
    73, //홀짝 [2 피리어드]
    74, //홀짝 [3 피리어드]
    75, //홀짝 [4 피리어드]
    76, //홀짝 [5 피리어드]
    100, //정확한스코어 [2 피리어드]
    153, //언더오버 [1 피리어드] <홈팀>
    154, //언더오버 [2 피리어드] <홈팀>
    155, //언더오버 [1 피리어드] <원정팀>
    156, //언더오버 [2 피리어드] <원정팀>
    194, //홈팀 무득점 [1 피리어드]
    195, //홈팀 무득점 [2 피리어드]
    196, //원정팀 무득점 [1 피리어드]
    197, //원정팀 무득점 [2 피리어드]
    203, //승패 [2 Peroid]
    204, //승패 [3 피리어드]
    205, //승패 [4 피리어드]
    206, //승패 [5 피리어드]
    217, //정확한스코어 [3 피리어드]
    222, //언더오버 [1 피리어드] <홈팀>
    223, //언더오버 [3 피리어드] <홈팀>
    224, //더블찬스 [3 피리어드]
    225, //더블찬스 [4 피리어드]
    242, //홀짝 [1 피리어드] <홈팀>
    243, //홀짝 [1 피리어드] <원정팀>
    287, //언더오버 [4 피리어드] <홈팀>
    288, //언더오버 [4 피리어드] <원정팀>
    289, //홀짝 [2 피리어드] <홈팀>
    290, //홀짝 [3 피리어드] <홈팀>
    291, //홀짝 [4 피리어드] <홈팀>
    292, //홀짝 [2 피리어드] <원정팀>
    293, //홀짝 [3 피리어드] <원정팀>
    294, //홀짝 [4 피리어드] <원정팀>
    317, //정확한 언더오버 [1 피리어드]
    318, //정확한 언더오버 [2 피리어드]
    319, //정확한 언더오버 [3 피리어드]
    320, //정확한 언더오버 [4 피리어드]
    321, //정확한 언더오버 [1 피리어드]
    350, //홀짝 [6 피리어드]
    351, //홀짝 [7 피리어드]
    352, //언더오버 [6 피리어드]
    353, //언더오버 [7 피리어드]
    436, //언더오버 [8 피리어드]
    437, //언더오버 [9 피리어드]
    445, //승패 [6 피리어드]
    446, //승패 [7 피리어드]
    447, //핸디캡 [6 피리어드]
    448, //핸디캡 [7 피리어드]
    449, //핸디캡 [8 피리어드]
    450, //핸디캡 [9 피리어드]
    451, //승패 [8 피리어드]
    452, //승패 [9 피리어드]
    456, //더블찬스 [1 피리어드]
    457, //더블찬스 [2 피리어드]
]

export const Period = {
    name: "Period",
    name_kor: "피리어드별",
    data: PeriodData
}

export const QuarterData = [
    459, //홈팀 전체 쿼터 득점
    460, //원정팀 전체 쿼터 득점
    1813, //Away Team to Win Every Quarter
    1814, //Home Team to Win Every Quarter
    1816, //To Win Quarter
    1857, //Under/Over Highest Scoring Quarter
    1858, //Under/Over Lowest Scoring Quarter
    1875, //Winning Quarter - Tennis Outright
    1938, //To Reach the Quarter Finals
    2252, //To Win Quarter - 1st Quarter (Outright)
    2253, //To Win Quarter - 2nd Quarter (Outright)
    2254, //To Win Quarter - 3rd Quarter (Outright)
    2255, //To Win Quarter - 4th Quarter (Outright)
]

export const Quarter = {
    name: "quarter",
    name_kor: "쿼터별",
    data: QuarterData
}

export const InningData =[
    235, //승패5이닝
    236, //오버언더 5이닝
    237, //득점발생 [1이닝]
    281, //핸디캡 5이닝
    475, //Under/Over Runs In Over - Home Team 1st Inning
    476, //Under/Over Runs In Over - Away Team 1st Inning
    477, //Under/Over Runs In Over - Home Team 2nd Inning
    478, //Under/Over Runs In Over - Away Team 2nd Inning
    479, //Odd/Even Runs In Over - Home Team 1st Inning
    480, //Odd/Even Runs In Over - Away Team 1st Inning
    481, //Odd/Even Runs In Over - Home Team 2nd Inning
    482, //Odd/Even Runs In Over - Away Team 2nd Inning
    483, //Will Home Team Get A Wicket in Over - 1st Inning?
    484, //Will Away Team Get A Wicket in Over - 1st Inning?
    485, //Will Home Team Get A Wicket in Over - 2nd Inning?
    486, //Will Away Team Get A Wicket in Over - 2nd Inning?
    491, //Will there be a home team hit in 5th inning?
    500, //Will there be a away team hit in 5th inning?
    505, //A Run Scored - home team 1st inning
    524, //1st 7 Innings Winner
    525, //1st 7 Innings Under/Over
    526, //1st 7 Innings Asian Handicap
    848, //Under/Over 3rd Inning
    849, //Under/Over 3rd Inning
    850, //Under/Over 3rd Inning
]

export const Inning = {
    name: "Inning",
    name_kor: "이닝별",
    data: InningData
}

export const SetData = [
    90, //5세트 발생
    164, //타이 브레이크 발생 [1세트]
    165, //오버언더 세트
    175, //타이 브레이크 발생 [2세트]
    176, //타이 브레이크 발생 [3세트]
    177, //타이 브레이크 발생 [4세트]
    178, //타이 브레이크 발생 [5세트]
    202, //타이 브레이크 발생 [2세트]타이 브레이크 발생 [2세트]
    866, //핸디캡 세트
]

export const Set = {
    name: "Set",
    name_kor: "세트별",
    data: SetData
}

export const ExtraData = [
    6, //정확한스코어
    11, //코너 합계
    12, //파울 합계 
    13, //유럽핸디캡
    149, //홈팀 득점수 
    150, //원정팀 득점수
    17, //량팀 모두 득점
    22, //원정팀 득점
    23, //홈팀 득점
    56, //마지막 득점팀
]

export const Extra = {
    name: "extra",
    name_kor: "추가옵션",
    data: ExtraData
}

export const esportsmain = MainMarketData.concat(PeriodData, QuarterData, InningData, SetData, HalfData, ExtraData);

export const esports1game = [
    202, // "1st Period Winner Home/Away   승패 1세트 
    541, // Winning Margin - 1st Period
    634, // Odd/Even Rounds 1st Period 
    647, // Will There Be Overtime? - 1st Period
    650, // 16th Round Winner - 1st Period
    653, // 1st Round Winner - 1st Period
    692, // "Odd/Even Kills - 1st Period
    666, // "1st Period - 1st Roshan
    669, // 1st Period - 1st Blood
    672, // 1st Period - 1st Tower 
    989, // Under/Over Kills - 1st Period
    653, // 1st Round Winner - 1st Period 
    1120, // Under/Over Rounds - 1st Period 
    1149, // "Asian Handicap Kills - 1st Period
    1619, // 1st Period - Halftime Winner Home/Away
    1620, // 1st Period - Halftime Asian Handicap 
]

export const esports2game = [
    203, // "2nd Period Winner Home/Away"    승패 [2 Peroid] 
    651, // 16th Round Winner - 2nd Period 
    654, // 1st Round Winner - 2nd Period
    667, // "2nd Period - 1st Roshan
    670, // 2nd Period - 1st Blood
    673, // 2nd Period - 1st Tower
    693, // "Odd/Even Kills - 2nd Period
    990, // Under/Over Kills - 2nd Period
    1150, // "Asian Handicap Kills - 2nd Period
    1121,	// Under/Over Rounds - 2nd Period	
]

export const esports3game = [
    204, // 승패 [3 피리어드]
    205, // 승패 [4 피리어드] 
    652,	    // 16th Round Winner - 3rd Period	
    668,	    // 3rd Period - 1st Roshan	
    674,	    // 3rd Period - 1st Tower	
    991,	    // Under/Over Kills - 3rd Period	
    1122,	// Under/Over Rounds - 3rd Period	
    1151,	// Asian Handicap Kills - 3rd Period	
]

export const EsportsMainMarkets = [
    esportsmain,
    // esports1game,
    // esports2game,
    // esports3game
]




export let AllMarket = {
    name: "allMarket",
    name_kor: "전체",
    // data: MainMarketData.concat(HalfData, PeriodData, QuarterData, InningData, SetData, ExtraData)
    data: []
}


export const EsportsMain = {
    name: "mainMarket",
    name_kor: "메인 마켓",
    data: esportsmain   
}

export const Dota1 = {
    name: "game1",
    name_kor: "1게임",
    data: esports1game
}

export const Dota2 = {
    name: "game2",
    name_kor: "2게임",
    data: esports2game
}

export const Dota3 = {
    name: "game3",
    name_kor: "3게임",
    data: esports3game
}


export const lsportsDotaMarkets = [
    AllMarket,
    EsportsMain,
    Dota1,
    Dota2,
    Dota3
]


export const lsportsLeagueOfLegendsaMarkets = [
    AllMarket,
    EsportsMain,
    Dota1,
]




export const lsportssoccerProvidedMarketIds = [
    AllMarket,
    MainMarket = {
        name: "mainMarket",
        name_kor: "메인 마켓",
        data: MainMarketData.concat(PeriodData, QuarterData, InningData, SetData)
    },
    Half,
    Extra,
]

export const lsportsIceHockeylProvidedMarketIds = [

    AllMarket,
    MainMarket = {
        name: "mainMarket",
        name_kor: "메인 마켓",
        data: MainMarketData.concat(PeriodData, QuarterData, InningData, SetData, HalfData, ExtraData)
    },
    Period,
    Extra,
]

export const lsportsbasketballProvidedMarketIds = [
    AllMarket,
    MainMarket = {
        name: "mainMarket",
        name_kor: "메인 마켓",
        data: MainMarketData.concat(PeriodData, PeriodData, InningData, SetData, HalfData, ExtraData)
    },
    Quarter,
]

export const lsportsfootballProvidedMarketIds = [
    AllMarket,
    MainMarket = {
        name: "mainMarket",
        name_kor: "메인 마켓",
        data: MainMarketData.concat(PeriodData, PeriodData, InningData, SetData, HalfData)
    },
    Quarter,
    Extra
]

export const lsportsbaseballProvidedMarketIds = [
    AllMarket,
    MainMarket = {
        name: "mainMarket",
        name_kor: "메인 마켓",
        data: MainMarketData.concat(PeriodData, PeriodData, InningData, SetData, HalfData)
    },
    Quarter,
    Extra
]

export const lsportsvolleyballProvidedMarketIds = [
    AllMarket,
    MainMarket = {
        name: "mainMarket",
        name_kor: "메인 마켓",
        data: MainMarketData.concat(PeriodData, PeriodData, QuarterData, InningData, HalfData)
    },
    Set,
    Extra
]

export const lsportsMMAProvidedMarketIds = [
    AllMarket,
    MainMarket = {
        name: "mainMarket",
        name_kor: "메인 마켓",
        data: MainMarketData.concat(PeriodData, PeriodData, QuarterData, InningData, SetData, HalfData, ExtraData)
    },
]

export const lsportsDefaultProvidedMarketIds = [
    AllMarket,
    MainMarket = {
        name: "mainMarket",
        name_kor: "메인 마켓",
        data: MainMarketData.concat(PeriodData, PeriodData, QuarterData, InningData, SetData, HalfData, ExtraData, HalfData)
    },
    Extra
]

export const lsportsDefaultEsportsMarketIds = [
    AllMarket,
    MainMarket = {
        name: "mainMarket",
        name_kor: "메인 마켓",
        data: esportsmain.concat(esports1game, esports2game, esports3game) 
    },
]



// WEBPACK FOOTER //
// ./src/utils/lsportsGroup.js